import { ApiCommonServicesService } from './../../services/api-common-services.service';
import { ConstantsService } from './../../services/constants.service';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import 'jquery';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import * as ClipboardJS from 'clipboard';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { invoiceFilter } from "../../common-functions";

declare var $: any;
import * as saveAs from 'file-saver';
import * as moment from 'moment';
import SignaturePad from 'signature_pad';
import SwiperCore, { Navigation, EffectCoverflow, Pagination, SwiperOptions, Swiper, Virtual } from "swiper";
SwiperCore.use([Navigation, Pagination, EffectCoverflow]);
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExcelService } from 'src/app/services/excel.service';
import { moments } from '../manage-clients/manage-clients.component';
import { ToastrService } from 'ngx-toastr';
import { PDFDocument, } from 'pdf-lib';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { HeaderComponent } from 'src/app/layouts/header/header.component';
import { LoaderService } from 'src/app/loader.service';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonAlgoService } from 'src/app/services/common-algo.service';
import { CommonPatternsService } from 'src/app/common-patterns.service';
// import { DomSanitizer } from '@angular/platform-browser';
import { LoggerService } from 'src/app/services/logger.service';
import { Store } from '@ngrx/store';
import { loadCorporateData, loadCorporateDataSuccess } from 'src/app/state/actions/corporates.actions';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { selectCorporateData, selectCorporateError, selectCorporateLoading } from 'src/app/state/selectors/corporates.selector';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { selectCorporateSignupConfigData } from 'src/app/state/selectors/corporateSignupConfig.selector';
import { loadCorporateSignupConfigData } from 'src/app/state/actions/corporateSignupConfig.actions';
import { AuthorizeNetService } from 'src/app/services/authorize-net.service';

declare global {
  interface JQuery {
    (selector: string): JQuery;
    gaugeMeter(any): JQuery;
    updateGaugeMeter(any): JQuery;
  }
}
@Component({
  selector: 'app-corporate-dashboard',
  templateUrl: './corporate-dashboard.component.html',
  styleUrls: ['./corporate-dashboard.component.css'],
  providers: [DatePipe, HeaderComponent],
})
export class CorporateDashboardComponent implements OnInit {
  loginame: any;
  role: any;
  userName: any;
  email: any;
  advisorsData: any;
  // advisorsData: any = [
  //   {
  //     "name": "saikumar",
  //     "phone": "23123123123123",
  //     "email": "sadadfi@aitestpro.com"
  //   },
  //   {
  //     "name": "adfadfa",
  //     "phone": "adcasdcasdc",
  //     "email": "dscad@aitestpro.com"
  //   }
  // ];
  invoicesArr: any = [];
  customerFinalInvoices: Array<any> = [];
  invoiceMonthsList: Array<any> = [];
  pending: any;
  enrolled: any;
  changeToPadLabel: any = 'Change to PAD';
  updateCCLabel: any = 'Update Credit Card';
  paymentMethodSelect: boolean;
  fusbillinfocaptchavalue: string;
  publicapikey: string;
  paymentsuccessuri: string;
  customerid: any;
  paymentUri: string;
  paymentfirstname: string;
  paymentlastname: string;
  paymentemail: string;
  uploadedVoidName: any;
  signaturecheckvalue1: boolean;
  generatePADaggrement: any | number;
  voidcheckfile: any;
  voidCheckFileType: any;
  isImage: boolean;
  emailAlreadyexist: boolean = false;
  NoWaithingPeridos: boolean = false;
  threeMonths: boolean = false;
  SixMonths: boolean = false;
  voidPreviewButtonVisible: boolean;
  // roeUrl: any='';
  //  roeUrl: SafeResourceUrl | null = null;
  isPdfLoading: boolean = false;
  padUrl: any;
  clickCount: number = 1;
  groupContacts: Array<any> = [];
  corporateTierPlans: Array<any> = [];
  // roePadHeader: any;
  // policyStartDate: string;
  imagedisplayvoid: any;
  verifydBankDetails: { name: any; address: any; city: any; province: any; postalCode: string; };
  // apt: any;
  // streetAddress2: any;
  // city: any;
  Province: any;
  // postalCode: any;
  generatePADaggrementres: any;
  selectedPaymentMethod: any;
  isBankDetailsValid: boolean;
  bankDetailsNames: string;
  signImage: any;
  bankverifyDetails: any;
  Amendment: any = 'None';
  dateFormat = 'MM-DD-YYYY';
  invalidcreditcard: boolean = false;
  showexpiryyearerror: boolean;
  futureexpiredate: boolean;
  showexpirymontherror: boolean;
  useCreditCard: boolean = false
  padPayment: boolean = false;
  achDetails: any;
  paymentMethodHeader: any;
  employeedata: Array<any> = [];
  employeedata2: Array<any> = [];
  excelempdata: Array<any> = [];
  finalemployeekeys: Array<any> = [];
  corpId: any;
  emp: any;
  // bankId: any = "002";
  // transit: any = "00001"
  // account: any = "***1231312341243";

  bankId: any = '';
  transit: any;
  account: any;
  bankNameNdAddress: any;

  reviewPadSign: boolean = false;

  enrolldCount: any;
  invitationSentCount: any;
  invitationPendingCount: any;

  // corp info variables
  bookletUrlLink: any;
  CorpName: any;
  bulkPlans: any = [];
  showEmployeeValue: any;
  showupdatebutton: boolean = false;
  showupdatebuttonwellness: boolean = false;
  bulkPlansLevelId: any;
  public employeeList: Array<any> = [];
  @ViewChild('myFileInput') myFileInput: ElementRef;
  lengthofemployee: number;
  maxEmployeeCount: any;
  enrollmentDates: any = [];
  policyStartDate: any;
  multiSelectProviance: any[];
  defaultCountry: any = "Canada";
  configprovincereslist1: any;
  multiProvinceSelectedValues: any;
  state_id: any;
  statename: any;
  provincelistid: any;
  countryList: any;
  selectedProvinceList: any = [];
  addemployeefrom = false;
  editemployeefrom = false;
  selectedFocusVariabl: any;
  dropdownSettings = {};
  streetAddress: any;
  streetAddress2: any;
  memberCards: any;
  public show: boolean = false;
  apt: any;
  city: any;
  country: any;
  stateLabel: any = 'Province';
  province: any;
  // Province: any;
  configprovincereslist: any;
  zipCodeLabel: any = 'Postal Code';
  postalCode: any;
  postalvalue: any;
  invalidpostalcodeprivince: boolean;
  memberhealthCardurl: any;
  provincialZipcodes: any;
  selectedCountry: string;
  configprovinceres: any=[];
  provincialHealthcareUrl: any;
  address: any;
  provincesShortNames: any;
  currentROE: any;
  corporateBooklets: any = [];
  corporateMyResorces: any = [];
  dashboardMyplans: any = [];
  viweUploadButtons: boolean = true;
  fileName: any = "";
  @ViewChild("myResorceHtml", { static: false }) myResorceHtml;
  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;
  @ViewChild('videoPlayer') videoplayer: any;

  public lang: any = {};
  selectedLanguage: string;
  languageData: any
  //Payment method variables:
  paymentMethod: any;
  paymentMethodId: any;
  expire: any;
  creditCardNo: any;
  bankCode: any
  transitNumber: any;
  accountNumber: any;
  bankinformation: any;
  fullName: any;
  bankDetails = false;
  resetButton = false;

  creditcardNumber: any = "";
  cardExpiry: any = "";
  ccFirstName: any = "";
  ccLastName: any = "";
  ccDetails: any = [];
  deletedId: Array<any> = [];

  personnelInvitedToEnoll: any;
  registeredDate: any;
  approvedDate: any;
  linksentDate: any;
  generate_Invite_Link: any;
  loginLink: any;
  logo: any;
  corporateEmployeesInitialSignupWaittime: any;
  requireEmployeeName: any;
  waitTime: any;
  setUplevelofCoverage: any=false;
  setupWallet: any;
  showEmpName: any;
  @Input() MaxEmployee: any;
  @Input() MinEmployee: any;
  @Input() status: any;
  @Input() employeeWorkingProviance: any;
  selectedPlans: any;
  coveredByCompany: any = [];
  paidByEmployee: any = [];
  paidByCompany: any = [];
  signPad: any;
  @ViewChild('canvas', { static: false }) signaturePadElement: any;
  fnlnMinlengthForSheetNdinputField: number = 1;
  renewalDate: any = {};

  hicList: any = [];
  draftInvoice: any;
  selectedInvoiceIndex: any;
  selectedInvoiceUrl: any;
  nextMonthName: any;
  customSelected: boolean = false;
  year: any;


  //edit group contacts

  editadminfirstname: string = "";
  editadminlastname: string = "";
  editadminphone: string = "";
  editadminemail: string = "";
  editadminrole: string = "";
  editadminroleothers: string = "";
  editAdminContactId: string = "";

  // bookletList: any = [];

  deleteBulkemployeelist: any = [];
  selectedRow: any = [];
  deletebulkemployeecheck: any;
  uploadEmployeeExcelData: any[];
  multiSelectProviancenames: any = [];
  headcountcheck: any;
  loginEmail: any;
  singupLinkDisplay: boolean;
  uploadadminlogoimg: any;
  session: string;
  coreplantemplateValue: null;
  plansBlock1: any;
  balkPlans: any;
  plansBlock1Tiers: any;
  selectedPackagePlansInfoTier: any;
  selectedPackagePlansInfoTiername: any;
  selectedPackagePlansInfoTierBlock2: any;
  selectedPackagePlansInfoTiernameBlock2: any;
  selectedPackagePlansInfoTierBlock3: any;
  selectedPackagePlansInfoTiernameBlock3: any;
  selectedPackagesavailableTiers2: any;
  selectedPackagesassignedTiers2: any;
  selectedPackagesavailableTiers2Block2: any;
  selectedPackagesassignedTiers2Block2: any;
  selectedPackagesavailableTiers3: any;
  selectedPackagesassignedTiers3: any;
  selectedPackagesavailableTiers3Block3: any;
  selectedPackagesassignedTiers3Block3: any;
  corporateId: any;
  corporateClientId: any;
  basicInfo: boolean;
  plansInfo: boolean;
  showtierbasicplans: boolean;
  showtieradvplans: boolean;
  showconfigurebutton: boolean;
  showemptytierconfig: boolean;
  showemptywalletConfig: boolean;
  selectedPackagePlansInfoTier2: {};
  selectedPackagePlansInfoTier2Block2: {};
  selectedPackagePlansInfoTier3Block3: {};
  seelctedplanLevelTierMapping: any[];
  seelctedplanLevelTierMappingBlock2: any[];
  seelctedplanLevelTierMappingBlock3: any[];
  bulkemployeeList: any;
  upgradeplanstrue: any;
  upgradeplansselection: boolean;
  employeepurchasetrue: any;
  employeeplanpurchase: boolean;
  plancheck2Coverage: any;
  bulkplans: any;
  adminData: any;
  roeAgreementSigned: any;
  fusebillCustomerId: any;
  fusebillCustomerDataId: any;
  multiSlectProviances: any;
  aptSuite: any;
  corporationName: any;
  ParentBrokerId: any;
  benefits: any[];
  headerName: any;
  @ViewChild('equitablePopup') openequitable: any;
  @ViewChild('supportPopup') opensupport: any;
  @ViewChild('iframePopup') openiframe: any;
  unlistener: any;
  videoLink: any;
  videoTitle: any;
  showimagelogo = true;
  support_link: any;
  booklet_link: any;
  iframeLink: any = '';
  iframeTitle: any;
  uploadlogoafter: boolean;
  imagedisplay: string | ArrayBuffer;
  currentLogo: any;
  employeeList1: any[];
  employeeRoe: any;
  employeeRoeURL: any;
  
  noOfEmployees: any;
  walletConfig: any;
  paymentInfo: any;
  requireEmpName: any;
  corporateParentCustomer: any;
  anyAdminEmailClicked: boolean = false;
  anyAdminGroupEmailClicked: boolean = false;
  showMaskedMail: boolean = true;
  showMaskedAdminMail: boolean = true;
  finalEmpResult: any[];
  employeeStatusValue: any = "All";
  ccExpiryTitle: any;
  ccExpiryColor: any;

  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  corporateData$: Observable<any>;
  clientList: any = [];
  languageData$: Observable<any>;
  corporateSignupConfigData$: Observable<any>;
  corporateSignupConfigData: any = {};
  private destroy$ = new Subject<void>();
  inviteEmails: any = []
  showGenericTierLinks: any;
  genericTierLinks: any = []
  corpDetails: any = {};
  // formConfigLoading: boolean=true;
  formConfigLoading: boolean=false;
  wallet:any= {}
  corporateTiers:any=[];
  tierPlans:any=[];
  configurationEmails:any=[];
  filterInvoice: any = 'All';
  filteredInvoices: any;
  allCustomerFinalInvoices: any = [];
  filterDateSelection: any = "";
  currentYear:any;
  maxDateForPicker: Date;
  latestPaymentStatus: string|null = null;
  isReauth: boolean = false;
  isRetryPayment: boolean = false;
  customerId: any = 0;
  authorizenetCustomerId: any;
  paymentPlatform: any;
  emailUsingAnywhere: any;
  oldEditAdminEmail: any;
  existingBrokerDetails: any;

  constructor(
    private logger: LoggerService,
    private loaderservice: LoaderService,
    private headerComponent: HeaderComponent,
    private toastrService: ToastrService,
    private router: Router,
    private renderer2: Renderer2,
    private sanitizer: DomSanitizer,
    private authorizeNetService: AuthorizeNetService,
    

    private route: ActivatedRoute,
    private excelService: ExcelService, private consts: ConstantsService,
    public elementRef: ElementRef, private commonMethods: CommonAlgoService,
    private commonPatternsService: CommonPatternsService,
    private commonApiAlgo: ApiCommonServicesService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private datePipe: DatePipe,
    private apiService: ApiCommonServicesService,
    public store: Store<{ corporateData: [], languageData: [], corporateSignupConfigData: {} }>
  ) {
    this.corporateData$ = store.select(selectCorporateData);
    this.loading$ = store.select(selectCorporateLoading);
    this.error$ = store.select(selectCorporateError);
    this.languageData$ = store.select(selectLanguageData);
    this.corporateSignupConfigData$ = store.select(selectCorporateSignupConfigData);
  }
  paymentMethodForm: FormGroup;
  creditCardForm: FormGroup = new FormGroup({
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    cvv: new FormControl(''),
    recaptchaReactivepayment: new FormControl(''),
  })


  addEmployeeformList: FormGroup = new FormGroup({
    employeeId: new FormControl(''),
    employeeFirstName: new FormControl(''),
    employeeLastName: new FormControl(''),
    employeeEmail: new FormControl(''),
    employeeOccupation: new FormControl(''),
    employeeDateofhire: new FormControl(''),
    employeeDateofbirth: new FormControl(''),
    employeeGender: new FormControl(''),
    employeeCountry: new FormControl(''),
    employeeResidence: new FormControl(''),
    employeefamilyStatus: new FormControl(''),
    employeePhoneno: new FormControl(''),
    employeeTier: new FormControl(''),
    empployeeAnnualIncome: new FormControl(''),
  });

  padInformationForm: FormGroup = new FormGroup({
    bankCode: new FormControl(''),
    transit: new FormControl(''),
    accountNumber: new FormControl(''),
    padDetailsVoidUpload: new FormControl(''),
  });

  adminform: FormGroup = new FormGroup({
    adminfirstname: new FormControl(''),
    adminlastname: new FormControl(''),
    adminphone: new FormControl(''),
    adminemail: new FormControl(''),
    role: new FormControl(''),
    roleOther: new FormControl(''),
  });

  editadminform: FormGroup = new FormGroup({
    adminfirstname: new FormControl(this.editadminfirstname ?? ''),
    adminlastname: new FormControl(this.editadminlastname ?? ''),
    adminphone: new FormControl(this.editadminphone ?? ''),
    adminemail: new FormControl(this.editadminemail ?? ''),
    role: new FormControl(this.editadminrole ?? ''),
    roleOther: new FormControl(this.editadminroleothers ?? ''),
  });


  editCorporateForm: FormGroup = new FormGroup({
    brokerName: new FormControl(''),
    corporationName: new FormControl(''),
    PolicyStartDate: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    apt_suite: new FormControl(),

    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    multiSelectProviance: new FormControl(''),
    postalCode: new FormControl(''),
  });

  emailForm: FormGroup = new FormGroup({
    email: new FormControl('')
  })

  settingsform: FormGroup = new FormGroup({
    waitingPeriod: new FormControl(''),
    waitingPeriodCustom: new FormControl(''),
    waitingPeriodinitialsignup: new FormControl(''),
    paymentInfo: new FormControl(''),
    bankCode: new FormControl(''),
    BankTransit: new FormControl(''),
    accounNum: new FormControl(''),
    voidcheck: new FormControl(''),
    walletConfig: new FormControl(''),
    tierConfig: new FormControl(''),
    expectednoofEmployees: new FormControl(''),
    ShowEmployer: new FormControl(''),
    autoSelectEmp: new FormControl(''),
  });


  clientregform: FormGroup = new FormGroup({
    corporationName: new FormControl(''),
    PolicyStartDate: new FormControl(''),
    multiSelectProviance: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    apt: new FormControl(''),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    postalCode: new FormControl(''),
    corporatelogo: new FormControl(''),
  });

  clientValidators() {
    this.clientregform = this.formBuilder.group({
      corporationName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(70)]],
      PolicyStartDate: ['', [Validators.required]],
      multiSelectProviance: ['', [Validators.required]],
      streetAddress: ['', [Validators.required]],
      streetAddress2: [''],
      corporatelogo: [''],
      // apt: ['', [this.commonMethods.apt_suitecheck, Validators.maxLength(50)]],
      apt: ['', [Validators.maxLength(10)]],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      Province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, Validators.compose([postalcodeValidator])]],

    });
  }

  ngOnInit() {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Corporate Dashboard');
    },100)
    sessionStorage.setItem('adminData', '');

    this.corpId = this.route.snapshot.params['id']
    
    this.currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth();
    this.maxDateForPicker = new Date(this.currentYear, currentMonth + 1);



    this.editCorporateForm = this.formBuilder.group({
      brokerName: [''],
      corporationName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(255),
          Validators.pattern('^(?:<[^>]*$|[^<]*>$|^[^<>]*$)'),

        ],
      ],
      PolicyStartDate: [''],
      streetAddress: [''],
      streetAddress2: [''],
      apt_suite: [''],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      Province: ['', [Validators.required]],
      multiSelectProviance: ['', [Validators.required]],
      postalCode: ['', Validators.compose([postalcodeValidator])],
    })


    this.settingsform = this.formBuilder.group({
      waitingPeriod: [''],
      waitingPeriodCustom: [''],
      waitingPeriodinitialsignup: [''],
      paymentInfo: [''],
      bankCode: [''],
      BankTransit: [''],
      accounNum: [''],
      voidcheck: [''],
      walletConfig: [false],
      tierConfig: [''],
      expectednoofEmployees: [''],
      ShowEmployer: [''],
      autoSelectEmp: [false],

    });

    this.emailForm = this.formBuilder.group({
      newEmail: [
        '',
        [
          // Validators.required,
          // Validators.pattern(this.consts.emailPattern2)  // Email pattern from service
          Validators.pattern(
            '^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
          ),
        ]
      ]
    });

    this.route.queryParams.subscribe((params) => {
      if (params['success']) {
        if (params['success'] == "False") {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: "Invalid Credit Card Details, Please try again" })
        } else if (params['success'] == "True") {
          //Added by sudeep.k on Apr 03 2024, for paymentMethodId going as null in payload fix
          if (params['paymentMethodId']) {
            this.commonApiAlgo.updatePaymentMethod(this.selectedPaymentMethod);
            Swal.fire({ title: "Success", text: "CreditCard Details verfied successfully" })
            this.router.navigate(['/dashboard']);
            this.getDetails();
          } else {
            Swal.fire({ title: "Success", text: "CreditCard Details verfied successfully" })
          }
        }
        this.router.navigate(['/dashboard']);
        // this.savePadsignatureROE();
      } else {
        // this.ReviewSummary();
      }
    })


    // this.getLanguageTokens();
    // this.getCustomersData();
    this.formConfig();
    // this.getDetails();

    this.unlistener = this.renderer2.listen("document", "click", event => {
      this.logger.log(event)
      let element = event.target
      var attribute = element.getAttribute("href");
      if (element.innerText) {
        this.logger.log(element.innerText)
      }
      var heading = element.innerText;
      this.headerName = element.innerText;
      // this.videoPopup = 'block';
      if (event.target.className == 'video') {
        event.preventDefault();
        this.videoLink = attribute;
        this.videoTitle = heading;
        var video = document.getElementsByTagName('video')[0];
        this.logger.log(video)

        this.openVideoPopup();
        video.load();
        video.play();
      }
      if (event.target.className == 'shortlink') {
        this.openSupportPopup();
        this.support_link = this.sanitizer.bypassSecurityTrustResourceUrl(attribute);
        event.preventDefault();
      }
      if (event.target.className == 'booklet') {
        this.openequitablePopup();
        event.preventDefault();
        console.log(this.booklet_link);
        this.booklet_link = element.getAttribute("href");
        console.log(this.booklet_link);
      }

      if (event.target.classList.contains('closevideo')) {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'closevideo') {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'drugsmart') {
        event.preventDefault();
        window.open("https://drugsmart-pharmacy.myshopify.com/account/register",
          "Register Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.className == 'bedrugsmart') {
        event.preventDefault();
        window.open("https://bedrugsmart.ca/pages/direct2u",
          "Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.classList.contains('site')) {
        this.logger.log('attribute', attribute)
        this.logger.log(typeof attribute)
        this.logger.log(attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions')
        this.logger.log(attribute == 'https://www.myfriendlylawyer.com/subscriptions')
        if (attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions') {
          attribute = 'https://www.myfriendlylawyer.com/subscriptions';
        }
        this.logger.log('afterattribute', attribute)
        this.iframeLink = this.sanitizer.bypassSecurityTrustResourceUrl(attribute)
        this.iframeTitle = heading;
        this.logger.log(this.iframeLink.changingThisBreaksApplicationSecurity)
        if (this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://groupbenefitz.lifespeak.com' && this.iframeLink.changingThisBreaksApplicationSecurity != 'http://my.norton.com/' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://clients.cowangroup.ca/') {
          this.logger.log(this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en')
          this.openiframePopup();
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en') {
          window.open("https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en", "CloudMDKii", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://groupbenefitz.lifespeak.com') {
          window.open("https://groupbenefitz.lifespeak.com", "LifeSpeak", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'http://my.norton.com/') {
          window.open("http://my.norton.com/", "Norton", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }

        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://clients.cowangroup.ca/') {
          window.open("https://clients.cowangroup.ca/", "Cowin", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        event.preventDefault();
      }
      // alert(attribute);

      // alert(heading);
      // document.getElementsByClassName("vid-title")[0].innerText=heading;
      // document.getElementsByTagName("source")[0].src=attribute;



      // var video = document.getElementsByTagName('video')[0];



      // video.load();
      // video.play();
    });


    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    const monthAbbreviations = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    this.nextMonthName = monthAbbreviations[nextMonth.getMonth()];
    this.year = nextMonth.getFullYear();

    // this.getDraftInvoices();
    var swiper1 = new Swiper('.swiper-container1', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChangeTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideChangeTransitionEnd: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideNextTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slidePrevTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        }
      }
    });
    var swiper2 = new Swiper('.swiper-container2', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChangeTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideChangeTransitionEnd: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideNextTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slidePrevTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        }
      }
    });

    // this.logger.log("details: " + JSON.stringify(details))

    // this.generate_Invite_Link="https://test.groupbenefitz.aitestpro.com/#/corporate/tL2YYXwR0367";
    // $(document).ready(function () {
    //   $("#gm1").gaugeMeter(
    //     {
    //       id: "gm1",
    //       label: 'Status',
    //       percent: 0,
    //       used: 0,
    //       total: 10,
    //       size: 200,
    //       width: 20,
    //       prepend: "",
    //       append: "%",
    //       color: "green",
    //       back: "silver",
    //       style: "Semi",
    //       "stripe": 3,
    //       animate_gauge_colors: 1,
    //       animate_text_colors: 1,
    //       showvalue: false
    //     });
    //   $("#gm2").gaugeMeter(
    //     {
    //       id: "gm2",
    //       label: 'Employees Enrolled',
    //       percent: 0,
    //       used: 0,
    //       total: 10,
    //       size: 200,
    //       width: 20,
    //       prepend: "",
    //       append: "%",
    //       color: "blue",
    //       back: "silver",
    //       style: "Semi",
    //       "stripe": 3,
    //       animate_gauge_colors: 1,
    //       animate_text_colors: 1,
    //       showminmax: true
    //     });
    //   $("#gm3").gaugeMeter(
    //     {
    //       id: "gm3",
    //       label: 'Employees Rostered',
    //       percent: 0,
    //       used: 0,
    //       total: 10,
    //       size: 200,
    //       width: 20,
    //       prepend: "",
    //       append: "%",
    //       color: "blue",
    //       back: "silver",
    //       style: "Semi",
    //       "stripe": 3,
    //       animate_gauge_colors: 1,
    //       animate_text_colors: 1,
    //       showminmax: true
    //     });
    //   $("#gm4").gaugeMeter(
    //     {
    //       id: "gm4",
    //       label: 'Expected Premium',
    //       percent: 0,
    //       used: 0,
    //       total: 10,
    //       size: 200,
    //       width: 20,
    //       prepend: "",
    //       append: "K",
    //       color: "blue",
    //       back: "silver",
    //       style: "Semi",
    //       "stripe": 3,
    //       animate_gauge_colors: 1,
    //       animate_text_colors: 1,
    //       showminmax: true,
    //       showvalue: true
    //     });
    //   $("#gm5").gaugeMeter(
    //     {
    //       id: "gm5",
    //       label: 'Monthly Premium',
    //       percent: 0,
    //       used: 0,
    //       total: 0,
    //       size: 200,
    //       width: 20,
    //       prepend: "",
    //       append: "K",
    //       color: "blue",
    //       back: "silver",
    //       style: "Semi",
    //       "stripe": 3,
    //       animate_gauge_colors: 1,
    //       animate_text_colors: 1,
    //       showminmax: true,
    //       showvalue: true
    //     });
    //   $("#gm6").gaugeMeter(
    //     {
    //       id: "gm6",
    //       label: 'Wallet Pre-pay',
    //       percent: 0,
    //       used: 0,
    //       total: 0,
    //       size: 200,
    //       width: 20,
    //       prepend: "",
    //       append: "K",
    //       color: "blue",
    //       back: "silver",
    //       style: "Semi",
    //       "stripe": 3,
    //       animate_gauge_colors: 1,
    //       animate_text_colors: 1,
    //       showminmax: true,
    //       showvalue: true
    //     });


    // });
    // this.updateChart()

    // this.summaryDates()
    this.adminValidators();
    // this.registeredDate = this.datePipe.transform(
    //   sessionStorage.getItem("adminApprovedDate"),
    //   'yyyy-MM-dd'
    // ) || ''
    // this.approvedDate = this.datePipe.transform(
    //   sessionStorage.getItem("linksSendDate"),
    //   'yyyy-MM-dd'
    // ) || ''

    // this.linksentDate = this.datePipe.transform(
    //   sessionStorage.getItem("registeredDate"),
    //   'yyyy-MM-dd'
    // ) || ''

    // this.registeredDate = this.dateTransForms(sessionStorage.getItem("adminApprovedDate") || "");
    // this.approvedDate = this.dateTransForms(sessionStorage.getItem("linksSendDate") || "");
    // this.linksentDate = this.dateTransForms(sessionStorage.getItem("registeredDate") || "");

    this.approvedDate = this.dateTransForm(sessionStorage.getItem("linksSendDate") || "");
    this.linksentDate = this.dateTransForm(sessionStorage.getItem("registeredDate") || "");

    this.role = sessionStorage.getItem('role');
    // this.userName = sessionStorage.getItem('adminName');
    this.userName = sessionStorage.getItem('groupContactName');
    this.email = sessionStorage.getItem('loginname');
    this.loginame = sessionStorage.getItem("loginname")


    const url = window.location.origin;
    this.paymentUri = url + "/dashboard"
    this.paymentsuccessuri = url + "/dashboard"
    this.paymentfirstname = "Test1";
    this.paymentlastname = "test2";
    this.paymentemail = "test12E@aitestpro.com";

    this.fusbillinfocaptchavalue = "6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11";
    this.publicapikey = sessionStorage.getItem('publicapikey')
    this.creditCardForm = this.formBuilder.group({
      CustomerID: [''],
      PublicApiKey: [''],
      SuccessUri: [''],
      FailUri: [''],
      FirstName: [''],
      LastName: [''],
      email: [''],
      CardNumber: ["", Validators.compose([Validators.required, creditcardvalidation])],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      cvv: ["", Validators.compose([Validators.required, Validators.minLength(3)])],
      // recaptchaReactivepayment: ['', Validators.required]
      recaptchaReactivepayment: ['']
    })
    this.padInformationForm = this.formBuilder.group({
      bankCode: ["", [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      transit: ["", [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNumber: ["", [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      padDetailsVoidUpload: [this.uploadedVoidName],
    });
    this.paymentMethodForm = this.formBuilder.group({
      paymentMethodSelection: [""],
      creditCardForm: this.creditCardForm,
      padInformationForm: this.padInformationForm,
    });

    //   const currentDate = new Date();
    //   const day = currentDate.getDate();
    //   const month = currentDate.getMonth(); /
    //   const year = currentDate.getFullYear();


    //   this.renewalDate = {
    //     'Classic Bronze': 'Dec 1' + year,
    //   'Classic Silver': 'Dec 1',
    //   'Mental Health & Wellbeing': 'Jan 1',
    //   'Wellness': 'Jan 1',
    //   'EAP 2.0': 'Jan 1',
    //   'Mind & Body': 'Jan 1',
    //   'Complete Wellness': 'Jan 1',
    //   'High-Cost Drugs': 'Jun 1',
    //   'Protect 100': 'April 1',
    //   'Protect 200': 'April 1',
    //   'Private Health': 'Sept 1',
    //   'Executive Health': 'Sept 1',
    //   'Complete Executive Care': 'Sept 1'
    // };

    this.getRenewsPlansDates();

    // corp info page data group contacts

    // this.getGroupContactList();
    this.clientValidators();



    this.dropdownSettings = {
      singleSelection: false,
      closeDropDownOnSelection: true,
      idField: 'id',
      // textField: 'name',
      textField: 'shortName',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };





    //membership code
    // this.getHealthBooklets();
    // this.getCustomerData();

    this.getLanguageTokens()

  }
  ngAfterViewInit() {
    this.signPad = new SignaturePad(this.signaturePadElement.nativeElement);
  }
   forceLowercase(event: Event): void {
      const input = event.target as HTMLInputElement;
      const lowerValue = input.value.toLowerCase();

      input.value = lowerValue;
      this.adminform.get('adminemail')?.setValue(lowerValue, { emitEvent: false });
    }


  toggleAdminEmailClick(employee: any) {
    console.log(employee)
    employee.emailClicked = !employee.emailClicked;
    this.anyAdminEmailClicked = this.employeeList.some(a => a.emailClicked);
  }

  toggleGroupAdminEmailClick(admin: any) {
    console.log(admin)
    admin.emailClicked = !admin.emailClicked;
    this.anyAdminGroupEmailClicked = this.groupContacts.some(a => a.emailClicked);
  }
  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "corporateDashboard"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })
  }

  public plansButtonDisable = false;
  public submitbasicInfo() {
    this.plansButtonDisable = true;
    this.showEmployeeValue = this.settingsform.value.expectednoofEmployees || ""

    //  this.headerComponent.headerDetails('login');
    // this.dummyData()
    // this.headerComponent.headerDetails('login');

    this.logger.log(this.settingsform);
    let customSelectedError = false;
    this.settingsform.get('waitingPeriod').setValue(this.settingsform.get('waitingPeriod').value ?? '');
    // if(this.customSelected&&this.settingsform.get('waitingPeriod').value=='Custom'){
    //    customSelectedError=true;
    // }

    // if (this.settingsform.invalid||(this.settingsform.get('waitingPeriod').value===''&&this.customSelected)) {
    if (this.settingsform.invalid) {
      this.logger.log(JSON.stringify(this.settingsform.value, null, 2));
      this.settingsform.markAllAsTouched();
      this.scrollToFirstInvalidControl1();
    } else {
      // this.logger.log("ok")
      var accessToken = sessionStorage.getItem('accessToken');
      var customerValidation = '/api/ap/admin/v2/corporate/customer/validation';

      this.configprovinceres.forEach((element: any) => {
        if (element.shortName.toLowerCase() == this.settingsform.value.Province.toLowerCase()) {
          this.provincialHealthcareUrl = element.provincialHealthcareUrl;
          this.provincialZipcodes = element.zipcodes.split(',');
          this.provincelistid = element.id;
          this.state_id = parseInt(element.fusebillId);
          this.statename = element.name;
        }
      });

      sessionStorage.setItem('summaryBlock1', '[]');
      sessionStorage.setItem('summaryBlockBulk', '[]');


      sessionStorage.setItem('walletConfig', '{}');
      // sessionStorage.setItem('selectedPlans', '{}');
      sessionStorage.setItem('summaryBlock1main', '[]');
      sessionStorage.setItem('summaryBlock1opt', '[]');
      // sessionStorage.setItem('selectedBlock1', '{}');
      sessionStorage.setItem('summaryBlock2', '[]');

      // sessionStorage.setItem('summaryBlock2main', '[]');
      sessionStorage.setItem('summaryBlock2opt', '[]');
      // sessionStorage.setItem('selectedBlock2', '{}');

      sessionStorage.setItem('summaryBlock3', '[]');

      sessionStorage.setItem('summaryBlock3main', '[]');
      sessionStorage.setItem('summaryBlock3opt', '[]');
      sessionStorage.setItem(
        'requireEmployeeName',
        this.settingsform.value.ShowEmployer
      );

      // sessionStorage.setItem('selectedBlock3', '{}');

      // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

      this.maxEmployeeCount = this.settingsform.value.expectednoofEmployees;
      var voidfileExtension = '';
      let voidcheckDetails = '';
      let logoDetails = '';

      if (this.bankDetails) {
        voidfileExtension = '.' + this.voidcheckfile.name.split('.').pop();
        (voidcheckDetails = this.voidcheckfile),
          'void_cheque_' + Date.now() + voidfileExtension.toLowerCase();
      } else {
        voidcheckDetails = '';
      }

      if (this.uploadadminlogoimg) {
        (logoDetails = this.uploadadminlogoimg),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploadadminlogoimg.name.split('.').pop().toLowerCase();
      } else {
        logoDetails = '';
      }

      this.session = sessionStorage.getItem('session');

      var padinfo: any;
      var creditCardinfo;
      var invoicemonthy;
      if (this.settingsform.value.paymentInfo == 'pad') {
        padinfo = 'true';
      } else if (this.settingsform.value.paymentInfo == 'creditcard') {
        creditCardinfo = 'true';
      } else {
        invoicemonthy = 'true';
      }

      var formdata = new FormData();

      formdata.append(
        'corporationName',
        this.settingsform.value.corporationName
      );

      formdata.append('brokerType', 'CORPORATE');
      formdata.append(
        'workingProvinces',
        JSON.stringify(this.multiSelectProviance)
      );
      formdata.append('cpPlanAutoSelection', this.settingsform.value.autoSelectEmp);

      formdata.append(
        'policyStartDate',
        this.datePipe.transform(
          this.settingsform.value.PolicyStartDate,
          'yyyy-MM-dd'
        ) || '0000-00-00'
      );

      formdata.append('logo', logoDetails);

      formdata.append('fuseBillCustomerCreation', 'true');

      formdata.append('voidCheck', voidcheckDetails);

      formdata.append('gropupAdmin', JSON.stringify(this.adminData));
      let waitingPeriod;

      if (this.customSelected && this.settingsform.value.waitingPeriod == 'Custom') {
        waitingPeriod = this.settingsform.value.waitingPeriodCustom || 0;

      } else {
        waitingPeriod = this.settingsform.value.waitingPeriod || 0;
      }
      formdata.append(
        'waitingPeriod',
        waitingPeriod || 0
      );

      formdata.append(
        'corporateEmployeesInitialSignupWaittime',
        this.settingsform.value.waitingPeriodinitialsignup
      );

      formdata.append('useCreditCard', creditCardinfo ? 'true' : 'false');

      // formdata.append('invoicePayment', invoicemonthy ? 'true' : 'false');
      //Invoices are not using so send as false
      formdata.append('invoicePayment', invoicemonthy ? 'false' : 'false');

      formdata.append('padPayment', padinfo ? 'true' : 'false');

      formdata.append('session', this.session);

      formdata.append('setupWallet', this.settingsform.value.walletConfig);

      formdata.append(
        'setUplevelofCoverage',
        this.settingsform.value.tierConfig
      );

      formdata.append(
        'exptNumofEmp',
        this.settingsform.value.expectednoofEmployees || 0
      );
      formdata.append('requireEmployeeName', JSON.parse(sessionStorage.getItem('requireEmployeeName')))


      formdata.append(
        'streetAddressLine1',
        this.capitalize(this.settingsform.value.streetAddress) || ''
      );

      formdata.append(
        'streetAddressLine2',
        this.capitalize(this.settingsform.value.streetAddress2) || ''
      );
      formdata.append('apt', this.settingsform.value.apt_suite || '');

      formdata.append('city', this.capitalize(this.settingsform.value.city));

      formdata.append('province', this.settingsform.value.Province);

      formdata.append('provinceId', this.provincelistid);

      formdata.append('state', this.settingsform.value.Province);

      formdata.append('stateId', this.state_id);

      formdata.append('country', this.settingsform.value.country);

      formdata.append('countryId', '1');
      formdata.append('fbcountryId', '124');
      formdata.append('parentId', this.settingsform.value.brokerName || 0);

      formdata.append('postalCode', this.settingsform.value.postalCode);
      formdata.append(
        'corporateClientId',
        sessionStorage.getItem('corporateClientId') ||
        environment.corporateClientId
      ); //fusebillid
      formdata.append(
        'corporateId',
        sessionStorage.getItem('corporateId') || '0'
      ); //corporateid

      this.settingsform.value['logo'] = logoDetails

      sessionStorage.setItem(
        'formData',
        JSON.stringify(this.settingsform.value)
      );
      // this.logger.log({ logoDetails })
      // formdata.forEach((val, key) => this.logger.log(`${key}:${val}`))
      // return;


      var requestOptions: any = {
        method: 'POST',

        body: formdata,

        redirect: 'follow',
        headers: { Authorization: 'Bearer ' + accessToken },
      };

      this.logger.log({ disable: this.plansButtonDisable })

      fetch(environment.apiUrl + customerValidation, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // this.logger.log(response);
          response = JSON.parse(response);

          if (response['status'] == 200) {

            this.logger.log({ disable: this.plansButtonDisable })

            let CorpId = this.route.snapshot.params['id']
            var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + endPoint
            // ]);
            this.coreplantemplateValue = null;
            this.plansBlock1 = response.plans.packages;
            this.balkPlans = response.plans.bulkPackages;


            this.plansBlock1Tiers = response.plans.packages;

            this.plansBlock1.forEach((planlevel: any) => {
              planlevel.groups.forEach((groups: any) => {
                groups.subGroups.forEach((subgroup: any) => {
                  subgroup.tiers = [];
                  subgroup.checked = false;
                });
              });
            });
            this.plansBlock1Tiers.forEach((planlevel: any) => {
              this.selectedPackagePlansInfoTier[planlevel.id] = [];
              this.selectedPackagePlansInfoTiername[planlevel.id] =
                planlevel.name;
              this.selectedPackagePlansInfoTierBlock2[planlevel.id] = [];
              this.selectedPackagePlansInfoTiernameBlock2[planlevel.id] =
                planlevel.name;
              this.selectedPackagePlansInfoTierBlock3[planlevel.id] = [];
              this.selectedPackagePlansInfoTiernameBlock3[planlevel.id] =
                planlevel.name;

              this.selectedPackagesavailableTiers2[planlevel.id] = {};
              this.selectedPackagesassignedTiers2[planlevel.id] = {};
              this.selectedPackagesavailableTiers2Block2[planlevel.id] = {};
              this.selectedPackagesassignedTiers2Block2[planlevel.id] = {};

              this.selectedPackagesavailableTiers3[planlevel.id] = {};
              this.selectedPackagesassignedTiers3[planlevel.id] = {};
              this.selectedPackagesavailableTiers3Block3[planlevel.id] = {};
              this.selectedPackagesassignedTiers3Block3[planlevel.id] = {};
              planlevel.groups.forEach((groups: any) => {
                groups.subGroups.forEach((subgroup: any) => {
                  this.selectedPackagesavailableTiers2[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers2[planlevel.id][
                    subgroup.id
                  ] = [];
                  this.selectedPackagesavailableTiers2Block2[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers2Block2[planlevel.id][
                    subgroup.id
                  ] = [];

                  this.selectedPackagesavailableTiers3[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers3[planlevel.id][
                    subgroup.id
                  ] = [];
                  this.selectedPackagesavailableTiers3Block3[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers3Block3[planlevel.id][
                    subgroup.id
                  ] = [];
                  subgroup.tiers = [];
                  subgroup.checked = false;
                  subgroup.coverage = ''; //default
                });
              });
            });


            this.executeBlocks()
              .then((message) => this.logger.log(message))
              .catch((error) => console.error("An error occurred:", error));


            // setTimeout(() => {
            //   const dom: HTMLElement = this.elementRef.nativeElement;
            //   this.logger.log('this.paidByCompany',this.paidByCompany);
            //   if(this.paidByCompany.length>0){
            //   for(let i=0;i<this.paidByCompany.length;i++){
            //     const element: any = dom.querySelector("#plancheck" + this.paidByCompany[i].planLevelId);
            //    if(element!=null)
            //     element.click()
            //   }
            // }

            // setTimeout(() => {
            //   if(this.coveredByCompany.length>0){
            //     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
            //    if(el1!=null) el1.click();
            //     this.upgradeplansselection == true;

            //     setTimeout(() => {
            //     for(let j=0;j<this.coveredByCompany.length;j++){
            //       const element: any = dom.querySelector("#plancheck2" + this.coveredByCompany[j].planLevelId);
            //      if(element!=null) element.click();
            //     }
            //   }, 1500);
            //   }
            //   setTimeout(() => {
            //     if(this.paidByEmployee.length>0){
            //       let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            //       if(el1!=null) el1.click();
            //       this.employeeplanpurchase == true
            //       setTimeout(() => {
            //       for(let k=0;k<this.paidByEmployee.length;k++){
            //         const element: any = dom.querySelector("#plancheck3" + this.paidByEmployee[k].planLevelId);
            //         element.click()


            //       }
            //     }, 1000);
            //     }
            //   }, 2000);
            // }, 1500);



            // }, 1000);

            sessionStorage.setItem(
              'planResults',
              JSON.stringify(this.plansBlock1)
            );
            sessionStorage.setItem(
              'plansBlock1Tiers',
              JSON.stringify(this.plansBlock1Tiers)
            );

            setTimeout(() => {
              $('#executiveplanssingle17').prop('disabled', true);
              $('#executiveplanscouple17').prop('disabled', true);
              $('#executiveplansfamily17').prop('disabled', true);
              $('#executiveplanssingle18').prop('disabled', true);
              $('#executiveplanscouple18').prop('disabled', true);
              $('#executiveplansfamily18').prop('disabled', true);
              $('#executiveplanssingle28').prop('disabled', true);
              $('#executiveplanscouple28').prop('disabled', true);
              $('#executiveplansfamily28').prop('disabled', true);

              $('#executiveplansTiersingle17').prop('disabled', true);
              $('#executiveplansTiercouple17').prop('disabled', true);
              $('#executiveplansTierfamily17').prop('disabled', true);
              $('#executiveplansTiersingle18').prop('disabled', true);
              $('#executiveplansTiercouple18').prop('disabled', true);
              $('#executiveplansTierfamily18').prop('disabled', true);
              $('#executiveplansTiersingle28').prop('disabled', true);
              $('#executiveplansTiercouple28').prop('disabled', true);
              $('#executiveplansTierfamily28').prop('disabled', true);

              $('#executiveplansblock2single17').prop('disabled', true);
              $('#executiveplansblock2couple17').prop('disabled', true);
              $('#executiveplansblock2family17').prop('disabled', true);
              $('#executiveplansblock2single18').prop('disabled', true);
              $('#executiveplansblock2couple18').prop('disabled', true);
              $('#executiveplansblock2family18').prop('disabled', true);
              $('#executiveplansblock2single28').prop('disabled', true);
              $('#executiveplansblock2couple28').prop('disabled', true);
              $('#executiveplansblock2family28').prop('disabled', true);
              this.plansButtonDisable = false;
            }, 1000);

            // if(this.existingPlans.length>0){
            //   for()
            // }

            this.updateAllStatus();

            this.assignAllplanLvelwithdisallowed(this.plansBlock1);
            // this.headerComponent.headerDetails('login');
            // this.headerComponent.applicationStatus(this.lengthofstatus);
            // this.plansBlock1 =response.plans.packages
            this.corporateId = response.data.corporateId;
            this.corporateClientId = response.data.fuseBillId;
            this.assignAllplanLvelwithdisallowedTiers(this.plansBlock1Tiers);
            sessionStorage.setItem('corporateId', this.corporateId);
            sessionStorage.setItem('corporateClientId', this.corporateClientId);
            sessionStorage.setItem(
              'corporateClientName',
              response.data.corporateName
            );
            sessionStorage.setItem(
              'mainresults',
              JSON.stringify(this.plansBlock1)
            );
            sessionStorage.setItem(
              'planResults',
              JSON.stringify(this.plansBlock1)
            );

            this.basicInfo = false;
            this.plansInfo = true;
            const dom: HTMLElement = this.elementRef.nativeElement;

            // this.headerComponent.headerDetails('login');

            if (this.settingsform.value.tierConfig == true) {
              this.showtierbasicplans = false;
              this.showtieradvplans = true;
              // this.showtierbasicplans = false;
              this.showtieradvplans = true;
              this.showconfigurebutton = true;
            } else {
              this.showtierbasicplans = true;
              this.showtieradvplans = false;
              // this.showtierbasicplans = true;
              this.showtieradvplans = false;
              this.showconfigurebutton = false;
            }
            if (this.settingsform.value.tierConfig == true) {
              this.showemptytierconfig = true;
            } else {
              this.showemptytierconfig = false;
            }
            if (this.settingsform.value.walletConfig == false) {
              this.showemptywalletConfig = false;
            } else {
              this.showemptywalletConfig = true;
            }
            // setTimeout(() => {
            //   // const element: any = dom.querySelector('#plancheck' + 16);
            //   // element.click();
            //   let el1: HTMLElement = this.upgradeplansfalse.nativeElement;
            //   el1.click();
            //   this.upgradeplansselection == false;
            //   let el2: HTMLElement = this.employeepurchasefalse.nativeElement;
            //   el2.click();
            //   this.employeeplanpurchase == false;
            // }, 1000);
            let selectedplansblock1 = JSON.parse(
              sessionStorage.getItem('summaryBlock1') || '[]'
            );
            let selectedplansblock2 = JSON.parse(
              sessionStorage.getItem('summaryBlock2') || '[]'
            );
            let selectedplansblock3 = JSON.parse(
              sessionStorage.getItem('summaryBlock3') || '[]'
            );
            // setTimeout(() => {
            //   const dom: HTMLElement = this.elementRef.nativeElement;
            //   if(selectedplansblock1.length>0){
            //   for(let i=0;i<selectedplansblock1.length;i++){
            //     const element: any = dom.querySelector("#plancheck" + selectedplansblock1[i].subGroupId);
            //     element.checked =true
            //     this.plancheckCoverage = selectedplansblock1[i].coverage

            //   }
            // }
            //   if(selectedplansblock2.length>0){
            //     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
            //     el1.click();
            //     this.upgradeplansselection == true
            //     setTimeout(() => {
            //     for(let i=0;i<selectedplansblock2.length;i++){
            //       const element1: any = dom.querySelector("#plancheck2" + selectedplansblock2[i].subGroupId);
            //       element1.checked =true
            //       this.plancheck2Coverage = selectedplansblock2[i].coverage
            //     }
            //   },1000)
            //   }
            //   if(selectedplansblock3.length>0){
            //     let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            //     el1.click();
            //     this.employeeplanpurchase == true
            //     setTimeout(() => {
            //     for(let i=0;i<selectedplansblock3.length;i++){
            //       const element2: any = dom.querySelector("#plancheck3" + selectedplansblock3[i].subGroupId);
            //       element2.checked =true
            //       this.plancheck3Coverage = selectedplansblock3[i].coverage
            //     }
            //   },1500)
            //   }
            // }, 1000);
            sessionStorage.setItem('selectedTiersBlock1', '[]');
            sessionStorage.setItem('selectedTiersBlock2', '[]');
            sessionStorage.setItem('selectedTiersBlock3', '[]');
            this.selectedPackagePlansInfoTier = {};
            this.selectedPackagePlansInfoTierBlock2 = {};
            this.selectedPackagePlansInfoTierBlock3 = {};
            this.selectedPackagePlansInfoTier2 = {};
            this.selectedPackagePlansInfoTier2Block2 = {};
            this.selectedPackagePlansInfoTier3Block3 = {};

            this.seelctedplanLevelTierMapping = []
            this.seelctedplanLevelTierMappingBlock2 = []
            this.seelctedplanLevelTierMappingBlock3 = []

            if (this.employeeList.length > 0) {
              for (let i = 0; i < this.employeeList.length; i++) {
                if (this.employeeList[i].isBulk == true) {
                  this.bulkemployeeList.push(this.employeeList[i])
                }
              }

            }
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
          }
          else if (response['status'] == 202) {
            // Swal.fire(this.lang.Error??'Error',response.message);
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        })

      // .catch((error) => this.logger.log(this.lang.Error??'Error', error));
    }

    // if (this.settingsform.invalid) {
    //   return;
    // }

  }



  openequitablePopup() {
    let el: HTMLElement = this.openequitable.nativeElement;
    el.click();
  }

  getRenewsPlansDates() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth(); // Month is zero-based, so no need to add 1
    const year = currentDate.getFullYear();

    this.renewalDate = {
      'Classic Bronze': 'Dec 1',
      'Classic Silver': 'Dec 1',
      'Mental Health & Wellbeing': 'Jan 1',
      'Wellness': 'Jan 1',
      'EAP 2.0': 'Jan 1',
      'Mind & Body': 'Jan 1',
      'Complete Wellness': 'Jan 1',
      'High-Cost Drugs': 'Jun 1',
      'Protect 100': 'April 1',
      'Protect 200': 'April 1',
      'Private Health': 'Sep 1',
      'Executive Health': 'Sep 1',
      'Complete Executive Care': 'Sep 1',
      'KixCare Kix360': 'Jan 1'
    };

    // 'Life Insurance':'',
    // 'Critical Illness':'',

    for (const plan in this.renewalDate) {
      const renewalDateParts = this.renewalDate[plan].split(' ');
      const renewalMonth = this.getMonthNumber(renewalDateParts[0]);
      const renewalDay = parseInt(renewalDateParts[1], 10);
      if (month > renewalMonth || (month === renewalMonth && day > renewalDay)) {
        this.renewalDate[plan] = `${renewalDateParts[0]} ${renewalDateParts[1]}`;
      } else {
        this.renewalDate[plan] = `${renewalDateParts[0]} ${renewalDateParts[1]}`;
      }
    }

  }

  openVideoPopup() {
    let el: HTMLElement = this.openPopup.nativeElement;
    el.click();
  }


  uploadadminlogo(event1: any) {
    this.logger.log('test');
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadadminlogoimg = event1.target.files[0];
    this.logger.log(this.uploadadminlogoimg)

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadadminlogoimg.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadadminlogoimg.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.uploadlogoafter = true;
          this.imagedisplay = reader.result;
        };
        sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 5 MB'
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang.File_size_is_too_large_maximum_file_size_is_1_Mb;
        // alert(message);
        Swal.fire({ title: 'Info', text: message });
        this.uploadadminlogoimg = "";
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
      this.uploadadminlogoimg = "";
    }
  }

  removeExistingLogo() {
    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_Logo,
      showCancelButton: true,
      denyButtonText: this.lang.Cancel,
      confirmButtonText: this.lang.Proceed
    }).then((result) => {
      if (result.isConfirmed) {
        this.logo = null;
        this.showimagelogo = true;
        this.uploadlogoafter = false;
        this.imagedisplay = '';
        this.uploadadminlogoimg = '';
        sessionStorage.setItem('adminlogo', '');
        this.client['corporatelogo'].reset();
      }
    });
  }

  uploadadminlogoclear(event1: any) {
    this.showimagelogo = true;
    this.uploadlogoafter = false;
    this.imagedisplay = '';
    this.uploadadminlogoimg = '';
    sessionStorage.setItem('adminlogo', '');
    this.client['corporatelogo'].reset();
    // this.client['corporatelogo'].setValidators([Validators.required]);

    // this.client['corporatelogo'].updateValueAndValidity();
  }


  uploadadminlogo1(event1: any) {
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadadminlogoimg = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadadminlogoimg.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadadminlogoimg.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.imagedisplay = reader.result;
        };
        sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 300kb';
        message = `File size is too large,maximum file size is 5 MB`
        // alert(message);
        Swal.fire({ title: 'Info', text: message });
        this.uploadadminlogoimg = "";
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
      this.uploadadminlogoimg = "";
    }
    // var reader = new FileReader();
    // reader.readAsDataURL(event1.target.files[0]);

    // reader.onload = (_event) => {
    //   this.showimagelogo = false;
    //   this.imagedisplay = reader.result;
    // };
    // sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
  }



  openSupportPopup() {
    let el: HTMLElement = this.opensupport.nativeElement;
    el.click();
  }


  getMonthNumber(monthName) {
    const months = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };
    return months[monthName];
  }

  //yyyy-MM-dd
  dateTransForm(input: any) {
    return this.datePipe.transform(input,
      'yyyy-MM-dd'
    ) || ''
  }
  //yyyy-MM-dd
  dateTransForms(input: any) {
    return this.datePipe.transform(input,
      'MMM-dd-yyyy'
    ) || ''
  }
  @ViewChild('generateInviteLink') generateInviteLinkCopy: ElementRef;
  @ViewChild('videoPopup') openPopup: any;

  copyToClipboard(link) {

    // const text = this.generateInviteLinkCopy.nativeElement.innerText;
    const text = link;

    const button = document.getElementById("copyButton") as HTMLButtonElement;
    if (button) {
      button.disabled = true;
      button.style.color = 'white';
      setTimeout(() => {
        button.disabled = false;
      }, 1000);
    }

    const clipboard = new ClipboardJS('#copyButton', {
      text: () => text
    });

    clipboard.on('success', (e) => {
      this.logger.log(`Text "${text}" was copied to the clipboard`);
      e.clearSelection();
    });

    clipboard.on(this.lang.Error ?? 'Error', (e) => {
      console.error('Unable to copy text to clipboard', e);
    });



    Swal.fire({
      text: 'Link Copied',
      // icon: 'info',
      timer: 1500, // Set the timer to 3000 milliseconds (3 seconds)
      showConfirmButton: false, // Hide the "OK" button
      width: 270
    });


  }
  copyToClipboard2(text: string) {
  navigator.clipboard.writeText(text).then(() => {
    this.logger.log(`Copied to clipboard: ${text}`);
    Swal.fire({
      text: 'Copied to clipboard!',
      timer: 1500,
      showConfirmButton: false,
      width: 270
    });
  }).catch(err => {
    console.error('Failed to copy:', err);
    Swal.fire({
      text: 'Failed to copy!',
      icon: 'error',
      timer: 1500,
      showConfirmButton: false
    });
  });
}



  copyToClipboard1() {
    // const text = this.generateInviteLinkCopy.nativeElement.innerText;
    // const button = document.getElementById("copyButton") as HTMLButtonElement;
    // if (button) {
    //   button.disabled = true;
    //   button.style.color = 'white';
    //   setTimeout(() => {
    //     button.disabled = false;
    //   }, 1000);
    // }
    const button = document.getElementById("copyButton1") as HTMLButtonElement;
    if (button) {
      button.disabled = true;
      button.style.color = 'white';
      setTimeout(() => {
        button.disabled = false;
      }, 2000);
    }

    const clipboard = new ClipboardJS('#copyButton1', {
      text: () => this.loginLink
    });

    clipboard.on('success', (e) => {
      this.logger.log(`Link was copied to the clipboard`);
      e.clearSelection();
    });

    clipboard.on(this.lang.Error ?? 'Error', (e) => {
      console.error('Unable to copy text to clipboard', e);
    });



    Swal.fire({
      text: 'Link Copied',
      // icon: 'info',
      timer: 1500, // Set the timer to 3000 milliseconds (3 seconds)
      showConfirmButton: false, // Hide the "OK" button
      width: 270
    });


  }


  openiframePopup() {
    let el: HTMLElement = this.openiframe.nativeElement;
    el.click();
  }


  summaryDates() {
    //get id of the element -- update min, total(max), used(value) and all below

    var accessToken = sessionStorage.getItem('accessToken');
    var endPoint = '/api/ap/admin/corporate/' + this.corpId + '/metricsSummary1';
    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {

          // this.approvedDate = this.dateTransForms(response.data.adminApprovedDate || "");
          // this.linksentDate = this.dateTransForms(response.data.linksSendDate || "");
          // this.registeredDate = this.dateTransForms(sessionStorage.getItem("registeredDate") || "");

          this.approvedDate = this.dateTransForm(response.data.adminApprovedDate || "");
          this.linksentDate = this.dateTransForm(response.data.linksSendDate || "");

          // this.approvedDate =  this.datePipe.transform(
          //   response.data.adminApprovedDate,
          //   'yyyy-MM-dd'
          // ) || ''

          // this.linksentDate =  this.datePipe.transform(
          //   response.data.linksSendDate,
          //   'yyyy-MM-dd'
          // ) || ''

          // this.registeredDate = this.datePipe.transform(
          //   sessionStorage.getItem("registeredDate"),
          //   'yyyy-MM-dd'
          // ) || ''

        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
        }

      });


  }

  public fixUsedMaxGraph(amount) {
    return parseFloat(parseFloat(amount.toString()).toFixed(2))
  }
  // private getHeaders(): HttpHeaders {
  //   // You can customize headers like adding an authentication token here
  //   var token: any = 'Bearer ' + sessionStorage.getItem('accessToken');
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': token
  //   });
  //   return headers;
  // }



  pauseVideo(videoplayer: any) {

    videoplayer.nativeElement.play();

    // this.startedPlay = true;

    // if(this.startedPlay == true)

    // {

    setTimeout(() => {

      videoplayer.nativeElement.pause();

      if (videoplayer.nativeElement.paused) {

        this.show = !this.show;

      }

    }, 5000);

    // }

  }


allUniquePlansByType: any[] = [];

  async getDetails() {
    this.logger.log("data")
    var token: any = 'Bearer ' + sessionStorage.getItem('accessToken');

    // const headers = {
    //   'Content-Type': 'application/json',
    //   'Authorization': token,
    //   'corpId': corpId
    // };


    var endPoint = '/api/ap/admin/v2/corporate/' + this.corpId + '/details';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      }).subscribe(
        async (response: any) => {
          if (response['status'] == 200) {
            this.getCustomersData();
            this.corpDetails = response.data
            this.getCustomerInvoices()
            // this.getConfigurationEmails()
            this.showGenericTierLinks = response.data.showGenericTierLinks
            this.authorizenetCustomerId = response.data?.authorizenetCustomerId
            this.paymentPlatform = response.data?.paymentPlatform ?? 'Staxbill'
            this.genericTierLinks = response.data.genericTierLinks
            this.wallet = response.data?.defaultTier;
            if(response.data?.setUplevelofCoverage){
              this.corporateTiers = response.data?.corporateTiers ?? [];
            }else{
              this.corporateTiers.push(response.data?.defaultTier ?? {});
            }
            const today = new Date();
            this.latestPaymentStatus = this.corpDetails?.latestPaymentStatus;
            if(this.latestPaymentStatus === 'Failed'){
              if(this.corpDetails?.latestPaymentDetails?.captureDate < today){
                this.isReauth = true;
              }
              else{
                this.isRetryPayment = true;
              }
            }
            console.log(this.corporateTiers)
            // Combine all the arrays into one
            let allPlans=[]
            for (let i = 0; i < this.corporateTiers.length; i++) {
              // Process paidByCompany plans
              this.corporateTiers[i]?.plans?.paidByCompany?.forEach((plan) => {
                const existingPlan = allPlans.find(p => p.planLevelName === plan.planLevelName);
                if (existingPlan) {
                  // If planLevelName already exists, append the new tier to the existing one
                  existingPlan.tier = existingPlan.tier ? `${existingPlan.tier}, ${plan.tier}` : plan.tier;
                } else {
                  // Otherwise, add the new plan to allPlans
                  allPlans.push({ ...plan });
                }
              });
            
              // Process coveredByCompany plans
              this.corporateTiers[i]?.plans?.coveredByCompany?.forEach((plan) => {
                const existingPlan = allPlans.find(p => p.planLevelName === plan.planLevelName);
                if (existingPlan) {
                  existingPlan.tier = existingPlan.tier ? `${existingPlan.tier}, ${plan.tier}` : plan.tier;
                } else {
                  allPlans.push({ ...plan });
                }
              });
            
              // Process paidByEmployee plans
              this.corporateTiers[i]?.plans?.paidByEmployee?.forEach((plan) => {
                const existingPlan = allPlans.find(p => p.planLevelName === plan.planLevelName);
                if (existingPlan) {
                  existingPlan.tier = existingPlan.tier ? `${existingPlan.tier}, ${plan.tier}` : plan.tier;
                } else {
                  allPlans.push({ ...plan });
                }
              });
            }
            console.log(allPlans)

            // Extract the required fields
            const result = allPlans.map(plan => {
              let uniqueTiers:any = [...new Set(plan.tier.split(',').map(t => t.trim()))].join(',');

              return{
                isParent: plan.isParent,
                planLevelId: plan.planLevelId,
                planLevelName: plan.planLevelName,
                coverage: plan.coverage,
                planLevel: plan.planLevel,
                tier: uniqueTiers
              }
            });

            console.log(result);
            this.tierPlans = result;
            // this.fusebillCustomerDataId = response.data?.fusebillCustomerId;

            this.roeAgreementSigned = response.data.roeAgreementSigned;
            this.fusebillCustomerId = response.data?.corporateParentCustomer?.fusebillCustomerId ?? response.data?.fusebillCustomerId;
            this.customerId = response.data?.corporateParentCustomer?.id;
            this.aptSuite = response.data.apt;
            this.registeredDate = response?.data?.adminApprovedDate ? moment(response?.data?.adminApprovedDate).format('DD-MMM-YYYY') : 'NA';
            this.corporateParentCustomer = response?.data?.corporateParentCustomer

            this.noOfEmployees = response?.data?.expectedNumberofEmployess;
            this.corporateEmployeesInitialSignupWaittime = response.data.corporateEmployeesInitialSignupWaittime;
            this.settingsform.get('waitingPeriodinitialsignup').setValue(this.corporateEmployeesInitialSignupWaittime);
            let planbenefits = response.data.corporatePlanBenefits.corporatePlansBenefits;
            this.requireEmployeeName = response.data.requireEmployeeName

            this.settingsform.get('ShowEmployer').setValue(this.requireEmployeeName);
            this.settingsform.get('ShowEmployer').updateValueAndValidity();
            this.settingsform.get('autoSelectEmp').setValue(response.data.cpPlanAutoSelection);
            this.settingsform.get('autoSelectEmp').updateValueAndValidity();
            this.employeeWorkingProviance = response.data.working_provinces.sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );
            sessionStorage.setItem('working_provinces', JSON.stringify(this.employeeWorkingProviance))

            this.waitTime = response.data.waitTime;
            if (this.waitTime == 0) {
              this.NoWaithingPeridos = true;
            }
            else if (this.waitTime == 3) {
              this.threeMonths = true;
            } else if (this.waitTime == 6) {
              this.SixMonths = true;
            }
            this.benefits = [];
            for (let benefit of planbenefits) {
              if (benefit.content) {
                if (benefit.content.includes('{{booklet_link}}')) {
                  this.logger.log('headerName', this.headerName)
                  benefit.content = benefit.content.replace('{{booklet_link}}', benefit.bookletLink)
                }
              }
              // if(benefit.content.includes('greenshield')) {
              //   this.headerName = benefit.name;
              //   this.logger.log('headerName',this.headerName)
              //   benefit.content = benefit.content.replace('{{booklet_link}}',benefit.bookletLink)
              // }
              if (this.hicList && this.hicList.length > 0) {
                if (benefit.content.includes('{{health_card_link}}')) {
                  benefit.content = benefit.content.replace('{{health_card_link}}', this.hicList[0].healthCard);
                }
              }
              this.benefits.push(benefit)
            }





            this.corporationName = response.data.corporationName;
            const formD = {
              "brokerName": " ",
              "corporationName": response.data.corporationName,
              "PolicyStartDate": response.data.policyStartDate,
              "streetAddress": response.data.streetAddressLine1,
              "streetAddress2": response.data.streetAddressLine2,
              "apt_suite": response.data.apt,
              "country": response.data.country,
              "city": response.data.city,
              "Province": response.data.province,
              "multiSelectProviance": [
                {
                  "countryId": 1,
                  "id": 12,
                  "name": "Ontario",
                  "provincialHealthcareUrl": "https://www.ontario.ca/page/apply-ohip-and-get-health-card",
                  "published": true,
                  "shortName": "ON",
                  "zipcodes": "K,L,M,N,P",
                  "fusebillId": "9",
                  "equitableId": 8,
                  "equitableQuestions": null,
                  "smartchoiceId": 9,
                  "country_id": 1
                }
              ],
              "postalCode": response.data.postalCode,
              "waitingPeriod": response.data.waitTime,
              "waitingPeriodCustom": null,
              "waitingPeriodinitialsignup": null,
              "paymentInfo": response.data.padPayment ? 'pad' : 'credit_card',
              "bankCode": "",
              "BankTransit": "",
              "accounNum": "",
              "voidcheck": "",
              "corporatelogo": response.data.logo,
              "walletConfig": response.data.setupWallet,
              "tierConfig": response.data.setUplevelofCoverage,
              "expectednoofEmployees": response.data.expectedNumberofEmployess,
              "ShowEmployer": response.data.requireEmployeeName,
              "autoSelectEmp": response.data.cpPlanAutoSelection,
              "logo": response.data.logo
            }


            sessionStorage.setItem(
              'formData',
              JSON.stringify(formD)
            );



            this.groupContacts = response.data.groupAdmins_new;

            this.groupContacts = this.groupContacts.map(item => {
              if (item.hasOwnProperty('email') && item['email'] != "" && item['email'] != null && item['email'] != undefined) {
                const splitMail = item.email.split('@');
                const maskedEmail = splitMail[0].slice(0, 4) + '...@' + splitMail[1].slice(0, 2) + '...';
                return { ...item, maskedEmail };
              }
              else {
                return item;
              }
            });


            if (this.groupContacts.length > 0) {
              for (let admin of this.groupContacts) {
                admin['firstName'] = admin['firstName'] ?? '';
                admin['lastName'] = admin['lastName'] ?? '';
                admin['phoneNum'] = admin['phoneNum'] ?? '';
                admin['email'] = admin['email'] ?? '';
                admin['role'] = admin['role'] ?? '';
                admin['roleName'] = admin['roleName'] ?? '';
              }
              sessionStorage.setItem('adminData', JSON.stringify(this.groupContacts));
            }



            //setting the default values
            const admin = this.groupContacts[0];


            if (!!admin) {
              this.editadminfirstname = admin.firstName.trim() == "" || admin.firstName.trim() === null ? this.firstNameEmpty() : admin.firstName;
              this.editadminlastname = admin.lastName.trim() == "" || admin.lastName.trim() === null ? this.lastNameEmpty() : admin.lastName;;
              this.editadminphone = admin.phoneNum.trim() == "" || admin.phoneNum.trim() === null ? this.phoneNumberEmpty() : admin.phoneNum;
              this.editadminemail = admin.email.trim() == "" || admin.email.trim() === null ? this.emailIdEmpty() : admin.email;
              this.editadminrole = admin.role.trim() == "" || admin.role.trim() === null ? this.roleEmpty() : admin.role;

              if (this.editadminrole == 'CORPORATE_OTHERS') {
                this.roleOthers();
                this.editadminroleothers = admin.roleName.trim() == "" || admin.roleName.trim() === null ? this.roleOtherEmpty() : admin.roleName;
              }
              this.editAdminContactId = admin.groupAdminId;
            }

            setTimeout(() => {
              this.getcoverflow1()
            }, 1000);

            const dom: HTMLElement = this.elementRef.nativeElement;


            if (this.useCreditCard == true) {
              const element: any = dom.querySelector('#creditpaymentInfo');
              if (element != null) element.click();
            } else if (this.padPayment == true) {
              const element: any = dom.querySelector('#padcreditpaymentInfo');
              if (element != null) element.click();
            } else {
              const element: any = dom.querySelector('#invoicepaymentInfo');
              if (element != null) element.click();
            }


            if (this.waitTime == 0) {
              const element: any = dom.querySelector('#nowaitingPeriod');
              if (element != null && element != undefined)
                element.click();
            } else if (this.waitTime == 3) {
              const element: any = dom.querySelector('#threemonths');
              if (element != null && element != undefined)
                element.click();
            } else if (this.waitTime == 6) {
              const element: any = dom.querySelector('#sixmonths');
              if (element != null && element != undefined)
                element.click();
            } else {
              const element: any = dom.querySelector('#customselection');
              this.logger.log(element);
              if (element != null || element != undefined)
                element.click();
            }

            this.advisorsData = [{
              'name': response.data.parentName,
              'phone': response.data.parentPhone,
              'email': response.data.parentEmail
            }];
            this.selectedPlans = response.data.plans;
            if(response.data.setUplevelofCoverage==false){
              this.paidByCompany = response.data?.defaultTier?.plans?.paidByCompany ?? []
              this.coveredByCompany = response.data?.defaultTier?.plans?.coveredByCompany ?? []
              this.paidByEmployee = response.data?.defaultTier?.plans?.paidByEmployee ?? []
            }else if(response.data.setUplevelofCoverage==true){
              let tiers = response.data?.corporateTiers?.filter(tier=>tier?.status?.toLowerCase()=='active') ?? []
              for(let i=0;i<tiers.length;i++){
                this.paidByCompany = [...this.paidByCompany, tiers[i]?.plans?.paidByCompany]
                this.coveredByCompany = [...this.coveredByCompany, tiers[i]?.plans?.coveredByCompany]
                this.paidByEmployee = [...this.paidByEmployee, tiers[i]?.plans?.paidByEmployee]
              }
            }else{
              this.paidByCompany = response.data?.plans?.paidByCompany ?? []
              this.coveredByCompany = response.data?.plans?.coveredByCompany ?? []
              this.paidByEmployee = response.data?.plans?.paidByEmployee ?? []
            }
            this.allUniquePlansByType = [];
const seen = new Set();

const allPlansWithType = [
  ...(this.paidByCompany ?? []).map(p => ({ ...p, planType: 'Paid by Company' })),
  ...(this.coveredByCompany ?? []).map(p => ({ ...p, planType: 'Covered by Company' })),
  ...(this.paidByEmployee ?? []).map(p => ({ ...p, planType: 'Paid by Employee' }))
];

for (const plan of allPlansWithType) {
  if (!seen.has(plan.planLevelId)) {
    seen.add(plan.planLevelId);
    this.allUniquePlansByType.push(plan);
  }
}

            this.generate_Invite_Link = response.data.genericLink;
            this.loginLink = response.data.loginUrl;
            this.waitTime = response.data.waitTime;
            this.logo = response.data.logo;
            this.currentLogo = response.data.logo;
            this.corporateEmployeesInitialSignupWaittime = response.data.corporateEmployeesInitialSignupWaittime;
            this.setUplevelofCoverage = response.data.setUplevelofCoverage;
            this.employeeList = response.data.employees;
            this.employeeList1 = this.employeeList.sort((a, b) => a.firstName.localeCompare(b.firstName));


            // this.employeeList.sort((a, b) => {
            //   if (a.status < b.status) {
            //     return -1;
            //   }
            //   if (a.status > b.status) {
            //     return 1;
            //   }
            //   return 0;
            // });
            this.employeeList = response.data.employees.sort((a, b) => {
              const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };
              if (a.status && b.status) {
                if (order[a.status] !== order[b.status]) {
                  return order[a.status] - order[b.status];
                }
              }
              const result = a.firstName.localeCompare(b.firstName);
              return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
            });

            this.employeeList = this.employeeList.map(item => {
              if (item.hasOwnProperty('email') && item['email'] != "" && item['email'] != null && item['email'] != undefined) {
                const splitMail = item.email.split('@');
                const maskedEmail = splitMail[0].slice(0, 4) + '...@' + splitMail[1].slice(0, 2) + '...';
                return { ...item, maskedEmail };
              }
              else {
                return item;
              }
            });

            this.finalEmpResult = this.employeeList
            this.setupWallet = response.data.setupWallet;
            this.corporateTierPlans = response.data.coportaeTiersWithPlans;
            this.loginEmail = response.data.loginMain;
            this.CorpName = response.data.corporationName;

            this.requireEmpName = response.data.requireEmployeeName

            sessionStorage.setItem("corporateClientName", response.data.corporationName)
            this.clientregform.get('corporationName').setValue(response.data.corporationName);
            this.streetAddress = response.data.streetAddressLine1;
            this.streetAddress2 = response.data.streetAddressLine2;
            this.apt = response.data.apt;
            this.city = response.data.city
            this.Province = response.data.province;
            // this.province = response.data.proviceShortName;
            if(response.data.proviceShortName == "" || response.data.proviceShortName == " " || response.data.proviceShortName == undefined || response.data.proviceShortName == null){
              let pro = response.data.province.trim();
              let wp = response.data.working_provinces.find(item => item.name == pro);
              this.province = wp?.shortName
            }else{
              this.province = response.data?.proviceShortName
            }
            this.postalCode = response.data?.postalCode;

            this.address = this.streetAddress + ", " + this.streetAddress2 + ", " + this.apt + ", " + this.city + ", " + this.province + ", " + this.postalCode;

            setTimeout(() => {
              this.headerComponent.GetDetails();
            }, 2000);
            // this.headerComponent.GetDetails();
            // this.policyStartDate = response.data.policyStartDate;
            this.policyStartDate = this.datePipe.transform(
              response.data.policyStartDate,
              'MM-dd-yyyy') || "";

            // if (this.policyStartDate) {
            //   if (this.enrollmentDates && !this.enrollmentDates.includes(this.policyStartDate)) {
            //     // Add policyStartDate to the beginning of the array
            //     this.enrollmentDates.unshift(this.policyStartDate);
            //   }
            // }

            let newEnrollmentDates = [...this.enrollmentDates];
            if (this.policyStartDate && !newEnrollmentDates.includes(this.policyStartDate)) {
              newEnrollmentDates.unshift(this.policyStartDate);
            }
            this.enrollmentDates = newEnrollmentDates;

            if (response.data.corporateSelectedBulkPlans) {
              if (response.data.corporateSelectedBulkPlans.length > 0) {
                this.bulkPlans = response.data.corporateSelectedBulkPlans;
                
                this.showEmployeeValue = response.data.corporateSelectedBulkPlans[0].quantity;
                this.headcountcheck = response.data.corporateSelectedBulkPlans[0].quantity;
                this.bulkPlansLevelId = response.data.corporateSelectedBulkPlans[0].planLevelId;
              }
            }
            // if (this.paidByCompany.length > 0 || this.coveredByCompany.length > 0 || this.paidByEmployee.length > 0) {
            //   this.singupLinkDisplay = true;
            // }
            // else {
            //   this.singupLinkDisplay = false;
            // }

            this.memberCards = response.data.corpEmployeeMemberCards;
            this.memberCards = this.memberCards.sort((a, b) => a.name.localeCompare(b.name));

            //ROE getting the latest one
            this.currentROE = response?.data?.roes[0]?.roe;
            this.corporateBooklets = response?.data?.corporateBooklets?.booklets ?? [];
            this.corporateBooklets = this.corporateBooklets.sort((a, b) => a.name.localeCompare(b.name));
            this.corporateMyResorces = response.data.corporatePlanBenefits.corporatePlansBenefits;
            this.dashboardMyplans = response.data.dashboardPlans;
            
            const seen1 = new Set();
            this.dashboardMyplans = response.data.dashboardPlans.filter(plan => {
              if (seen1.has(plan.planLevelId)) {
                return false;
              } else {
                seen1.add(plan.planLevelId);
                return true;
              }
            });

            const contents = []
            if (this.corporateMyResorces.length > 0) {
              // Remove "Download Card" from the content string
              if (this.corporateMyResorces[0].content) {
                this.corporateMyResorces[0].content = this.corporateMyResorces[0].content.replace(/<li><a class="healthcard".*?<\/li>​/s, '');
              }
              this.corporateMyResorces.forEach(resource => {
                if (resource.content) {
                  resource.content = resource.content.replace(/\u200B/g, '');
                }
              });
            }
            console.log(this.corporateMyResorces);


            setTimeout(() => {
              this.getcoverflow();
              const dom: HTMLElement = this.elementRef.nativeElement;
              let modalContent = dom.querySelector(".site") as HTMLElement;
              if (modalContent) {
                modalContent.style.color = 'white';
                // modalContent.style.fontSize = '16px';
              }
              const dom1: HTMLElement = this.elementRef.nativeElement;
              let modalContent1 = dom1.querySelector(".greenshieldFooter") as HTMLElement;
              if (modalContent1) {
                modalContent1.style.margin = '0px !important';
                // modalContent.style.fontSize = '16px';
              }
            }, 2000);


            // this.corporateMyResorces = [
            //   {
            //     "name": "Greenshield",
            //     "description": "Health & Dental Insurance",
            //     "planProductName": null,
            //     "backgroundColor": "#FFFFFF",
            //     "backgroundImage": "app/resources/images/plans/GreenshieldHeader.png",
            //     "logo": "app/resources/images/plans/Greenshield.png",
            //     "color": "#8BC63E",
            //     "link": "https://www.greenshield.ca/",
            //     "content": "<ul class=\"greenshield plan_benefits_content\"> \n    <li><a class=\"booklet\" href=\"{{booklet_link}}\" >View your Plan Benefits</a></li>​\n    ​<li><a class=\"healthcard\" href=\"{{health_card_link}}\" >Download Card</a></li>​\n    ​<li><a class=\"video\" href=\"https://4ykn77m8nwqg-hls-push.5centscdn.com/mp4/greenshield_claims.mp4\" >How to Submit Claims Online</a></li>​\n    ​<li>Claims Line: <span class=\"contact\" href=\"#\">1-888-711-1119</span></li>​\n    ​</ul>",
            //     "footer": "<p><a class=\"greenshield site\" href=\"https://www.greenshield.ca/\">Visit Greenshield </a></p>",
            //     "video": "",
            //     "iframe": true,
            //     "provider": "GreenShield Canada"
            //   }
            // ];
            // if (this.corporateMyResorces.length > 0) {
            //   this.corporateMyResorces = this.corporateMyResorces
            // }


            this.useCreditCard = response.data.useCreditCard  //true
            this.padPayment = response.data.padPayment   //false
            this.customerid = response.data.corporateClientId;
            // this.country = response.data.country;
            this.country = response.data.country.trim();
            this.paymentMethod = response.data.paymentMethod;
            this.paymentMethodId = response.data.paymentMethodId;
            this.multiProvinceSelectedValues = response.working_provinces;
            console.log('multiProvinceSelectedValues:', this.multiProvinceSelectedValues);


            // this.multiProvinceSelectedValues = await this.getprovincelistselection(this.country);
            this.multiProvinceSelectedValues = await this.getprovincelistselection_v2(this.country);
            console.log('multiProvinceSelectedValues:', this.multiProvinceSelectedValues);

            // this.provinceDisplayString = this.multiProvinceSelectedValues
            //   .map(p => p.shortName)
            //   .join(', ');
            //   console.log('provinceDisplayString:', this.provinceDisplayString);



            if (this.paymentMethod === null || this.paymentMethod === "") {
              $('#paymentInformation-modal1').show();
            }

            // if (this.useCreditCard) {
            if (this.paymentMethod == 'CREDIT_CARD') {
              this.paymentMethodHeader = 'Credit Card';
              this.changeToPadLabel = 'Change to PAD';
              this.updateCCLabel = 'Update Credit Card';
              this.paymentMethod = 'CREDIT_CARD'
            }
            // else if (this.padPayment || this.paymentMethod=='ACH') {
            else if (this.paymentMethod == 'ACH') {
              this.paymentMethodHeader = 'Pre-Authorized Debit (PAD)';
              this.changeToPadLabel = 'Change to Credit Card';
              this.updateCCLabel = 'Update PAD';
              this.paymentMethod = 'ACH'
            } else {
              this.paymentMethod = 'NONE'
            }


            if (response.data?.useCreditCard == false && response.data?.padPayment == false && response.data.ccDetails?.length == 0) {
              this.useCreditCard = true;
              this.changeToPadLabel = 'Add PAD';
              this.updateCCLabel = 'Add Credit Card';
            }
            if (this.useCreditCard) {
              this.changePaymentSelection('creditCard');
            } else {
              this.changePaymentSelection('preAuthorizedDebit');
            }

            this.achDetails = response.data?.corporateACHdetails;
            if (this.achDetails && this.achDetails.status == '200') {
              if (this.achDetails.data != null && this.achDetails.data != "" && this.achDetails != undefined) {
                this.bankId = this.achDetails.data.bankCode;
                this.transit = this.achDetails.data.transitNumber;
                this.account = this.achDetails.data.accountNumber;
                this.bankNameNdAddress = this.achDetails.data.bankDetails.bank.name + " " + this.achDetails.data.bankDetails.address;
                this.generatePADaggrement = this.achDetails.data.padAgreement;
              }
            }

            this.ccDetails = response.data?.ccDetails??[];
            // setTimeout(() => {
            if (this.ccDetails.length > 0) {
              let filteredCards = this.ccDetails.filter(card => card.defaultCard === true);
              this.ccDetails.filter(card => {
                if (card.defaultCard === true) {
                  this.cardExpiry = card.expirationMonth + "/" + card.expirationYear;
                  this.ccFirstName = card.firstName;
                  this.ccLastName = card.lastName;
                  this.creditcardNumber = card.maskedCardNumber;
                  this.logger.log("this.cardExpiry: " + this.cardExpiry + "  " + this.creditcardNumber)
                  this.updateExpiryStatus(this.cardExpiry);
                }
              }
              );
              this.logger.log("this.ccDetails: " + JSON.stringify(this.ccDetails))
            }
            // }, 1000);


            this.enrolldCount = response.data.enrolldCount;
            this.invitationSentCount = response.data.invitationSentCount;
            this.invitationPendingCount = response.data.cancelCustomerCount;


            this.multiSelectProviance = JSON.parse(response.data.corporteWorkingProvince) || "";
            this.logger.log("this.multiSelectProviance: " + JSON.stringify(this.multiSelectProviance));
            // this.multiSelectProviance = [12, 22]
            var numberArray = this.multiSelectProviance.map(str => parseInt(str, 10));
            this.logger.log("numberArray: " + JSON.stringify(numberArray));
            this.getprovincelistselection1(this.country, numberArray);
            setTimeout(() => {
              this.selectedFocusVariabl = this.selectedProvinceList;
              // this.selectedFocusVariabl = [{ "id": 12, "shortName": "ON" }]
              this.client['multiSelectProviance'].setValue(this.selectedFocusVariabl);
              this.logger.log(this.selectedFocusVariabl);
            }, 500);
            setTimeout(() => {
              this.provincelist(this.province);
            }, 700);



            //plans data

            sessionStorage.setItem('summaryBlock1', '[]');
            sessionStorage.setItem('summaryBlockBulk', '[]');


            sessionStorage.setItem('walletConfig', '{}');
            // sessionStorage.setItem('selectedPlans', '{}');
            sessionStorage.setItem('summaryBlock1main', '[]');
            sessionStorage.setItem('summaryBlock1opt', '[]');
            // sessionStorage.setItem('selectedBlock1', '{}');
            sessionStorage.setItem('summaryBlock2', '[]');

            // sessionStorage.setItem('summaryBlock2main', '[]');
            sessionStorage.setItem('summaryBlock2opt', '[]');
            // sessionStorage.setItem('selectedBlock2', '{}');

            sessionStorage.setItem('summaryBlock3', '[]');

            sessionStorage.setItem('summaryBlock3main', '[]');
            sessionStorage.setItem('summaryBlock3opt', '[]');
            sessionStorage.setItem(
              'requireEmployeeName',
              this.clientregform.value.ShowEmployer
            );



          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );


    // this.logger.log(await this.ccc()+"222")
    // this.logger.log("dddd: " + JSON.stringify(d));
    // this.logger.log(await this.ccc() + "5555")
    // this.logger.log("details: " + JSON.stringify(details))


  }


  moments(date: string | undefined): moment.Moment {
    if (date)
      return moment((new Date(date)).toJSON())
    else
      return moment();
  }
  employeeStatus(event: any) {

    this.employeeStatusValue = event.target.value

    // alert(this.employeeStatusValue)

    if (event.target.value == "All") {
      // let filteredResult = this.finalEmpResult.filter(data => data.status == event.target.value);
      this.employeeList = this.finalEmpResult
      setTimeout(() => {
        this.getcoverflow()
      }, 100);

    }
    else {
      let filteredResult = this.finalEmpResult.filter(data => data.status == event.target.value);
      this.employeeList = filteredResult
      setTimeout(() => {
        this.getcoverflow()
      }, 100);
    }






  }

  async getDetailsBulkplans() {
    var token: any = 'Bearer ' + sessionStorage.getItem('accessToken');
    var details = await fetch(environment.apiUrl + '/api/cp/admin/corporate/' + this.corpId + '/details', { headers: this.commonApiAlgo.apiHeaders() });
    var response = await details.json();
    this.logger.log("d: " + JSON.stringify(response))
    if (response.status == 200) {
      if (response.data.corporateSelectedBulkPlans) {
        if (response.data.corporateSelectedBulkPlans.length > 0) {
          this.bulkPlans = response.data.corporateSelectedBulkPlans;
          this.showEmployeeValue = response.data.corporateSelectedBulkPlans[0].quantity;
          this.headcountcheck = response.data.corporateSelectedBulkPlans[0].quantity;
          this.bulkPlansLevelId = response.data.corporateSelectedBulkPlans[0].planLevelId;
        }
      }
    } else {
    }
    // this.logger.log(await this.ccc()+"222")
    // this.logger.log("dddd: " + JSON.stringify(d));
    // this.logger.log(await this.ccc() + "5555")
    // this.logger.log("details: " + JSON.stringify(details))
  }

  public changeToCCorPAD(input: any) {
    this.logger.log("changeToPadLabel: " + input);
    if (input == 'Change to PAD' || input == "Update PAD" || input == 'Add PAD') {
      this.changePaymentSelection('preAuthorizedDebit');
    }

    if (input == 'Update Credit Card' || input == 'Change to Credit Card' || input == 'Add Credit Card') {
      this.changePaymentSelection('creditCard');
    }

    $('#paymentInformation-modal').show();
  }

  get getPaymentMethodControls() {
    return this.paymentMethodForm.controls;
  }
  get padPaymentControls() {
    return this.padInformationForm.controls;
  }
  get creditCardControls() {
    return this.creditCardForm.controls;
  }
  voidcheckupload(event: any) {
    this.logger.log("voidcheckupload: " + event)
    sessionStorage.setItem('voidcheckupload', event);
    this.generatePADaggrement = "";
    var fileExtension = '.' + event.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.voidcheckfile = event.target.files[0];
    this.uploadedVoidName = event.target.files[0].name;
    this.logger.log("uploadedVoidName: " + this.uploadedVoidName)
    this.logger.log(this.voidcheckfile);

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;
    let message = '';
    this.voidCheckFileType = this.voidcheckfile.type;
    sessionStorage.setItem('voidCheckFileType', this.voidCheckFileType)
    var reader = new FileReader();
    if (allowedMimes.includes(this.voidcheckfile.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.voidcheckfile.size <= maxFileSize) {
        //1MB
        error = false;
        if (this.voidcheckfile.type.startsWith('application/pdf')) {
          this.logger.log("this.voidcheckfile: " + this.voidcheckfile)
          // this.isImage = this.isImageFile(this.voidcheckfile.name);
          this.isImage = true;
          // Handle PDF

          reader.readAsArrayBuffer(this.voidcheckfile);
          reader.onload = () => {
            this.imagedisplayvoid = reader.result;
            // sessionStorage.setItem('voidCheckImg', this.imagedisplayvoid)
            // this.logger.log("imgedisplayvoid pdf: " + this.imagedisplayvoid)
          };

        } else {
          this.isImage = false;
          // var reader = new FileReader();
          reader.readAsDataURL(this.voidcheckfile);
          reader.onload = (_event) => {
            this.imagedisplayvoid = reader.result;
            // this.logger.log("imagedisplayvoid: " + this.imagedisplayvoid)
            // sessionStorage.setItem('voidCheckImg', this.imagedisplayvoid)
          };
        }
        sessionStorage.setItem('voidCheckImg', this.imagedisplayvoid)
        // this.showvoidcheck = false;
        // this.voidcheckuploadafter = true;
        this.voidPreviewButtonVisible = true;
        sessionStorage.setItem('voidCheque', this.voidcheckfile);
        var fileExtension = '.' + this.voidcheckfile.name.split('.').pop();
        let corporateDetails = JSON.parse(sessionStorage.getItem("corporateDetails"))
        let bankDetails = sessionStorage.getItem('session');
        if (bankDetails == null) {
          let inputData = this.bankDetailsInput1();
          bankDetails = btoa(JSON.stringify(inputData));
        }
        // let addressobject = "";


        let addressobject = {
          "apt": this.apt, "address1": this.streetAddress,
          "address2": this.streetAddress2, "city": this.city,
          "province": this.Province, "postalCode": this.postalCode,
          "phone": corporateDetails.phone, "email": this.loginEmail
        }

        var formData: any = new FormData();
        // const words = corporateDetails.corporateName.split(" ");
        // var corporateName = "";
        // this.logger.log("words.length: " + words.length)
        // for (let i = 0; i < words.length; i++) {
        //   corporateName += words[i][0].toUpperCase() + words[i].substr(1)+" ";
        // }
        // formData.append("firstName", corporateName.trim());
        formData.append("firstName", this.CorpName);
        formData.append("lastName", "");
        formData.append("address", JSON.stringify(addressobject));
        formData.append("bank", JSON.stringify(this.verifydBankDetails));
        formData.append("files", this.voidcheckfile, "void_cheque_" + Date.now() + fileExtension.toLowerCase());
        // formData.append("files", this.bankfile.name,"void.pdf");
        formData.append("session", bankDetails) || "";
        formData.append("timestamp", new Date().getTime());
        formData.append("adminName", sessionStorage.getItem('groupContactName'));
        formData.append("corporateId", parseInt(sessionStorage.getItem('corporateId')));



        var accessToken = sessionStorage.getItem('accessToken');
        var endPoint = '/api/cp/admin/corporate/generateCorporatePAD';
        this.http
          .post(environment.apiUrl + endPoint, formData, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'corpId': this.corpId,
            },
          })
          .subscribe((response: any) => {

            if (response.status == 200) {
              // this.cdr.detectChanges();
              // this.voidCheckUploadDetailsEmpty1();
              // $("#PADpafaggrement1-modal").show();
              // this.generatePADaggrement = "";
              this.reviewPadSign = true;
              this.logger.log("response.data.url: " + response.data.url)
              let timestamp = new Date().getTime();
              // this.generatePADaggrement = response.data.url ? timestamp = ${ timestamp }: "";
              // this.generatePADaggrement = '';
              this.generatePADaggrement = response.data.url ? `${response.data.url}?timestamp=${timestamp}` : '';

              // this.generatePADaggrement = this.generatePADaggrement1(response.data.url);
              this.generatePADaggrementres = response.data;
              // this.cdr.detectChanges();
            }

          })
        this.logger.log("uploadedVoidName: " + this.uploadedVoidName)
        this.padPaymentControls['padDetailsVoidUpload'].setValue(this.uploadedVoidName + "");
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 1Mb';

        message = `File size is too large,maximum file size is 5 MB`
        alert(message);
      }
    } else {
      error = true;
      this.voidCheckUploadDetailsEmpty();
      message = 'Invalid file type. Only jpg, png image, pdf files are allowed.';
      alert(message);
    }

    event.target.value = null;
  }
  showPad() {
    // $("#PADpafaggrement1-modal").show();
    $("#PADpafaggrement1-modal").modal('show');
  }
  hidePad() {
    $("#PADpafaggrement1-modal").hide();
  }

  public creditcardpaysubmit1(value: Event, value1: any) {
    this.logger.log("creditcardpaysubmit1 " + value1)
    if (this.creditCardForm.invalid) {
      this.logger.log("this.creditCardForm: " + this.creditCardForm.value);
      const invalid = [];
      const controls = this.creditCardForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      this.logger.log("invalid::: " + invalid)
      this.creditCardForm.markAllAsTouched();
      return;
    }
    value.preventDefault();
    // this.customerid = result.data.customer.fusebill.customerId;
    // this.publicapikey = result.data.customer.fusebill.publicApiKey;
    // this.validationInsert1();
    value1.submit();
  }
  voidCheckUploadDetailsEmpty() {
    // this.showvoidcheck = true;
    // this.voidcheckuploadafter = false;
    // this.imagedisplayvoid = "";
    // this.voidcheckfile = "";
    // this.client['voidcheck'].reset();
    // this.signaturestatus = true;
    this.clearPad();
  }

  public startDrawing(event: Event) {
    // //this.logger.log(event);
    // this.signaturecheck = false;
    // this.signaturemessage = false;
  }
  public signaturestart(event) {
    // this.signaturecheck = false;
    // this.signaturemessage = false;
    // this.signaturecheckvalue = true;
    this.signaturecheckvalue1 = true;
    const base64Data = this.signPad.toDataURL();
    let signatureImg = base64Data;
    sessionStorage.setItem("signature", signatureImg);
  }

  padSignEnd(event: Event) {
    this.signaturecheckvalue1 = true;
    const base64Data = this.signPad.toDataURL();
    let signatureImg = base64Data;
    sessionStorage.setItem("signature", signatureImg);
  }
  clearPad() {
    this.signPad.clear();
    // this.signaturecheckvalue1 = false;
    // this.signaturecheck = true;
    // this.signaturemessage = true;
    // this.signaturecheckvalue = false;
    this.signaturecheckvalue1 = false;
    sessionStorage.setItem("signature", "");
    // this.signatureclearhide =true
  }

  bankDetailsInput1() {
    this.logger.log("this.policyStartDate: " + this.policyStartDate)
    let inputData = {
      bankCode: this.padInformationForm.value.bankCode || "",
      branchCode: this.padInformationForm.value.transit || "",
      accountNumber: this.padInformationForm.value.accountNumber || "",
      enrollmentDate: this.policyStartDate || "",
      amount: 0
    };
    return inputData;
  }

  public changePaymentSelection(event: any) {
    this.logger.log(event)
    if (event == 'preAuthorizedDebit') {
      this.paymentMethodSelect = true;
      this.getPaymentMethodControls['paymentMethodSelection'].patchValue('preAuthorizedDebit');
      this.isBankDetailsValid = false;
      this.getPaymentMethodControls['creditCardForm'].reset();
      this.selectedPaymentMethod = true;
      // this.getPaymentMethodControls['creditCardForm'].clearValidators();
      // this.clearValidators(this.getPaymentMethodControls, ['creditCardForm', 'paymentMethodSelection'])
      this.creditCardControls['ExpirationMonth'].setValue('');
      this.creditCardControls['ExpirationYear'].setValue('');
      this.bankDetailsNames = '';

    } else {
      this.paymentMethodSelect = false;
      this.getPaymentMethodControls['paymentMethodSelection'].patchValue('creditCard');
      this.selectedPaymentMethod = false;
      this.paymentMethodForm.get('padInformationForm').clearValidators();
      this.paymentMethodForm.get('padInformationForm').updateValueAndValidity();
      this.getPaymentMethodControls['padInformationForm'].reset();
      // this.padInformationForm.clearValidators();
      // this.padInformationForm.updateValueAndValidity();
      // this.getPaymentMethodControls.get('padInformationForm').
      // this.clearValidators(this.getPaymentMethodControls,['padInformationForm','paymentMethodSelection'])
      // this.clearValidators(this.getPaymentMethodControls['padInformationForm'], ['accountNumber', 'transit', 'bankCode','padDetailsVoidUpload'])
      // this.getPaymentMethodControls['padInformationForm'].clearValidators();
      // this.getPaymentMethodControls['padInformationForm'].updateValueAndValidity();
      this.bankDetailsNames = '';
    }
    // this.getPaymentMethodControls['paymentMethodSelection'].updateValueAndValidity();
    // if (event.target.value == 'creditCard') {
    // this.commonApiAlgo.updatePaymentMethod(this.selectedPaymentMethod);

    // }
  }
  public paymentMethodSubmit() {
    this.logger.log("paymentMethodSubmit")
  }
  public paymentInfoCancel() {
    this.logger.log("paymentInfoCancel")
    $("#paymentInformation-modal").hide();
    this.voidPreviewButtonVisible = false;
    // this.uploadedVoidName = "";
    this.reviewPadSign = false;
    this.padPaymentControls['padDetailsVoidUpload'].reset();
  }
  rejectPADpafaggrement2() {
    // $("#drawsignaturemodel-modal").hide()
    this.logger.log("rejectPADpafaggrement2");
    this.paymentMethodHeader = 'Pre-Authorized Debit (PAD)';
    this.changeToPadLabel = 'Change to Credit Card';
    this.updateCCLabel = 'Update PAD';
    this.padInformationForm.reset();
    this.clearPad();
    $("#drawsignaturemodel-modal").hide();
    $("#PADpafaggrement2-modal").modal('hide');
    // this.savePadsignatureROE();
    $("#paymentInformation-modal").hide();
    this.getDetails();
    window.location.reload();
  }
  closePadSignModal() {
    $("#drawsignaturemodel-modal").hide();
    this.signPad.clear();
  }
  public savePadsignature() {
    this.logger.log("savePadsignature: ")
    const base64ImageData = this.signPad.toDataURL();
    this.signImage = base64ImageData;
    $("#drawsignaturemodel-modal").hide();
    $("#PADpafaggrement1-modal").hide();

    this.generatePADaggrement = ""

    // var formData: any = new FormData();
    // formData.append("filename", this.voidcheckfile,"void_cheque_"+Date.now()+fileExtension.toLowerCase());
    // formData.append("signature",this.signImage) || "";
    // formData.append("ext",this.generatePADaggrementres.ext) || "";
    // formData.append("mimetype",this.generatePADaggrementres.mimetype) || "";
    // formData.append("filename",this.generatePADaggrementres.filename) || "";
    // formData.append("padfilename",this.generatePADaggrementres.padfilename) || "";

    let obj = {
      "signature": this.signImage,
      "ext": this.generatePADaggrementres.ext,
      "mimetype": this.generatePADaggrementres.mimetype,
      "filename": this.generatePADaggrementres.filename,
      "padfilename": this.generatePADaggrementres.padfilename,
      "url": this.generatePADaggrementres.url,
      "session": sessionStorage.getItem('session'),
      "corporateId": parseInt(sessionStorage.getItem('corporateId')),
      "adminName": sessionStorage.getItem('groupContactName'),
    }
    this.logger.log("obj: " + JSON.stringify(obj))
    var accessToken = sessionStorage.getItem('accessToken');
    var endPoint = '/api/cp/admin/corporate/updateCorporatePAD';
    this.http
      .post(environment.apiUrl + endPoint, obj, {
        // headers: {
        //   Authorization: 'Bearer ' + accessToken,
        //   'Content-Type': 'application/json',
        // },
        headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe((response: any) => {
        if (response.status == 200) {
          // this.generatePADaggrement = '';
          // this.validationInsert();
          this.logger.log("pad agreement url: " + response.data.url);
          // $("#PADpafaggrement2-modal").show();
          $("#PADpafaggrement2-modal").modal('show');
          // this.generatePADaggrement = response.data.url;
          this.isBankDetailsValid = false;
          this.reviewPadSign = false;
          let timestamp = new Date().getTime();
          this.generatePADaggrement = response.data.url ? `${response.data.url}?timestamp=${timestamp}` : '';
          sessionStorage.setItem('generatePADaggrement', response.data.url);
          // this.logger.log("pad agreement url: " + response.data.url);
          // this.generatePADaggrement = this.generatePADaggrement1(response.data.url);
          // this.signaturestatus = false
          // this.agreestatus = false

        }
        if (response.status == 202) {
          Swal.fire({ title: this.lang.Error ?? 'Error', html: "" + response.message });
        }

      })
    // setTimeout(() => {
    //   jQuery("#PADpafaggrement-modal").modal("hide");
    //   this.showmodelsign()
    // }, 10);
    // this.updateStatus(14);
  }



  openEmployeeROEModal(roe) {
    this.employeeRoe = roe;
    $('#viewRoe-employees').modal('show');
  }


getROEDetails(roe: any) {
  const rawURL = roe.link;
  console.log("Raw URL:", rawURL);

  this.employeeRoeURL = this.sanitizer.bypassSecurityTrustResourceUrl(rawURL);

  setTimeout(() => {
    $('#roeAgreement').modal('show');
    $('#viewRoe-employees').modal('hide');
  }, 100);
}




  DownloadROEContract2(roe) {
    this.logger.log("DownloadROEContract: ")
    let corporateName = sessionStorage.getItem('corporateClientName') || '';
    let name = this.convertString(corporateName);
    let dateTime = this.getCurrentFormattedDateTime();
    // this.currentROE = sessionStorage.getItem('generateROEpdfRESurl');
    this.http.get(roe, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        // const corpoateName = this.clientregform.value.corporationName || "";
        const corpoateName = "";
        const fileName = name + "ROE_GroupBenefitz_" + dateTime + ".pdf";
        saveAs(blob, fileName);
      },
      err => {
        this.logger.log("err->", err);
      }
    );
  }


  signaturestartmodel() {
    $("#drawsignaturemodel-modal").show()
  }


  numberOnly(event: any): boolean {
    return this.commonMethods.numberOnly(event);
  }
  // openROEModal() {
  
  //   this.logger.log("openROEModal" + this.currentROE)
  //   $('roeModal#').modal('show');
  //   this.roeUrl = this.currentROE;
  // }

roeUrl: string = '';
// isPdfLoading: boolean = false;

// openROEModal(pdfUrl: string) {
//   this.isPdfLoading = true;       // Start spinner
//   this.roeUrl = pdfUrl;

//   setTimeout(() => {
//     $('#roeModal').modal('show');
//   }, 0); // No delay needed
// }

openROEModal() {
  console.log('Opening ROE Modal');
  console.log("openROEModal " + this.currentROE);
  this.logger.log("openROEModal " + this.currentROE);

  this.isPdfLoading = true; // Show spinner
  this.roeUrl = this.currentROE;
  console.log("roeUrl", this.roeUrl);

  setTimeout(() => {
    $('#roeModal').modal('show');
  }, 5000); // Keep your existing timeout
}
// Called once PDF is fully loaded
onPdfLoadComplete() {
  this.isPdfLoading = false;
}


//   openROEModal() {
//   console.log('Opening ROE Modal');
//   console.log("openROEModal " + this.currentROE)
//   this.logger.log("openROEModal " + this.currentROE);

//   this.roeUrl = this.currentROE;
//   console.log("roeUrl", this.roeUrl)

//   setTimeout(() => {
//     $('#roeModal').modal('show');
//   }, 5000);
// }



  openPADModal() {
    this.logger.log("openPADModal")
    this.loaderservice.ShowLoader();

      setTimeout(()=>{

    $('#padModal').modal('show');
    this.loaderservice.HideLoader();
  },1000)
    // console.log("padUrl",this.padUrl);
   
    this.padUrl = this.generatePADaggrement;
     console.log("padUrl",this.padUrl);

  }

  selectedSubCategories: string[] = [];

onSubCategoryToggle(sub: any, event: any) {
  if (event.target.checked) {
    this.selectedSubCategories.push(sub.id);
  } else {
    this.selectedSubCategories = this.selectedSubCategories.filter(id => id !== sub.id);
  }

  console.log('Selected:', this.selectedSubCategories);
}



//   openPADModal() {
//   this.logger.log("openPADModal");
// this.loaderservice.ShowLoader();
  
//   const base64 = this.generatePADaggrement;
//   this.padUrl = base64?.startsWith('data:application/pdf;base64,')
//   ? base64
//   : 'data:application/pdf;base64,' + base64;
  
//   setTimeout(()=>{

//     $('#padModal').modal('show');
//     this.loaderservice.HideLoader();
//   },1000)
//   console.log("padUrl", this.padUrl);
// }



//   openPADModal() {
//   this.logger.log("openPADModal");
  
//   // Show modal first
//   $('#padModal').modal('show');

//   // Wait for modal to be fully visible before setting the URL
//   $('#padModal').on('shown.bs.modal', () => {
//     const base64String = this.generatePADaggrement;
//     const fullBase64Url = base64String.startsWith('data:application/pdf;base64,')
//       ? base64String
//       : 'data:application/pdf;base64,' + base64String;

//     this.padUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullBase64Url)['changingThisBreaksApplicationSecurity'];
//     console.log("padUrl", this.padUrl);
//   });
// }



  changePADndROE(input: string): void {
    this.logger.log("changePADndROE: " + input)
    const timestamp = new Date().getTime();
    if (input === 'PAD') {
      this.logger.log("generatePADaggrement: " + this.generatePADaggrement)
      //   this.padAndRoeUrlAssign = this.generatePADaggrement
      // ? `${this.generatePADaggrement.toString()}?timestamp=${timestamp}`
      // : '';
      this.roeUrl = this.generatePADaggrement;
      // this.roePadHeader = "PAD Agreement"

    }

    // else if (input === 'ROE') {
    //   this.padAndRoeUrlAssign = ""
    //     ? `${"".toString()}?timestamp=${timestamp}`
    //     : '';
    //   this.roePadHeader = "Record of Enrollment";

    // }
  }

  DownloadROEContract() {
    this.logger.log("DownloadROEContract: ")
    let corporateName = sessionStorage.getItem('corporateClientName') || '';
    let name = this.convertString(corporateName);
    let dateTime = this.getCurrentFormattedDateTime();
    // this.currentROE = sessionStorage.getItem('generateROEpdfRESurl');
    this.http.get(this.currentROE, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        // const corpoateName = this.clientregform.value.corporationName || "";
        const corpoateName = "";
        const fileName = name + "ROE_GroupBenefitz_" + dateTime + ".pdf";
        saveAs(blob, fileName);
      },
      err => {
        this.logger.log("err->", err);
      }
    );
  }

  membershipcardsNodataFound: any;
  isMembercardsavail: boolean = false;
  viewHealthCard(input: any) {
    // this.memberhealthCardurl = input.card;

    if (input.cards.length > 0) {
      this.isMembercardsavail = false;
      this.mergePDFs(input.cards);
    }
    else {
      this.isMembercardsavail = true;
      this.membershipcardsNodataFound = "No Data Found"
    }

    // this.mergePDFs([
    //   "https://testcorporateapi.groupbenefitz.aitestpro.com/api/cp/app/server//ROE_CORP_889_1710400796496.pdf",
    //   "https://testcorporateapi.groupbenefitz.aitestpro.com/api/cp/app/server//ROE_CORP_889_1710400796496.pdf",
    //   "https://testcorporateapi.groupbenefitz.aitestpro.com/api/cp/app/server//ROE_CORP_889_1710400796496.pdf",
    // ]);
  }


  async DownloadContractMemberBooklets(urls: any) {
    // const urls = [
    //   "https://testcorporateapi.groupbenefitz.aitestpro.com/api/cp/app/server//ROE_CORP_889_1710400796496.pdf",
    //   "https://testcorporateapi.groupbenefitz.aitestpro.com/api/cp/app/server//ROE_CORP_889_1710400796496.pdf",
    //   "https://testcorporateapi.groupbenefitz.aitestpro.com/api/cp/app/server//ROE_CORP_889_1710400796496.pdf"
    // ];
    const promises = urls.map(url =>
      this.http.get(url, { responseType: "arraybuffer" }).toPromise()
    );
    Promise.all(promises).then(async pdfs => {
      const mergedPdf = await PDFDocument.create();

      for (const pdfBytes of pdfs) {
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
        copiedPages.forEach(page => mergedPdf.addPage(page));
      }

      const mergedPdfBytes = await mergedPdf.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const fileName = "MembershipBooklet.pdf"; // You can customize the file name here
      saveAs(blob, fileName);
    }).catch(error => {
      console.error("Error downloading PDFs:", error);
    });
  }

  DownloadContractPAD() {
    // let corporateName = sessionStorage.getItem('corporateClientName') || '';
    // let name = this.convertString(corporateName);
    // let dateTime = this.getCurrentFormattedDateTime();
    this.http.get(this.generatePADaggrement, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        // const fileName = name + "PAD_Agreement_GroupBenefitz_" + dateTime + ".pdf";
        const fileName = this.padFileName();
        saveAs(blob, fileName);
      },
      err => {
        this.logger.log("err->", err);
      }
    );
  }
  viewBooklet(bookletObject: any, index: any) {
    this.loaderservice.ShowLoader();
    setTimeout(() => {
      this.loaderservice.HideLoader();
    }, 3000);
    const timestamp = new Date().getTime();
    this.bookletUrlLink = bookletObject.link ? `${bookletObject.link.toString()}?timestamp=${timestamp}` : "";
    this.logger.log(" this.bookletUrlLink: " + this.bookletUrlLink);
    this.logger.log(" bookletObject.link.toString(): " + bookletObject.link.toString());
    $('#bookletView-modal').modal('show');
    // $('#bookletView-modal').show();
    // $('#roeModal').modal('show');
  }

  downloadHpbooklet(bookletObject: any, index: any) {
    // let corporateName = sessionStorage.getItem('corporateClientName') || '';
    // let name = this.convertString(corporateName);
    // let dateTime = this.getCurrentFormattedDateTime();
    this.http.get(bookletObject.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        // const fileName = name + "PAD_Agreement_GroupBenefitz_" + dateTime + ".pdf";

        let cleanedString = bookletObject.name.replace(/[^a-zA-Z_\s]/g, ''); // Removes non-alphabetic characters except underscore
        cleanedString = cleanedString.replace(/\s/g, '_');
        const fileName = cleanedString;
        saveAs(blob, fileName);
      },
      err => {
        this.logger.log("err->", err);
      }
    );
  }

  moved(e: any) {
  }

  padFileName() {
    let corporateName = sessionStorage.getItem('corporateClientName') || '';
    let name = this.convertString(this.commonMethods.firstLetterCapitalizeForEachWord(corporateName));
    let dateTime = this.getCurrentFormattedDateTime();
    return name + "PAD_Agreement_GroupBenefitz_" + dateTime + ".pdf";
  }
  convertString(input: any) {
    // Replace spaces with underscores
    let result = input.replace(/ /g, '_');
    // Remove special characters
    result = result.replace(/[^a-zA-Z0-9_]/g, '');
    // if (result !=='' && result !== null && result !== undefined) {
    //   result+"_"
    // }
    return result + "_";
  }
  getCurrentFormattedDateTime() {
    // Create a new Date object to represent the current date and time
    const currentDate = new Date();

    // Get the individual components of the date and time
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1
    const year = currentDate.getFullYear();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();

    // Format the date and time components
    const formattedDateTime = `${day < 10 ? '0' : ''}${day}_${month < 10 ? '0' : ''}${month}_${year}_${hours < 10 ? '0' : ''}${hours}_${minutes < 10 ? '0' : ''}${minutes}_${seconds < 10 ? '0' : ''}${seconds}`;

    // Return the formatted date and time
    return formattedDateTime;
  }

  verifybankdetails1() {
    let inputData = this.bankDetailsInput1();
    this.logger.log("inputData: " + inputData)
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/bank/verify';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, inputData, {
        // headers: {
        //   Authorization: 'Bearer ' + accessToken,
        //   'Content-Type': 'application/json',
        // },
        headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            // this.voidbankDetails = true;
            this.isBankDetailsValid = true;
            this.voidPreviewButtonVisible = false;
            // this.uploadvoidcheckclear();
            // this.client['voidcheck'].setValidators([Validators.required]);
            // this.client['voidcheck'].updateValueAndValidity();
            this.padPaymentControls['padDetailsVoidUpload'].setValidators([Validators.required]);
            this.padPaymentControls['padDetailsVoidUpload'].updateValueAndValidity();
            // // this.imagedisplayvoid = "";
            // // this.voidcheckfile = "";
            this.logger.log("verifywwbankdetails1 response: " + response);
            this.bankverifyDetails = response.data;
            let bankAddress = this.bankverifyDetails.address
            let bankAdressArr = bankAddress.split(",")
            let provincePostal = bankAdressArr[bankAdressArr.length - 1];
            let provincePostalArr = provincePostal.split(" ")
            let bankobject =
            {
              "name": this.bankverifyDetails.bank.name,
              "address": this.bankverifyDetails.bank.address.split(",")[0],
              "city": bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
              "province": provincePostalArr[provincePostalArr.length - 3],
              "postalCode": provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1]
            }

            this.bankNameNdAddress = this.bankverifyDetails.bank.name + " " + bankAddress;
            this.logger.log("bankobject: " + JSON.stringify(bankobject))
            this.verifydBankDetails = bankobject;
            var encBank = btoa(JSON.stringify(inputData));
            this.logger.log("encBank: " + encBank)
            sessionStorage.setItem('session', encBank);
            // var verifyBankDetails = "<br><div style='font-size: 14px; font - family: sans - serif; margin - top: 16px; text - align: left;'>" + bankobject.name + "<br>" + bankobject.address + "<br>" + bankobject.city + "<br>" + bankobject.province + "<br>" + bankobject.postalCode +"</div>";
            // var verifyBankDetails = "<div style='font-size: 14px;'>Bank details verified successfully. Proceed to upload Void Cheque</div> <div style='margin-top: 10px; border: 1px solid black; opacity: 0.5;' ><table style='margin-left: 5px;'> <tr> <td style='font-size: 14px; font-family: sans-serif; margin-top: 16px; text-align: left;'> " + bankobject.name + "<br>" + bankobject.address + "<br>" + bankobject.city + "<br>" + bankobject.province + "<br>" + bankobject.postalCode + "</td></tr></table></div>";
            this.bankDetailsNames = bankobject.name + "\n" + bankobject.address + "\n" + bankobject.city + "\n" + bankobject.province + "\n" + bankobject.postalCode;
            // Swal.fire({ title: 'Success', text: 'Bank details verified successfully. Proceed to upload Void Cheque'  })
            // Swal.fire({ title: 'Success', html: "" + verifyBankDetails });
            // this.generatePADaggrement = '';
            Swal.fire({ title: 'Success', html: "Verification Successful" });
            // this.client['voidcheck'].value('');
            // alert(bankobject.name + "\n" + bankobject.address + "\n" + bankobject.city + "\n" + bankobject.province + "\n" + bankobject.postalCode)
            Swal.fire({
              title: 'Success',
              html: 'Verification Successful',
              // icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                const dom: HTMLElement = this.elementRef.nativeElement;
                let modalContent = dom.querySelector("#Modall") as HTMLElement;
                this.logger.log("adfa: " + modalContent)
                setTimeout(() => {
                  if (modalContent) {
                    modalContent.scrollTo(0, modalContent.scrollHeight);
                  }
                }, 500);

              }
            });

          }
          else {
            // this.voidbankDetails = false
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
          }
        },
        (error) => {
          this.logger.log(error)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.message })
        }
      );
  }
  bankDetailsClear() {
    this.padInformationForm.reset();
    this.padInformationForm.updateValueAndValidity();
    this.bankDetailsNames = "";
    this.isBankDetailsValid = false;
    this.voidPreviewButtonVisible = false;
    // this.uploadedVoidName = "";
    this.reviewPadSign = false;
    this.padPaymentControls['padDetailsVoidUpload'].reset();
  }
  public formatCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      inputVal = inputVal.match(/.{1,4}/g).join(' ');
    }

    this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  // public numberFormateChange() {
  //   this.logger.log("creditCardControls['CardNumber']: " + this.creditCardControls['CardNumber'].value)
  //   let cardnumber = this.creditCardControls['CardNumber'].value;
  //   if (cardnumber.length == 4 || cardnumber.length == 9 || cardnumber.length == 14)
  //     cardnumber + " ";
  //   this.creditCardForm.get('CardNumber').setValue(cardnumber);
  //     this.logger.log(" cardnumber: " + cardnumber)
  // }

  public creditcardlblurmethod(event) {
    // this.postalvalue = event.target.value
    this.logger.log("creditcardlblurmethod: ")
    this.formatCreditCardNumber(event)
    let val = event.target.value;
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2
    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }
      // Add the units element to the checksum total
      checksum = checksum + calc;
      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    //Check if it is divisible by 10 or not.
    // return (checksum % 10) == 0;
    if (checksum % 10 == 0) {
      this.invalidcreditcard = false;
    } else {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length == 0) {
      this.invalidcreditcard = false;
    }
  }

  public changeexpirymonth(event) {
    let today;
    let someday;

    let expiryyear;

    // if (this.paymentForm.get("ExporationYear").value) {
    //   expiryyear = "20" + this.paymentForm.get("ExporationYear").value;
    // } else {
    //   expiryyear = this.paymentForm.get("ExporationYear").value;
    // }


    if (this.creditCardControls["ExpirationYear"]?.value) {
      expiryyear = "20" + this.creditCardControls["ExpirationYear"]?.value;
    } else {
      expiryyear = this.creditCardControls["ExpirationYear"]?.value;
    }
    let expirymonth = event.target.value;

    var oneDate = moment();
    var yearName = oneDate.format("YYYY");

    var oneMonth = moment();
    var MonthName = oneMonth.format("MM");

    if (expiryyear == yearName) {
      if (expirymonth < MonthName) {
        this.showexpirymontherror = true;
        this.futureexpiredate = false;
      } else {
        this.showexpiryyearerror = false;
        this.showexpirymontherror = false;
        today = this.addMonths(new Date(), +6);
        someday = new Date();

        someday.setFullYear(expiryyear, event.target.value, 0);

        if (someday >= today) {
          this.futureexpiredate = false;
        } else {
          this.futureexpiredate = true;
          this.showexpiryyearerror = false;
          this.showexpirymontherror = false;
        }
      }
    } else {
      this.showexpirymontherror = false;
      this.showexpiryyearerror = false;
      this.futureexpiredate = false;

      today = this.addMonths(new Date(), +6);
      someday = new Date();

      someday.setFullYear(expiryyear, event.target.value, 0);
      if (expiryyear && event.target.value) {
        if (someday >= today) {
          this.futureexpiredate = false;
        } else {
          this.futureexpiredate = true;
          this.showexpiryyearerror = false;
          this.showexpirymontherror = false;
        }
      }
    }
  }

  voidPdfEnable() {
    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;
      let element = dom.querySelector("#voidModalPdf") as HTMLElement;
      this.logger.log("voidPdfEnable: voidModalPdf");
      if (element) {
        this.logger.log("voidPdfEnable: 12121");
        element.click();
      }
    }, 500);
  }
  public addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
    // alert(date)
  }

  rightClick() {
    if (this.clickCount < this.groupContacts.length) {
      this.clickCount += 1;
    } else {
      this.clickCount = 1
    }
    const admin = this.groupContacts[this.clickCount - 1];

    this.editadminfirstname = admin.firstName.trim() == "" || admin.firstName.trim() === null ? this.firstNameEmpty() : admin.firstName;
    this.editadminlastname = admin.lastName.trim() == "" || admin.lastName.trim() === null ? this.lastNameEmpty() : admin.lastName;;
    this.editadminphone = admin.phoneNum.trim() == "" || admin.phoneNum.trim() === null ? this.phoneNumberEmpty() : admin.phoneNum;
    this.editadminemail = admin.email.trim() == "" || admin.email.trim() === null ? this.emailIdEmpty() : admin.email;
    this.editadminrole = admin.role.trim() == "" || admin.role.trim() === null ? this.roleEmpty() : admin.role;

    if (this.editadminrole == 'CORPORATE_OTHERS') {
      this.roleOthers();
      this.editadminroleothers = admin.roleName.trim() == "" || admin.roleName.trim() === null ? this.roleOtherEmpty() : admin.roleName;
    }
    this.editAdminContactId = admin.groupAdminId;

  }


  leftClick() {
    if (this.clickCount > 1) {
      this.clickCount -= 1;
    } else {
      this.clickCount = this.groupContacts.length;
    }
    const admin = this.groupContacts[this.clickCount - 1];

    this.editadminfirstname = admin.firstName.trim() == "" || admin.firstName.trim() === null ? this.firstNameEmpty() : admin.firstName;
    this.editadminlastname = admin.lastName.trim() == "" || admin.lastName.trim() === null ? this.lastNameEmpty() : admin.lastName;;
    this.editadminphone = admin.phoneNum.trim() == "" || admin.phoneNum.trim() === null ? this.phoneNumberEmpty() : admin.phoneNum;
    this.editadminemail = admin.email.trim() == "" || admin.email.trim() === null ? this.emailIdEmpty() : admin.email;
    this.editadminrole = admin.role.trim() == "" || admin.role.trim() === null ? this.roleEmpty() : admin.role;

    if (this.editadminrole == 'CORPORATE_OTHERS') {
      this.roleOthers();
      this.editadminroleothers = admin.roleName.trim() == "" || admin.roleName.trim() === null ? this.roleOtherEmpty() : admin.roleName;
    }
    this.editAdminContactId = admin.groupAdminId;

  }

  getcoverflow() {
    var TrandingSlider = new Swiper('.tranding-slider', {
      effect: 'coverflow',
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
      },
      pagination: {
        el: '.swiper-pagination',
        type: "fraction"
      },
      navigation: {
        nextEl: '.swiper-button-next2',
        prevEl: '.swiper-button-prev2',
      },
      on: {
        slideChangeTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideChangeTransitionEnd: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideNextTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slidePrevTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        }
      }
    });
    // this.logger.log(TrandingSlider.activeIndex)
  }

  getcoverflow1() {
    var TrandingSlider = new Swiper('.tranding-slider1', {
      effect: 'coverflow',
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
      },
      pagination: {
        el: '.swiper-pagination1',
        type: "fraction",
      },
      navigation: {
        nextEl: '.swiper-button-next1',
        prevEl: '.swiper-button-prev1',
      },
      on: {
        slideChangeTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideChangeTransitionEnd: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slideNextTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slidePrevTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        }
      }
    });
    // this.logger.log(TrandingSlider.activeIndex)
  }



  // getHealthBooklets() {
  //   this.logger.log('getHealthBooklets')
  //   const corpId = sessionStorage.getItem("corporateId");
  //   let Endpoint = '/customer/' + corpId + '/booklets/false/false';
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   this.http.get(environment.apiUrl + Endpoint, {
  //     // headers: {
  //     //   Authorization: 'Bearer ' + accessToken,
  //     //   'Content-Type': 'application/json',
  //     // }
  //     headers: this.commonApiAlgo.apiHeaders(),
  //   }).subscribe((response: any) => {
  //     if (response.status == 200) {
  //       this.bookletList = response.data;
  //     }
  //     else {
  //       Swal.fire({ allowOutsideClick: false, title: 'Info', text: response.message })
  //     }
  //   }, (error) => {
  //     Swal.fire({ allowOutsideClick: false, title: 'Info', text: error.error.error.message })
  //   });
  // }


  // getCustomerData() {
  //   this.logger.log('getCustomerData')
  //   const corpId = sessionStorage.getItem("corporateId");
  //   let customerDataEndpoint = '/customer/' + corpId + '/details';
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   this.http.get(environment.apiUrl + customerDataEndpoint, {
  //     // headers: {
  //     //   Authorization: 'Bearer ' + accessToken,
  //     //   'Content-Type': 'application/json',
  //     // }
  //     headers: this.commonApiAlgo.apiHeaders(),
  //   }).subscribe((response: any) => {
  //     if (response.status == 200) {
  //       var customerData = response.data;
  //       this.logger.log(customerData)
  //       this.hicList = customerData.healthCards;
  //     setTimeout(() => {
  //       this.getcoverflow();
  //     }, 1000);

  //     }
  //     else {
  //       Swal.fire({ allowOutsideClick: false, title: 'Info', text: response.message })
  //     }
  //   }, (error) => {
  //     Swal.fire({ allowOutsideClick: false, title: 'Info', text: error.error.error.message })
  //   });
  // }

  get f() {
    return this.adminform.controls;
  }

  get fe() {
    return this.editadminform.controls;
  }


  get client() {
    return this.clientregform.controls;
  }

  get settings() {
    return this.settingsform.controls;
  }


  checkPaymentInfo(e: any) {
    if (e.target.value == 'pad') {
      this.padPayment = true;
      this.useCreditCard = false;
      this.bankDetails = false;
    } else {
      this.padPayment = false;
      this.useCreditCard = true;
      this.bankDetails = false;
    }
  }


  onPaste(e: any) { e.preventDefault() }

  get corporateInfo() {
    return this.editCorporateForm.controls;
  }


  getGroupContactList() {
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var GetGroupcontacts = '/api/ap/admin/corporate/' + this.corpId + '/groupAdmins';

    this.http
      .get(environment.apiUrl + GetGroupcontacts, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        // headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            // this.groupContacts = response.data;
            this.groupContacts = response.data;

            //setting the default values
            const admin = this.groupContacts[0];

            this.editadminfirstname = admin.firstName.trim() == "" || admin.firstName.trim() === null ? this.firstNameEmpty() : admin.firstName;
            this.editadminlastname = admin.lastName.trim() == "" || admin.lastName.trim() === null ? this.lastNameEmpty() : admin.lastName;;
            this.editadminphone = admin.phoneNum.trim() == "" || admin.phoneNum.trim() === null ? this.phoneNumberEmpty() : admin.phoneNum;
            this.editadminemail = admin.email.trim() == "" || admin.email.trim() === null ? this.emailIdEmpty() : admin.email;
            this.editadminrole = admin.role.trim() == "" || admin.role.trim() === null ? this.roleEmpty() : admin.role;

            if (this.editadminrole == 'CORPORATE_OTHERS') {
              this.roleOthers();
              this.editadminroleothers = admin.roleName.trim() == "" || admin.roleName.trim() === null ? this.roleOtherEmpty() : admin.roleName;
            }
            this.editAdminContactId = admin.groupAdminId;

            this.logger.log("this.groupContacts: " + JSON.stringify(this.groupContacts));
            setTimeout(() => {
              this.getcoverflow1()
            }, 1000);
            // this.lengthofemployee = this.employeeList.length;
            // this.maxEmployees = this.employeeList.length;
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          this.logger.log(error);
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        }
      );
  }
  basicModalOpen() {
    this.adminform.reset();
    $('#basicModal1').modal('show');
    this.f['role'].setValue("");
  }

  basicEmployeeOpen() {
    sessionStorage.setItem('corporateId', this.corpId);
    // window.location.href = `/manageCorporates/${this.corpId}/viewEmployees`
    this.router.navigate([`/manageCorporates/${this.corpId}/viewEmployees`])



  }


  corporateInformation() {
    $('#corporateInfoModal').modal('show');
  }

  corpPlansNavigate() {
    this.router.navigate([`/manageCorporates/${this.corpId}/viewPlans`])
  }

  textChangeToLowerCase(formcontrolField: any) {
    this.emp[formcontrolField].setValue(
      this.emp[formcontrolField].value.toLowerCase()
    );
  }



  adminValidators() {
    this.adminform = this.formBuilder.group({
      adminfirstname: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
          Validators.pattern(this.consts.fnlnFrenchAndEnglishRegx)
        ],
      ],
      adminlastname: [
        '', [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
          Validators.pattern(this.consts.fnlnFrenchAndEnglishRegx)
        ],
      ],
      adminphone: ['', [Validators.required, Validators.minLength(17),
      Validators.maxLength(17)]],


      adminemail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.consts.emailPattern2),
        ],
      ],
      role: [''],
      roleOther: ['']
    });

    this.editadminform = this.formBuilder.group({
      adminfirstname: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
          Validators.pattern(this.consts.fnlnFrenchAndEnglishRegx)
        ],
      ],
      adminlastname: [
        '', [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
          Validators.pattern(this.consts.fnlnFrenchAndEnglishRegx)
        ],
      ],
      adminphone: ['', [Validators.required, Validators.minLength(17),
      Validators.maxLength(17)]],


      adminemail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.consts.emailPattern2),
        ],
      ],
      role: [''],
      roleOther: ['']
    });
  }

  hidegrpadmindetails() {
    this.adminform.reset();
  }

  phoneFormat(event: any) {
    const inputValue = this.adminform.get("adminphone").value;
    this.adminform.get("adminphone").setValue(this.commonMethods.transform(inputValue), { emitEvent: false });


    const editinputValue = this.editadminform.get("adminphone").value;
    this.editadminform.get("adminphone").setValue(this.commonMethods.transform(editinputValue), { emitEvent: false });
  }

  editphoneFormat(event: any) {
    const editinputValue = this.editadminform.get("adminphone").value;
    this.editadminphone = this.commonMethods.transform(editinputValue)
    this.editadminform.get("adminphone").setValue(this.commonMethods.transform(editinputValue), { emitEvent: false });
  }

  alphabatesOnly(event: any): boolean {
    return this.commonMethods.alphabatesOnly(event);
  }

  firstNameEmpty() {
    this.f['adminfirstname'].reset();
    this.fe['adminfirstname'].reset();
  }
  lastNameEmpty() {
    this.f['adminlastname'].reset();
    this.fe['adminlastname'].reset();
  }
  phoneNumberEmpty() {
    this.f['adminphone'].reset();
    this.fe['adminphone'].reset();
  }
  emailIdEmpty() {
    this.f['adminemail'].reset();
    this.fe['adminemail'].reset();
  }
  roleEmpty() {
    this.f['role'].setValue("");
    this.fe['role'].setValue("");
  }
  roleOtherEmpty() {
    this.f['roleOther'].reset();
    this.fe['roleOther'].reset();
  }

  editadmin(admin: any, index: any) {
    this.logger.log("edit admin: " + JSON.stringify(admin));
    this.editadminfirstname = admin.firstName.trim() == "" || admin.firstName.trim() === null ? this.firstNameEmpty() : admin.firstName;
    this.editadminlastname = admin.lastName.trim() == "" || admin.lastName.trim() === null ? this.lastNameEmpty() : admin.lastName;;
    this.editadminphone = admin.phoneNum.trim() == "" || admin.phoneNum.trim() === null ? this.phoneNumberEmpty() : admin.phoneNum;

    this.oldEditAdminEmail = admin.email.trim() == "" || admin.email.trim() === null ? this.emailIdEmpty() : admin.email;
    this.editadminemail = admin.email.trim() == "" || admin.email.trim() === null ? this.emailIdEmpty() : admin.email;
    this.editadminrole = admin.role.trim() == "" || admin.role.trim() === null ? this.roleEmpty() : admin.role;

    if (this.editadminrole == 'CORPORATE_OTHERS') {
      this.roleOthers();
      this.editadminroleothers = admin.roleName.trim() == "" || admin.roleName.trim() === null ? this.roleOtherEmpty() : admin.roleName;
    }
    this.editAdminContactId = admin.groupAdminId;

  }
  addadmin() {


    if (this.adminform.invalid) {
      this.logger.log(this.adminform);
      return;
    }
    this.logger.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = this.groupContactsAPIInputBody();
    obj['roleName'] = obj.role == 'CORPORATE_OTHERS' ? this.adminform.value.roleOther : "";
    this.emailAlreadyexist = false;
    for (let admin of this.groupContacts) {
      if (admin['email'] == obj['email']) {
        Swal.fire({
          title: 'Info',
          text: 'Email Already exist',
          showDenyButton: false,
          confirmButtonText: 'OK',
        }).then((res) => {
          if (res.isConfirmed) {
            this.emailAlreadyexist = true;
            return false;
          }
        });
        this.emailAlreadyexist = true;
        break;
      }
    }


    let CorpId = this.route.snapshot.params['id'];
    let endPoint = `/api/ap/admin/v2/corporate/${CorpId}/groupAdmin`;
    let accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            // Swal.f
            // Swal.fire({title:'Info',text:response.message||response.data.message});
            Swal.fire({ title: 'Info', text: response.message || response.data.message }).then((result) => {
              if (result.isConfirmed) {
                this.clientregform.reset();
                window.location.reload();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            })
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );



    // this.logger.log("admin: group contact details: " + admin);
    // let obj = {
    //   firstName: this.commonMethods.firstLetterCapitalizeForEachWord(admin.adminfirstname),
    //   lastName: this.commonMethods.firstLetterCapitalizeForEachWord(admin.adminlastname),
    //   role: admin.role,
    //   roleName: this.adminform.value.role == 'CORPORATE_OTHERS' ? this.commonMethods.firstLetterCapitalizeForEachWord(this.adminform.value.roleOther || "") : '',
    //   email: admin.adminemail,
    //   phoneNum: admin.adminphone,
    // }
  }


  updateSettings() {


    if (this.settingsform.invalid) {
      this.logger.log(this.settingsform);
      return;
    }
    if (this.settingsform.value.waitingPeriod == 'Custom') {
      this.settingsform.value.waitingPeriod = Number(this.waitTime)
      this.settingsform.value.waitingPeriodCustom = this.waitTime
    }

    this.logger.log(JSON.stringify(this.settingsform.value, null, 2));

    let obj = this.settingsAPIInputBody();


    let CorpId = this.route.snapshot.params['id'];
    let endPoint = `/api/ap/admin/corporate/${this.corpId}/settings`;
    let accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            // Swal.f
            // Swal.fire({title:'Info',text:response.message||response.data.message});
            Swal.fire({ title: 'Info', text: response.message || response.data.message }).then((result) => {
              if (result.isConfirmed) {
                this.settingsform.reset();
                window.location.reload();
                // $('#closeButton').click();
                // this.getDetails();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            })
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );



    // this.logger.log("admin: group contact details: " + admin);
    // let obj = {
    //   firstName: this.commonMethods.firstLetterCapitalizeForEachWord(admin.adminfirstname),
    //   lastName: this.commonMethods.firstLetterCapitalizeForEachWord(admin.adminlastname),
    //   role: admin.role,
    //   roleName: this.adminform.value.role == 'CORPORATE_OTHERS' ? this.commonMethods.firstLetterCapitalizeForEachWord(this.adminform.value.roleOther || "") : '',
    //   email: admin.adminemail,
    //   phoneNum: admin.adminphone,
    // }
  }
  deleteadmin() {



    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_group_contact,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {

      if (result.isConfirmed) {
        let admin = this.groupContacts[this.clickCount - 1]
        if (this.groupContacts.length == 1) {
          Swal.fire({
            title: this.lang.warning,
            text: this.lang.Can_t_delete_the_contact_when_there_is_only_one,
          }).then(res => {
            if (res.isConfirmed) {
              $("#basicModaldelete").modal('hide');
            }
          })
          $("#basicModaldelete").modal('hide');
          return;
        } else {
          var corporateId = sessionStorage.getItem('corporateId');
          var accessToken = sessionStorage.getItem('accessToken');
          // var deleteEmployee = '/api/cp/admin/corporate/' + corporateId + '/groupAdmin/' + admin.groupAdminId;
          var deleteEmployee = '/api/ap/admin/v2/corporate/' + this.corpId + '/groupAdmin/' + admin.groupAdminId;


          this.http
            .delete(environment.apiUrl + deleteEmployee, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
              // headers: this.commonApiAlgo.apiHeaders(),
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                  // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
                    this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                      "message": "Corporates information has been updated. Please refresh screen."
                    }, {
                      headers: {
                        Authorization: 'Bearer ' + accessToken,
                        'Content-Type': 'application/json',
                      }
                    }).subscribe((res) => {
                      console.log({ res })
                    })
                  })
                  Swal.fire({ title: 'Info', text: response.message }).then(res => {
                    if (res.isConfirmed) {
                      this.getGroupContactList();
                      this.getDetails();
                      $("#basicModaldelete").modal('hide');
                      window.location.reload();
                      this.clickCount = 1
                    }
                  })
                } else {
                  $("#basicModaldelete").modal('hide');
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
                }
              }
            );
        }
      } else {
        $("#basicModaldelete").modal('hide');
      }
    })

  }


  closeDeleteAdmin() {
    $('#basicModaldelete').model('hide')
  }
  roleOthers(type = '') {
    // this.logger.log("this.editadminrole:  " + this.editadminrole)
    let val = this.f['role'].value == 'CORPORATE_OTHERS' ? true : false;
    let valE = this.fe['role'].value == 'CORPORATE_OTHERS' ? true : false;
    // let val = this.editadminrole == 'CORPORATE_OTHERS' ? true : false;
    if (val) {
      // if (this.editadminroleothers) {
      //   this.f['roleOther'].setValue(this.editadminroleothers);
      // } else {
      // }
      this.f['roleOther'].setValidators([Validators.required]);
      this.f['roleOther'].updateValueAndValidity();
    }
    if (valE) {
      this.fe['roleOther'].setValidators([Validators.required]);
      this.fe['roleOther'].updateValueAndValidity();
    }
    else {
      this.f['roleOther'].clearValidators();
      this.f['roleOther'].updateValueAndValidity();
      this.fe['roleOther'].clearValidators();
      this.fe['roleOther'].updateValueAndValidity();
      // this.f['roleOther'].reset();
    }
    return type == 'edit' ? valE : val;
  }

  editadminSubmit() {
    this.logger.log("editadminSubmit: 123");
    if (this.editadminform.invalid) {
      this.logger.log(this.editadminform);
      return;
    }
    this.logger.log(JSON.stringify(this.editadminform.value, null, 2));

    // let obj = {
    //   firstName: this.capitalize(this.adminform.value.adminfirstname),
    //   lastName: this.capitalize(this.adminform.value.adminlastname),
    //   phoneNum: this.adminform.value.adminphone,
    //   email: this.adminform.value.adminemail,
    //   role: this.adminform.value.role,
    // };
    let obj = this.editGroupContactsAPIInputBody();
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var editGroupContact = '/api/ap/admin/v2/corporate/' + this.corpId + '/groupAdmin/' + this.editAdminContactId;
    this.http
      .put(environment.apiUrl + editGroupContact, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.clientList = this.clientList.map(client =>
              client.id == this.corpId ? { ...client, email: obj.email } : client
            );
            this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))
            this.store.dispatch(loadCorporateData())

            this.checkUserIsAnyWhere(this.oldEditAdminEmail)

            Swal.fire({ title: 'Info', text: this.lang.Group_admin_details_updated_successfully }).then(res => {
              if (res.isConfirmed) {
                this.clickCount = 1
                this.getcoverflow();
                $("#basicModaledit").modal("hide");
                this.getGroupContactList();
              }
            })
            // window.location.reload();

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }
      );
  }

  multiSelectProvianceItemSelect(event: any) {
    this.multiSelectProviancenames.push(event);
    this.logger.log("event: " + JSON.stringify(event));
    this.multiSelectProviance.push(Number(event.id));
    this.logger.log("this.multiSelectProvianc12e: " + this.multiSelectProviance);
    this.logger.log("this.multiSelectProviance: " + JSON.stringify(this.multiSelectProviance));
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }

  multiSelectProvianceSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    event.forEach((proviance: any) => {
      this.multiSelectProviance.push(proviance.id);
      this.multiSelectProviancenames.push({ "id": proviance.id, "shortName": proviance.shortName });

    });
    this.logger.log(this.multiSelectProviance);
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }
  multiSelectProvianceItemDeSelect(event: any) {
    this.logger.log(event);
    let indexOf = this.multiSelectProviance.indexOf(event.id);
    this.multiSelectProviancenames.splice(indexOf, 1);
    this.multiSelectProviance.splice(indexOf, 1);
    this.logger.log(this.multiSelectProviance);

    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);

  }
  multiSelectProvianceItemDeSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];
    this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }

  async getprovincelistselection(event: any) {

    this.logger.log("getprovincelistselection: " + event, this.countryList);
    setTimeout(() => {
      if (this.countryList.length > 0) {
        this.countryList.forEach((element: any) => {
          this.configprovincereslist = []
          if (element.name == event) {
            this.configprovincereslist = element.countryStates || [];
          }
          this.configprovincereslist = [...this.configprovincereslist].sort(
            (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
          );
        });
      }
      // this.logger.log("configprovincereslist: " + this.configprovincereslist);
      // this.configprovincereslist.forEach(element => {
      //   this.provincesShortNames += ", " + element.shortName;
      // });
      // this.provincesShortNames = this.provincesShortNames.substring(2);

      // this.logger.log("this.provincesShortNames: " + this.provincesShortNames)
      // this.logger.log("this.configprovincereslist : " + JSON.stringify(this.configprovincereslist))
    }, 2000);
  }
  provinceDisplayString: string = '';


  async getprovincelistselection_v2(event: any) {
    console.log("called after province", this.countryList, event)
    this.logger.log("getprovincelistselection: " + event, this.countryList);
    this.countryList.forEach((element: any) => {
      if (element.name == event) {
        this.configprovincereslist = element.countryStates;
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    });
   
      // this.logger.log("configprovincereslist: " + this.configprovincereslist);
      // this.configprovincereslist.forEach(element => {
      //   this.provincesShortNames += ", " + element.shortName;
      // });
      // this.provincesShortNames = this.provincesShortNames.substring(2);
 
      // this.logger.log("this.provincesShortNames: " + this.provincesShortNames)
      // this.logger.log("this.configprovincereslist : " + JSON.stringify(this.configprovincereslist))
  }

  // async getprovincelistselection1(event: any, selectedList: any) {
  //   this.logger.log("getprovincelistselection: " + event);
  //   if (this.multiSelectDropdown) {
  //     this.multiSelectDropdown.closeDropdown();
  //   }
  //   let uniqueSet = new Set(selectedList);
  //   selectedList = Array.from(uniqueSet);
  //   setTimeout(() => {
  //     if (this.countryList)
  //       this.countryList.forEach((element: any) => {
  //         if (element.name == event) {
  //           this.configprovincereslist1 = element.countryStates;
  //           const stateIdNamePairs: { [key: string]: string } = {};
  //           this.configprovincereslist1.forEach((state: any) => {
  //             // if (selectedList.includes(state.id)) {
  //             //   this.logger.log(state);
  //             // }
  //             for (var i = 0; i < selectedList.length; i++) {
  //               if (selectedList[i] == state.id) {
  //                 this.logger.log("state: " + state);
  //                 this.selectedProvinceList.push(state);
  //               }
  //             }
  //             // this.logger.log("this.selectedProvinceList: " + JSON.stringify(this.selectedProvinceList))
  //             stateIdNamePairs[state.id] = state.shortName;
  //           });
  //           this.logger.log("State Id and Name Pairs: ", JSON.stringify(stateIdNamePairs));
  //           // this.logger.log("configprovincereslist1 selected: " + JSON.stringify(this.configprovincereslist1));
  //           this.configprovincereslist1 = [...this.configprovincereslist1].sort(
  //             (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //           );

  //           // this.logger.log("configprovincereslist1 after: " + JSON.stringify(this.configprovincereslist1));
  //           const selectedNames = [...new Set(selectedList.map(id => stateIdNamePairs[id]).filter(name => name !== undefined))]
  //           if (selectedNames.length > 0) {
  //             this.multiProvinceSelectedValues = selectedNames.join(', ');
  //           }
  //           this.logger.log("Selected Names: ", this.multiProvinceSelectedValues);
  //         }
  //       });
  //     // this.logger.log("this.configprovincereslist1: " + JSON.stringify(this.configprovincereslist1))
  //   }, 500);
  // }
  async getprovincelistselection1(event: any, selectedList: any) {
    this.logger.log("getprovincelistselection: " + event);
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
    let uniqueSet = new Set(selectedList);
    selectedList = Array.from(uniqueSet);
    setTimeout(() => {
      if (this.countryList) {
        this.countryList.forEach((element: any) => {
          if (element.name == event.trim()) {
            this.configprovincereslist1 = element.countryStates;
            const stateIdNamePairs: { [key: string]: string } = {};
            this.selectedProvinceList = [];

            this.configprovincereslist1.forEach((state: any) => {
              if (selectedList.includes(state.id)) {
                this.selectedProvinceList.push(state);
              }
              stateIdNamePairs[state.id] = state.shortName;
            });

            this.configprovincereslist1 = [...this.configprovincereslist1].sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );

            const selectedNames = Array.from(
              new Set(
                selectedList
                  .map(id => stateIdNamePairs[id])
                  .filter(name => name !== undefined)
              )
            );

            if (selectedNames.length > 0) {
              this.multiProvinceSelectedValues = selectedNames.join(', ');
            }

            this.logger.log("Selected Names: ", this.multiProvinceSelectedValues);
          }
        });
      }
    }, 500);
  }


  groupContactsAPIInputBody() {
    let obj = {
      firstName: this.commonMethods.firstLetterCapitalizeForEachWord(this.adminform.value.adminfirstname),
      lastName: this.commonMethods.firstLetterCapitalizeForEachWord(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
      roleName: this.adminform.value.role == 'CORPORATE_OTHERS' ? this.commonMethods.firstLetterCapitalizeForEachWord(this.adminform.value.roleOther) : '',
    };
    this.logger.log("group contact Body: ", JSON.stringify(obj));
    return obj;
  }


  settingsAPIInputBody() {
    let obj = {
      waitingPeriod: this.settingsform.value.waitingPeriod,
      setupWallet: this.settingsform.value.walletConfig,
      setUplevelofCoverage: this.settingsform.value.tierConfig,
      exptNumofEmp: +this.settingsform.value.expectednoofEmployees,
      cpPlanAutoSelection: this.settingsform.value.autoSelectEmp,
      cpPlansSelectionLocked: this.settingsform.value.cpPlansSelectionLocked,
      requireEmployeeName: this.settingsform.value.ShowEmployer,
      corporateEmployeesInitialSignupWaittime: this.settingsform.value.waitingPeriodinitialsignup,
      useCreditCard: this.useCreditCard,
      padPayment: this.padPayment
    };
    this.logger.log("group contact Body: ", JSON.stringify(obj));
    return obj;
  }


  editGroupContactsAPIInputBody() {
    let obj = {
      firstName: this.commonMethods.firstLetterCapitalizeForEachWord(this.editadminform.value.adminfirstname),
      lastName: this.commonMethods.firstLetterCapitalizeForEachWord(this.editadminform.value.adminlastname),
      phoneNum: this.editadminform.value.adminphone,
      email: this.editadminform.value.adminemail,
      role: this.editadminform.value.role,
      roleName: this.editadminform.value.role == 'CORPORATE_OTHERS' ? this.commonMethods.firstLetterCapitalizeForEachWord(this.editadminform.value.roleOther) : '',
    };
    this.logger.log("group contact Body: ", JSON.stringify(obj));
    return obj;
  }


  public capitalize(str: any) {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }

  updateCorpInfoDate() {

  }
  async checkNameExists() {
    if (this.client['corporationName']?.value) {
      // let isExist = this.apiCommonService.checkCorporationNameIsExist(this.CorpName);
      const corpnameSession = sessionStorage.getItem('corporateClientName');
      this.logger.log("corpnameSession: " + corpnameSession + " :: " + this.CorpName);
      if (corpnameSession && this.client['corporationName']?.value.toLowerCase() != corpnameSession.toLowerCase()) {
        let isExist = this.checkCorporationNameIsExist(this.CorpName);
      }
    }
  }

  async checkCorporationNameIsExist(input: any) {
    let isExist: boolean;
    var accessToken = sessionStorage.getItem('accessToken');
    var obj: any = {
      name: input
    };
    this.logger.log("obj isExist: " + JSON.stringify(obj));
    await this.http
      .post(environment.apiUrl + '/api/cp/admin/corporate/checkCorporateName', obj, {
        // headers: {
        //   Authorization: 'Bearer ' + accessToken,
        //   'Content-Type': 'application/json',
        // },
        headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe((response: any) => {
        this.logger.log("checkCorporationNamesExist: " + JSON.stringify(response));
        if (response.status == 200) {
          if (response.data.count != 0) {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: 'Corporation Name already exists' });
            this.client['corporationName'].reset();
            this.client['corporationName'].markAsTouched();
            this.logger.log("checkCorporationNameIsExist: true" + isExist);
            isExist = true;
            this.logger.log("checkCorporationNameIsExist: true" + isExist);
          } else {
            isExist = false;
          }

        }
        else if (response.data.count != 0) {
          if (response.data.count != 0) {
            this.client['corporationName'].reset();
            this.client['corporationName'].markAsTouched();
            Swal.fire({ title: this.lang.Error ?? 'Error', text: 'Corporation Name already exists' });
            this.logger.log("checkCorporationNameIsExist: true" + isExist);
            isExist = true;
            this.logger.log("checkCorporationNameIsExist: true" + isExist);
          } else {
            isExist = false;
          }
        }
      });
    // this.logger.log("return : " + isExist)
    // return isExist;
  }

  public updateCorporateAddress() {
    this.logger.log("updateCorporateAddress;");

    // api/ap/admin/v2/corporate/customer/validation
    var endPoint = '/api/ap/admin/corporate/' + this.corpId + '/primaryInfo';
    var accessToken = sessionStorage.getItem('accessToken');

    let currentTimestamp = new Date().getTime();
    this.logger.log("corporationName: " + this.client['corporationName']?.value)


    let logoDetails = '';
    if (this.uploadadminlogoimg) {
      (logoDetails = this.uploadadminlogoimg),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadadminlogoimg.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }



    var obj = {
      "corporationName": this.clientregform.get('corporationName').value || "",
      "policyStartDate": this.client['PolicyStartDate']?.value || "",
      "polisyStartDateUpdate": false,
      "provinceId": this.provincelistid || "",
      "state": this.statename,
      "stateId": this.state_id,
      "country": this.client['country']?.value || "",
      "countryId": 1,
      "timestamp": currentTimestamp + "",
      "apt": this.client['apt']?.value || "",
      "streetAddressLine1": this.client['streetAddress']?.value || "",
      "streetAddressLine2": this.client['streetAddress2']?.value || "",
      "postalCode": this.client['postalCode']?.value || "",
      "city": this.client['city']?.value || "",
      "province": this.client['Province']?.value || "",
      "workingProvinces": this.multiSelectProviance.map(item => Number(item)),
      "logo": logoDetails
    };


    var form = new FormData();
    form.append("apt", this.client['apt']?.value);
    form.append("provinceId", this.provincelistid);
    form.append("city", this.client['city']?.value);
    form.append("logo", logoDetails);
    form.append("stateId", this.state_id);
    form.append("state", this.statename);
    form.append("streetAddressLine1", this.client['streetAddress']?.value);
    form.append("countryId", '1');
    form.append("workingProvinces", JSON.stringify(this.multiSelectProviance.map(item => Number(item))));
    form.append("corporationName", this.clientregform.get('corporationName').value);
    form.append("timestamp", `${currentTimestamp}`);
    form.append("country", this.client['country']?.value);
    form.append("polisyStartDateUpdate", 'false');
    form.append("policyStartDate", this.client['PolicyStartDate']?.value);
    form.append("postalCode", this.client['postalCode']?.value);



    var requestOptions: any = {
      method: 'PUT',

      body: form,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };



    this.loaderservice.ShowLoader()

    fetch(environment.apiUrl + endPoint, requestOptions)
      .then((response) => response.text())
      .then((response: any) => {
        response = JSON.parse(response);
        this.loaderservice.HideLoader()
        this.clientList = this.clientList.map(client =>
          client.id == this.corpId ? { ...client, name: obj.corporationName } : client
        );
        this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
        // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
            "message": "Corporates information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })
        Swal.fire({
          title: 'Info', text: response.message,
          showDenyButton: false,
          // showCancelButton: true,
          confirmButtonText: 'Ok',
        }).then((result) => {
          this.logger.log("result: " + result)
          if (result.isConfirmed) {
            $('#updateCorpInfo2').modal('hide');
            this.getDetails();
            // window.location.reload();
            sessionStorage.setItem('corporateClientName', obj?.corporationName ?? "")
          }
        });
      }).catch(err => {
        this.loaderservice.HideLoader()
      })





  }

  changeTextToUppercase(field: any, event: any) {
    this.logger.log(field);
    // const obj = {};
    // obj[field] = this.clientregform.controls[field].value.toUpperCase();
    // this.clientregform.patchValue(obj);
    this.postalvalue = event.target.value;
    this.logger.log("(this.postalvalue: " + this.postalvalue);
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      // this.logger.log("r")
      this.invalidpostalcodeprivince = true;
      this.client['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }

    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
    //  postalcodeValidator1(this.invalidpostalcodeprivince )
    if (this.clientregform.get('country')?.value.toLowerCase() == 'usa') {
      this.invalidpostalcodeprivince = false;
      // return;
    };
  }

  public getprovincelist(event: any) {
    this.countryList.forEach((element: any) => {
      if (element.name == event.target.value) {
        this.configprovincereslist = element.countryStates;
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    });
    if (event.target.value.toLowerCase() == 'canada') {
      this.stateLabel = this.lang.Province;
      this.selectedCountry = 'Canada';
      this.zipCodeLabel = this.lang.Postal_Code;
      this.clientregform.get('postalCode').setValidators(Validators.compose([postalcodeValidator, Validators.required]));
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.clientregform.get('postalCode').reset();
    } else {
      this.clientregform.get('postalCode').reset();
      this.clientregform.get('postalCode').clearValidators();
      this.clientregform.get('postalCode').updateValueAndValidity();
      // this.clientregform.get('postalCode').setValidators(Validators.compose([postalcodeValidator]));
      this.clientregform.get('postalCode').setValidators(Validators.required);
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.stateLabel = this.lang.State;
      this.selectedCountry = 'USA';
      this.zipCodeLabel = this.lang.Zip_Code;
      this.invalidpostalcodeprivince = false;
    }
    // this.updateStatusAddress();
  }


  public provincelist(event: any) {
    this.logger.log("provincelist: " + this.clientregform.get('country')?.value);
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    if (this.clientregform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.clientregform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        //  this.logger.log("test")
        // this.clientregform.controls['postalCode'].markAllAsTouched
        // this.clientregform.get(['postalCode'])?.markAsTouched()
        this.client['postalCode'].markAsTouched();
        this.client['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
        // this.logger.log("test1")
      }

      if (this.clientregform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        // this.logger.log("test11")
      }
    }
    if (this.clientregform.get('country')?.value) {


      if (this.clientregform.get('country')?.value.toLowerCase() == 'usa') {
        this.invalidpostalcodeprivince = false;
        // return;
      };
    }
    // this.updateStatus(1);
  }

  getDraftInvoices() {
    this.logger.log("calling")
    var corporateId = sessionStorage.getItem("corporateId")
    var endPoint = '/api/ap/admin/corporate/' + this.corpId + '/draftInvoice'
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
        // headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {
          this.draftInvoice = response.data.invoiceData;
          this.logger.log(this.draftInvoice)
          $('#draftInvoice-modal').modal('show');
          this.logger.log("response: " + JSON.stringify(response))
        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }

      }, (error) => {
        if (error.status == 400 || error.status == 401 || error.status == 402 || error.status == 403) {

          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Proceed',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // sessionStorage.clear()
              // this.router.navigate(['/login']);
            }
          });
        }
        else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: 'Something went wrong' });

        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });
  }


  downloadInvoice(invoice: any, index:any) {
    console.log(invoice.link)
    this.http.get(invoice?.link ?? invoice?.invoice ?? invoice?.file, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        // const fileName = invoice?.customer?.firstName + "_" + this.corpId + "_" + this.invoiceMonthsList[index] + ".pdf";
        const fileName = (this.corpDetails?.corporationName != undefined ? this.corpDetails?.corporationName+"_" : "Invoice_") + this.corpId.toString() + "_" + moments(invoice.dueDate).format('MMM-YYYY') + ".pdf";
        console.log(fileName)
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
    // this.logger.log("test")
    // this.selectedInvoiceIndex = index;
    // if (this.invoicesArr &&
    //   this.selectedInvoiceIndex >= 0 &&
    //   this.selectedInvoiceIndex < this.invoicesArr.length) {
    //   let dueDates = this.datePipe.transform(this.invoicesArr[this.selectedInvoiceIndex].dueDate, 'MMM yyyy');
    //   const fileName = `Invoice_${this.invoicesArr[this.selectedInvoiceIndex]?.invoiceId}_${dueDates}.pdf`;
    //   this.commonMethods.downloadPdf(this.invoicesArr[this.selectedInvoiceIndex]?.file, fileName);
    // }
  }


  customSelectedfunction() {
    this.customSelected = true;
  }
  waitingPeriodChange(e: any) {
    if (e.target.value == 'Custom') {
      this.customSelected = true;
      this.settingsform.get('waitingPeriodCustom').setValidators(Validators.required);
    } else {
      this.customSelected = false;
      this.settingsform.get('waitingPeriodCustom').reset();
      this.settingsform.get('waitingPeriodCustom').clearValidators();
    }
    this.settingsform.get('waitingPeriodCustom').updateValueAndValidity();
  }



  //update the corporate details

  updateCorporateInformation() {


    var endPoint = '/api/ap/admin/v2/corporate/customer/validation';
    var accessToken = sessionStorage.getItem('accessToken');

    let currentTimestamp = new Date().getTime();
    this.logger.log("corporationName: " + this.client['corporationName']?.value)

    var formdata = new FormData();

    formdata.append(
      'corporationName',
      this.clientregform.value.corporationName
    );

    formdata.append('brokerType', 'CORPORATE');
    formdata.append(
      'workingProvinces',
      JSON.stringify(this.multiSelectProviance)
    );
    formdata.append('cpPlanAutoSelection', 'false');

    formdata.append(
      'policyStartDate',
      this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00'
    );

    formdata.append('logo', this.logo);

    formdata.append('fuseBillCustomerCreation', 'true');

    formdata.append('voidCheck', '');

    formdata.append('gropupAdmin', JSON.stringify(this.groupContacts));
    let waitingPeriod;
    if (this.customSelected && this.clientregform.value.waitingPeriod == 'Custom') {
      waitingPeriod = this.clientregform.value.waitingPeriodCustom || 0;

    } else {
      waitingPeriod = this.clientregform.value.waitingPeriod || 0;
    }

    formdata.append(
      'waitingPeriod',
      waitingPeriod || 0
    );

    formdata.append(
      'corporateEmployeesInitialSignupWaittime',
      'false'
    );

    formdata.append('useCreditCard', this.paymentMethod == 'creditcard' ? 'true' : 'false');

    // formdata.append('invoicePayment', invoicemonthy ? 'true' : 'false');
    //Invoices are not using so send as false
    formdata.append('invoicePayment', this.paymentMethod == 'creditcard' ? 'false' : 'false');

    formdata.append('padPayment', this.paymentMethod == 'pad' ? 'true' : 'false');

    formdata.append('session', sessionStorage.getItem('session'));

    formdata.append('setupWallet', 'false');

    formdata.append(
      'setUplevelofCoverage',
      'false'
    );

    formdata.append(
      'exptNumofEmp',
      this.clientregform.value.expectednoofEmployees || 0
    );

    formdata.append(
      'streetAddressLine1',
      this.capitalize(this.clientregform.value.streetAddress) || ''
    );

    formdata.append(
      'streetAddressLine2',
      this.capitalize(this.clientregform.value.streetAddress2) || ''
    );
    formdata.append('apt', '');

    formdata.append('city', this.capitalize(this.clientregform.value.city));

    formdata.append('province', this.clientregform.value.Province);

    formdata.append('provinceId', this.provincelistid);

    formdata.append('state', this.clientregform.value.Province);

    formdata.append('stateId', this.state_id);

    formdata.append('country', this.clientregform.value.country);

    formdata.append('countryId', '1');
    formdata.append('fbcountryId', '124');
    formdata.append('parentId', this.clientregform.value.brokerName || '');

    formdata.append('postalCode', this.clientregform.value.postalCode);
    formdata.append(
      'corporateClientId',
      this.customerid ||
      environment.corporateClientId
    ); //fusebillid
    formdata.append(
      'corporateId',
      this.corpId || '0'
    ); //corporateid


    var requestOptions: any = {
      method: 'POST',

      body: formdata,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };


    fetch(environment.apiUrl + endPoint, requestOptions)
      .then((response) => response.text())
      .then(
        (response: any) => {
          response = JSON.parse(response);
          if (response['status'] == 200) {
            Swal.fire({
              title: 'Info', text: response.message,
              showDenyButton: false,
              // showCancelButton: true,
              confirmButtonText: 'Ok',
            }).then((result) => {
              this.logger.log("result: " + result)
              if (result.isConfirmed) {
                $('#updateCorpInfo').modal('hide');
                this.getDetails();
                // setTimeout(() => {
                // window.location.reload();
                // }, 1000);


              }
            });
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })


          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          this.logger.log(error);
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        });


  }
  public getCustomerInvoices() {
    var accessToken = sessionStorage.getItem('accessToken');
    // let fusbillid = this.corpDetails.fusebillCustomerId ?? this.corpDetails.corporateParentCustomer.fusebillCustomerId
    let fusbillid = this.corpDetails.corporateParentCustomer.id
    let customerDataEndpoint = '/customer/' + fusbillid + '/invoices/list';


    this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        this.customerFinalInvoices = response.data;
        // this.customerFinalInvoices.sort((a, b) => {
        //   const dateA: any = new Date(a.dueDate || a.invoiceDate);
        //   const dateB: any = new Date(b.dueDate || b.invoiceDate);
          
        //   return dateB - dateA; // Descending order
        // });

        this.customerFinalInvoices.sort((a, b) => {
          const dateA = new Date(a.dueDate || a.invoiceDate).getTime();
          const dateB = new Date(b.dueDate || b.invoiceDate).getTime();

          if (dateA !== dateB) {
            return dateB - dateA; // Descending by date
          }

          // If dates are equal, sort by invoiceNumber descending
          if (a.invoiceNumber > b.invoiceNumber) return -1;
          if (a.invoiceNumber < b.invoiceNumber) return 1;
          return 0;
        });

        // this.allCustomerFinalInvoices = response.data
        this.allCustomerFinalInvoices = this.customerFinalInvoices;
        this.invoiceMonthsList = response.invoiceMonthsList




      }
      else {
        // Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      // Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });

  }

  getInvoices() {
    var accessToken = sessionStorage.getItem('accessToken');
    var endPoint = '/api/ap/admin/corporate/' + this.corpId + '/invoices';
    var endPoint1 = '/api/ap/customer/' + this.corporateParentCustomer?.id + '/get-invoices';

    let invoices1: any = [];
    let invoices2: any = [];

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      }).subscribe(async (response: any) => {
        if (response['status'] == 200) {

          invoices1 = await response.data;


          console.log("invoicesArr1: ", invoices1);
          this.http
            .get(environment.apiUrl + endPoint1, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            }).subscribe(async (response1: any) => {
              if (response['status'] == 200) {
                console.log("response: " + response1);
                invoices2 = await response1.data;
                console.log({ invoices2 })
                console.log("invoicesArr2: " + this.invoicesArr);
                this.invoicesArr = [...invoiceFilter(invoices1, invoices2)]
                console.log(invoices1, invoices2)
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }

            });

        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }
      });
  }

  async formConfig() {
    // var endPoint = '/api/ap/admin/corporateSignup/formConfig';
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   }).subscribe((response: any) => {
    //     if (response['status'] == 200) {
    //       // this.statesInfo = response.data.states;
    //       // this.walletConfig = response.data.walletConfig;
    //       // this.payrolldeduction = response.data.payRolldeductionUI
    //       // this.countryList = response.data.countryList
    //       this.countryList = response.data.allCountrys;

    //       this.walletConfig = response.data.walletConfig;

    //       this.multiSlectProviances = response.data.countryList[0].countryStates;
    //       this.multiSlectProviances = this.multiSlectProviances.sort(
    //         (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //       );
    //       // this.countryList.array.forEach(element => {
    //       //   if (element.name == 'canada') {
    //       //     this.canadaCountry = element.name;
    //       //   }
    //       // });
    //       // for (var list of this.countryList) {
    //       //   if (list.name == 'canada') {
    //       //     this.canadaCountry = element;
    //       //   }
    //       // }

    //       this.configprovinceres = response.data.states.sort((a: any, b: any) =>
    //         a.shortName > b.shortName ? 1 : -1
    //       );

    //       this.enrollmentDates = response.data.planEnrollmentDatesFullMonth;

    //       this.getDetails();

    //     } else {
    //       Swal.fire({ title: this.lang.Error??'Error', text: response.message });
    //     }

    //   }, (error) => {
    //     if (error.status == 400 || error.status == 401 || error.status == 402 || error.status == 403) {

    //       Swal.fire({
    //         title: this.lang.Error??'Error',
    //         text: error.error.error.message,
    //         showDenyButton: false,
    //         showCancelButton: true,
    //         confirmButtonText: 'Proceed',
    //       }).then((result) => {
    //         /* Read more about isConfirmed, isDenied below */
    //         if (result.isConfirmed) {
    //           // sessionStorage.clear()
    //           // this.router.navigate(['/login']);
    //         }
    //       });
    //     }
    //     // this.toastrService.error("Invalid Credentials", 'Error!');
    //   });

    this.store.dispatch(loadCorporateSignupConfigData());
    this.corporateSignupConfigData$ = this.store.select(state => state.corporateSignupConfigData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateSignupConfigData$.subscribe(async (data) => {
      if (data) {
        console.log(data)
        if (data?.corporateSignupConfigData == undefined || Object.keys(data.corporateSignupConfigData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (Object.keys(this.corporateSignupConfigData).length > 0) {
          this.formConfigLoading=false;
          return;
        }
        this.corporateSignupConfigData = {}
        this.multiSlectProviances = []
        this.configprovinceres = []
        // const response  = {data: data.corporateSignupConfigData}
        this.corporateSignupConfigData = { ...data.corporateSignupConfigData }
        this.countryList = this.corporateSignupConfigData.allCountrys;
        this.walletConfig = this.corporateSignupConfigData.walletConfig;
        this.multiSlectProviances = this.corporateSignupConfigData.countryList[0].countryStates;
        this.multiSlectProviances = [...this.multiSlectProviances].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        this.configprovinceres = [...this.corporateSignupConfigData.states].sort((a: any, b: any) =>
          a.shortName > b.shortName ? 1 : -1
        );
        this.enrollmentDates = this.corporateSignupConfigData.planEnrollmentDatesFullMonth;
        this.getLanguageTokens();
        this.getDetails();

        // if(this.country){
        //   this.multiProvinceSelectedValues = await this.getprovincelistselection(this.country);
        // }
        // this.getcoverflow();
        // setTimeout(() => {
        //   this.getcoverflow1()
        // }, 1000);

        // if(this.multiSelectProviance){
        //   var numberArray = this.multiSelectProviance.map(str => parseInt(str, 10));
        //   this.logger.log("numberArray: " + JSON.stringify(numberArray));
        //   this.getprovincelistselection1(this.country, numberArray);
        // }
        
        // if(this.selectedProvinceList){
        //   setTimeout(() => {
        //     this.selectedFocusVariabl = this.selectedProvinceList;
        //     // this.selectedFocusVariabl = [{ "id": 12, "shortName": "ON" }]
        //     this.client['multiSelectProviance'].setValue(this.selectedFocusVariabl);
        //     this.logger.log(this.selectedFocusVariabl);
        //   }, 500);
        // }

        // if(this.province){
        //   setTimeout(() => {
        //     this.provincelist(this.province);
        //   }, 700);
        // }

        this.formConfigLoading = false;

      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  getCustomersData() {
    this.store.dispatch(loadCorporateData());
    this.corporateData$ = this.store.select(state => state.corporateData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.clientList.length > 0) {
          return;
        }

        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.clientList = decompress(data.corporateData)
          this.clientList = data.corporateData
        } else {
          this.clientList = data.corporateData.map(res => {
            return {
              ...res,
              formsLength: res.forms?.length || 0
            }
          })
        }
        const sortedList = [...this.clientList].sort((a, b) => {
          const order = { true: 1, false: 2, cancelled: 3 };
          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }
          return a.name.trim().localeCompare(b.name.trim());
        });
        this.clientList = sortedList;
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  alphaNumarics(event: any) {
    return this.commonPatternsService.alphaNumarics(event);
  }

  showDraftInvoice() {
    this.getDraftInvoices();
    this.logger.log("showDraftInvoice")
    // setTimeout(() => {
    //   $('#draftInvoice-modal').modal('show');
    // }, 1000);


  }
  showInvoice(invoiceUrl: any, index: any): void {
    // var clickedItem = document.getElementById(`invoiceList${index}`);
    // // Call the selectItem function to handle the selection
    // this.logger.log(index)
    // if (clickedItem) {
    //   this.selectItem(clickedItem);
    // }
    this.selectedInvoiceIndex = index;
    this.selectedInvoiceUrl = invoiceUrl?.link ?? invoiceUrl?.invoice ?? invoiceUrl?.file;
    console.log("selectedInvoiceUrl: " + this.selectedInvoiceUrl)
    $('#invoice-modal').modal('show');
  }


  exportAsXLSXBulkPlans(): void {

    this.employeedata = [
      {
        label: 'Employee ID',
        key: 'employeeId',
        mandatory: true,
        display: true,
      },
      {
        label: 'First Name',
        key: 'firstName',
        mandatory: true,
        display: true,
      },
      {
        label: 'Last Name',
        key: 'lastName',
        mandatory: true,
        display: true,
      },
      {
        label: 'Email',
        key: 'email',
        mandatory: true,
        display: true,
      },
      // {
      //   label: 'Date of Hire',
      //   key: 'dateOfHire',
      //   mandatory: false,
      //   display: true,
      //   style: { numFmt: 'mm-dd-yyyy' },
      // },

      // {
      //   label: 'Country',
      //   key: 'country',
      //   mandatory: true,
      //   display: true,
      // },
      // {
      //   label: 'Province of Employment',
      //   key: 'provinceOfEmployment',
      //   mandatory: false,
      //   display: true,
      // },
      // {
      //   label: 'Job Title', //job title
      //   key: 'jobTitle',
      //   mandatory: true,
      //   display: true,
      // },
      // {
      //   label: 'Date of Birth',
      //   key: 'dateOfBirth',
      //   mandatory: false,
      //   display: true,
      //   style: { numFmt: 'mm-dd-yyyy' },
      // },
      // {
      //   label: 'Gender',
      //   key: 'gender',
      //   mandatory: true,
      //   display: true,
      // },
      // {
      //   label: 'Marital Status', //marital status
      //   key: 'maritalStatus',
      //   mandatory: false,
      //   display: true,
      // },
    ];


    // this.logger.log("exportas excel: setUplevelofCoverage: " + this.setUplevelofCoverage + " setupwallet: " + this.setupWallet)
    this.employeedata2 = [
      {
        label: 'Employee ID',
        header: 'Employee ID',
        key: 'employeeId',
        mandatory: true,
        display: true,
      },
      {
        label: 'First Name',
        header: 'First Name',
        key: 'firstName',
        mandatory: true,
        display: true,
      },
      {
        label: 'Last Name',
        header: 'Last Name',
        key: 'lastName',
        mandatory: true,
        display: true,
      },
      {
        label: 'Email',
        header: 'Email',
        key: 'email',
        mandatory: true,
        display: true,
      },
      // {
      //   label: 'Date of Hire',
      //   header: 'Date of Hire',
      //   key: 'dateOfHire',
      //   mandatory: false,
      //   display: true,
      //   style: { numFmt: 'mm-dd-yyyy' },
      // },
      // {
      //   label: 'Country',
      //   header: 'Country',
      //   key: 'country',
      //   mandatory: true,
      //   display: true,
      // },
      // {
      //   label: 'Province of Employment',
      //   header: 'Province of Employment',
      //   key: 'provinceOfEmployment',
      //   mandatory: false,
      //   display: true,
      // },
      // {
      //   label: 'Occupation', //job title
      //   header: 'Job Title',
      //   key: 'occupation',
      //   mandatory: true,
      //   display: true,
      // },
      // {
      //   label: 'Date of Birth',
      //   header: 'Date of Birth',
      //   key: 'dateOfBirth',
      //   mandatory: false,
      //   display: true,
      //   style: { numFmt: 'mm-dd-yyyy' },
      // },

      // {
      //   label: 'Gender',
      //   header: 'Gender',
      //   key: 'gender',
      //   mandatory: true,
      //   display: true,
      // },

      // {
      //   label: 'Family Status', //marital status
      //   header: 'Marital Status',
      //   key: 'maritalStatus',
      //   mandatory: false,
      //   display: true,
      // },
    ];

    if (this.setupWallet) {
      this.employeedata.push({
        label: 'Annual Income',
        key: 'annualIncome',
        mandatory: false,
        display: true,
      });
      this.employeedata2.push({

        label: 'Annual Income',
        header: 'Annual Income',
        key: 'annualIncome',
        mandatory: false,
        display: true,

      });
    }
    if (this.setUplevelofCoverage) {
      this.employeedata.push({
        label: 'Classification Tier',
        key: 'classificationTier',
        mandatory: false,
        display: true,
      });

      this.employeedata2.push({
        label: 'Classification Tier',
        header: 'Classification Tier',
        key: 'classificationTier',
        mandatory: false,
        display: true,
      });
    }

    var obj: any = {};
    for (let i = 0; i < this.employeedata.length; i++) {
      obj[this.employeedata[i].label] = '';
      this.excelempdata.push(obj);
    }

    var finalres = Object.values(
      this.excelempdata.reduce((c, e) => {
        if (!c[e.Gender]) c[e.Gender] = e;
        return c;
      }, {})
    );

    this.finalemployeekeys = finalres;
    this.logger.log("this.finalemployeekeys: " + this.finalemployeekeys);
    // let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.excelService.exportAsExcelFileBulkPlans(
      this.finalemployeekeys,
      this.employeedata2,
      'EmployeeData',
      this.setUplevelofCoverage,
      this.setupWallet,
      this.showEmployeeValue,
      this.selectedProvinceList
    );
  }

  onFileChangeExcel(ev: any) {
    this.logger.log("onFileChangeExcel: ")
    this.addemployeefrom = false;
    this.editemployeefrom = false;
    let workBook: any = null;
    let jsonData = [];
    const reader = new FileReader();

    const file = ev.target.files[0];
    reader.readAsArrayBuffer(file)
    reader.onload = async (event) => {
      const data = reader.result;
      this.logger.log("data: " + data)
      const wb = await this.excelService.readDataFromExcel(data);
      this.logger.log("wb: " + wb)
      const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
      this.logger.log(employeeSheet);
      // read first row as data keys
      if (employeeSheet) {
        let firstRow = employeeSheet.getRow(1);
        this.logger.log(firstRow)
        if (!firstRow.cellCount) return;
        let keys = firstRow.values;
        this.logger.log(keys)
        let ExceldataError = false
        let ExceldataErrorMessage = ''
        let ExceldataemailError = false
        let ExceldataEmailErrorMessage = ''
        let ExceldataFirstNameError = false
        let ExceldataFirstNameErrorMessage = ''
        let ExceldataLastNameError = false
        let ExceldataLastNameErrorMessage = ''
        employeeSheet.eachRow((row, rowNumber) => {
          if (rowNumber == 1) return;
          let values = row.values;
          if (values[1] == "" && values[2] == "" && values[3] == "" && values[4] == "" && values[5] == "") {
            return;
          }
          let obj = {};
          //@ts-ignore
          //@ts-ignore
          for (let i = 1; i < keys.length; i++) {
            if (ExceldataError) {
              break;
            }
            if (keys[i]) {
              let value = values[i]
              switch (keys[i]) {
                case "Employee ID": if (value && value != '') {
                  value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                };
                  break;
                case "First Name":
                  if (value && value != '') {
                    if (value.text && value.text.length) {
                      // value = value.text.charAt(0).toUpperCase() + value.text.slice(1);
                      value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                    }
                    else {
                      // value = value.charAt(0).toUpperCase() + value.slice(1);
                      value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                    }
                    if (value.length >= this.fnlnMinlengthForSheetNdinputField) {

                    }
                    else {
                      ExceldataFirstNameError = true
                      ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                      break;
                    }
                    if (this.commonMethods.isValidPattern(value, this.consts.fnlnFrenchAndEnglishRegx)) {
                      // if (/^(?!\\s)[A-Za-z\\s]+$/.test(value)) {
                      // Additional logic can be added here if needed
                    } else {
                      ExceldataFirstNameError = true;
                      ExceldataFirstNameErrorMessage = "First name Shouldn't allow numbers, special characters and blank spaces";
                      break;
                    }
                  }
                  else {
                    ExceldataError = true
                    ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
                    break;
                  }
                  break;
                case "Last Name":
                  if (value && value != '') {
                    if (value.text && value.text.length) {
                      // value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                    }
                    else {
                      // value = value.charAt(0).toUpperCase() + value.slice(1)
                      value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                    }
                    if (value.length >= this.fnlnMinlengthForSheetNdinputField) {

                    }
                    else {
                      ExceldataLastNameError = true
                      ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                      break;
                    }
                    // if (/^(?!\s)[A-Za-z-\s]+$/.test(value)) {
                    if (this.commonMethods.isValidPattern(value, this.consts.fnlnFrenchAndEnglishRegx)) {
                      // Additional logic can be added here if needed
                    } else {
                      ExceldataFirstNameError = true;
                      ExceldataFirstNameErrorMessage = "Last name Shouldn't allow numbers, special characters and blank spaces";
                      break;
                    }
                  }
                  else {
                    ExceldataError = true
                    ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
                    break;
                  }
                  break;

                case "Email":
                  if (value && value != '') {
                    // value=value.text
                    if (value.text && value.text.length) {
                      value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                    }
                    else {
                      value = value.charAt(0).toLowerCase() + value.slice(1)
                    }
                    var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!filter.test(value)) {
                      // alert('Please /provide a valid email address');

                      ExceldataemailError = true
                      ExceldataEmailErrorMessage = this.lang.Some_fields_have_invalid_email_please_check
                      break;
                    }

                  }
                  else {
                    ExceldataError = true
                    ExceldataErrorMessage = this.lang.Email_can_t_be_empty
                    break;
                  }

                  break;
                case "Date of Hire":
                  if (value && value != '') {
                    value = moments(value).format(this.dateFormat)
                  }
                  break;
                case "Date of Birth":
                  if (value && value != '') {
                    value = moments(value).format(this.dateFormat)
                  }
                  break;
                case "Country":
                  obj["country"] = 'Canada';
                  // if (value && value != '') {
                  // }
                  // else {
                  //   ExceldataError = true
                  //   ExceldataErrorMessage = "Country can't be empty"
                  //   break;
                  // }
                  break;
                case "Province of Employment":
                  if (value && value != '') {
                    this.logger.log("value: " + value)
                    this.logger.log("this.selectedProvinceList: " + JSON.stringify(this.selectedProvinceList))
                    const keyExists = this.selectedProvinceList.some(objs => objs['shortName'] === value);

                    if (keyExists) {

                    } else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Province_of_Employment_is_not_listed
                      break;
                    }
                  }
                  else {
                    ExceldataError = true
                    ExceldataErrorMessage = this.lang.Province_of_Employment_can_t_be_empty
                    break;
                  }
                  break;
                case "Classification Tier":
                  obj["classificationTier"] = this.gettierId(value)
                  break;
                case "Job Title":
                  if (value && value != '') {
                    if (value.text && value.text.length) {
                      // value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                    }
                    else {
                      value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
                      // value = value.charAt(0).toUpperCase() + value.slice(1)
                    }
                  }
              }
              obj[keys[i]] = value;
            }
          }
          jsonData.push(obj);
        });
        if (ExceldataError) {
          // Swal.fire(this.lang.Error??'Error',ExceldataErrorMessage)
          Swal.fire({ title: 'Info', text: ExceldataErrorMessage })
          jsonData = []
        }
        if (ExceldataemailError) {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: ExceldataEmailErrorMessage })
          jsonData = []
        }
        if (ExceldataFirstNameError) {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: ExceldataFirstNameErrorMessage })
          jsonData = []
        }
        if (ExceldataLastNameError) {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: ExceldataLastNameErrorMessage })
          jsonData = []
        }
        if (ExceldataError || ExceldataemailError || ExceldataFirstNameError || ExceldataLastNameError) {
          $('#uploadButton').val('');
        }
      } else {
        //tampered excel error
      }



      this.logger.log(jsonData);

      let uploadEmployeeData = jsonData;

      this.logger.log(uploadEmployeeData);
      // value = this.commonMethods.firstLetterCapitalizeForEachWord(value || "");
      uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
        // obj['employeeId'] = this.commonMethods.firstLetterCapitalizeForEachWord(obj['Employee ID']|| "");
        obj['employeeId'] = obj['Employee ID'];
        obj['firstName'] = obj['First Name'];
        obj['lastName'] = obj['Last Name'];
        obj['email'] = obj['Email'];
        obj['jobTitle'] = obj['Job Title'];
        obj['dateOfBirth'] = obj['Date of Birth'];
        obj['dateOfHire'] = obj['Date of Hire'];
        obj['gender'] = obj['Gender'];
        // obj['residentIn'] = obj['Resident in'];
        obj['country'] = obj['Country'];
        obj['province'] = obj['Province of Employment'];
        obj['maritalStatus'] = obj['Marital Status'];
        obj['phoneNum'] = obj['Phone'];
        obj['annualIncome'] = obj['Annual Income'];
        // obj['annualIncome'] = obj['Annaul Income'];
        obj['provinceName'] = obj['Province of Employment'];
        obj['classificationTier'] = obj['Classification Tier'];

        // obj['uId'] =0

        if (typeof obj.employeeId == 'number') {
          obj.employeeId = obj.employeeId.toString();
        }
        if (typeof obj.phoneNum == 'number') {
          obj.phoneNum = obj.phoneNum.toString();
        }
        if (obj.phoneNum == '') {
          obj.phoneNum = '';
        }
        if (obj.annualIncome == '') {
          obj.annualIncome = 0;
        }
        if (obj.classificationTier == '') {
          obj.classificationTier = 0; //assign default tier id
        }

        // obj.uId =0

        // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
        delete obj['Employee ID'];
        delete obj['First Name'];
        delete obj['Last Name'];
        delete obj['Email'];
        delete obj['Job Title'];
        delete obj['Date of Birth'];
        delete obj['Date of Hire'];
        delete obj['Gender'];
        //delete obj['Resident in'];
        delete obj['Country'];
        delete obj['Province of Employment'];
        delete obj['Marital Status'];
        delete obj['Phone'];
        delete obj['Annual Income'];
        // delete obj['Provience Name'];
        delete obj['Classification Tier'];
        delete obj['Provience Id'];
        // Assign new key

        return obj;
      });

      // assign province-id
      //asign tier-id

      this.logger.log("this.employeeList: " + JSON.stringify(this.employeeList));
      this.logger.log("this.uploadEmployeeData: " + JSON.stringify(uploadEmployeeData));
      if (this.employeeList.length > 0) {
        for (let i = 0; i < uploadEmployeeData.length; i++) {
          this.employeeList.push(uploadEmployeeData[i]);
        }
      } else {
        this.employeeList = uploadEmployeeData;
      }

      //original-employee-list

      //already-emp-cust-id?

      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i] && this.employeeList[i]['uId']) {

        }
        else {
          this.employeeList[i]['uId'] = 0
        }
        if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

        }
        else {
          this.employeeList[i]['phoneNum'] = ""
        }
      }

      this.lengthofemployee = this.employeeList.length;
      if (this.maxEmployeeCount && this.maxEmployeeCount.length > 0) {

      }
      else {
        // this.maxEmployeeCount = this.employeeList.length;
      }

      this.logger.log(this.employeeList);
    };
    this.myFileInput.nativeElement.value = '';
    // reader.readAsBinaryString(file);
  }

  //   onFileChangeExcelBulk(ev: any) {

  //     const file = ev.target.files[0];
  //     var fileExtension = '.' + ev.target.files[0].name.split('.').pop();


  //     var allowedMimes = [
  //       '.xlsx'
  //     ];

  //     let error = false;

  //     let message = '';

  //     if (allowedMimes.includes(fileExtension)) {
  //       let workBook: any = null;
  //       let jsonData = [];
  //       const reader = new FileReader();
  //       reader.readAsArrayBuffer(file)
  //       reader.onload = async (event) => {
  //         const data = reader.result;
  //         const wb = await this.excelService.readDataFromExcel(data);
  //         const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
  //         this.logger.log(employeeSheet);
  //         // read first row as data keys
  //         if (employeeSheet) {
  //           let firstRow = employeeSheet.getRow(1);
  //           this.logger.log(firstRow)
  //           if (!firstRow.cellCount) return;
  //           let keys = firstRow.values;
  //           this.logger.log(keys)
  //           let ExceldataError = false
  //           let ExceldataErrorMessage = ''
  //           let ExceldataemailError = false
  //           let ExceldataEmailErrorMessage = ''
  //           let ExceldataFirstNameError = false
  //           let ExceldataFirstNameErrorMessage = ''
  //           let ExceldataLastNameError = false
  //           let ExceldataLastNameErrorMessage = ''
  //           employeeSheet.eachRow((row, rowNumber) => {
  //             if (rowNumber == 1) return;
  //             let values = row.values;
  //             let obj = {};
  //             //@ts-ignore


  //             //@ts-ignore
  //             for (let i = 1; i < keys.length; i++) {
  //               if (ExceldataError) {
  //                 break;
  //               }
  //               if (keys[i]) {
  //                 let value = values[i]
  //                 // if(value==""){
  //                 //   this.myFileInput.nativeElement.value = '';

  //                 // }
  //                 switch (keys[i]) {
  //                   case "First Name":
  //                     if (value && value != '') {

  //                       if (value.text && value.text.length) {
  //                         value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                       }
  //                       else {
  //                         value = value.charAt(0).toUpperCase() + value.slice(1)
  //                       }
  //                       if (value.length >= 3) {

  //                       }
  //                       else {
  //                         ExceldataFirstNameError = true
  //                         ExceldataFirstNameErrorMessage = "First Name must be minimum of 3 characters, please check"
  //                         break;
  //                       }
  //                     }
  //                     else {

  //                       this.logger.log(value)
  //                       ExceldataError = true
  //                       ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
  //                       break;
  //                     }
  //                     break;
  //                   case "Last Name":
  //                     if (value && value != '') {

  //                       if (value.text && value.text.length) {
  //                         value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                       }
  //                       else {
  //                         value = value.charAt(0).toUpperCase() + value.slice(1)
  //                       }
  //                       if (value.length >= 3) {

  //                       }
  //                       else {
  //                         ExceldataLastNameError = true
  //                         ExceldataLastNameErrorMessage = "Last Name must be minimum of 3 characters, please check"
  //                         break;
  //                       }
  //                     }
  //                     else {
  //                       ExceldataError = true
  //                       ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
  //                       break;
  //                     }
  //                     break;

  //                   case "Email":
  //                     if (value && value != '') {
  //                       // value=value.text
  //                       if (value.text && value.text.length) {
  //                         value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
  //                       }
  //                       else {
  //                         value = value.charAt(0).toLowerCase() + value.slice(1)
  //                       }
  //                       // var filter = this.commonPatternsService.emailTestPattern;
  //                       // if (!filter.test(value)) {
  //                       //     // alert('Please /provide a valid email address');

  //                       //     ExceldataemailError =true
  //                       // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
  //                       // break;
  //                       // }

  //                     }
  //                     else {
  //                       ExceldataError = true
  //                       ExceldataErrorMessage = this.lang.Email_can_t_be_empty
  //                       break;
  //                     }


  //                     break;
  //                   case "Date of Hire":
  //                     if (value && value != '') {
  //                       value = moments(value).format(this.dateFormat)
  //                     }
  //                     break;
  //                   case "Date of Birth":
  //                     if (value && value != '') {
  //                       value = moments(value).format(this.dateFormat);
  //                       let today = moment(new Date());
  //                       let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

  //                       if (moment(value).isAfter(maxDAte)) {
  //                         ExceldataError = true;
  //                         ExceldataErrorMessage = "Age should not exceed 16 years";
  //                       }
  //                     }
  //                     break;

  //                   case "Country":
  //                     // if (value && value != '') {


  //                     // }
  //                     // else {
  //                     //   ExceldataError = true
  //                     //   ExceldataErrorMessage = "Country can't be empty"
  //                     //   break;
  //                     // }


  //                     break;
  //                   case "Province of Employment":

  //                     // if(value && value !=''){


  //                     //   }
  //                     //   else{
  //                     //     ExceldataError =true
  //                     //     ExceldataErrorMessage = "Province can't be empty"
  //                     //     break;
  //                     //   }
  //                     break;
  //                   case "Classification Tier":
  //                     // obj["classificationTier"] = this.gettierId(value)
  //                     break;
  //                   case "Job Title":
  //                     if (value && value != '') {

  //                       if (value.text && value.text.length) {
  //                         value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                       }
  //                       else {
  //                         value = value.charAt(0).toUpperCase() + value.slice(1)
  //                       }
  //                     }
  //                     break;
  //                 }

  //                 obj[keys[i]] = value;


  //               }

  //             }

  //             jsonData.push(obj);
  //           });
  //           if (ExceldataError) {

  //             Swal.fire({
  //               title: this.lang.Error
  //               , text: ExceldataErrorMessage
  //             }).then((result) => {
  //               /* Read more about isConfirmed, isDenied below */
  //               if (result.isConfirmed) {
  //                 this.myFileInput.nativeElement.value = '';
  //               }


  //             });
  //             jsonData = []
  //           }
  //           if (ExceldataemailError) {

  //             Swal.fire({
  //               title: this.lang.Error??'Error',
  //               text: ExceldataEmailErrorMessage
  //             }).then((result) => {
  //               if (result.isConfirmed) {
  //                 this.myFileInput.nativeElement.value = '';
  //               }

  //             });
  //             jsonData = []
  //           }
  //           if (ExceldataFirstNameError) {

  //             Swal.fire({
  //               title: this.lang.Error??'Error',
  //               text: ExceldataFirstNameErrorMessage
  //             }).then((result) => {
  //               if (result.isConfirmed) {
  //                 this.myFileInput.nativeElement.value = '';
  //               }


  //             });
  //             jsonData = []
  //           }
  //           if (ExceldataLastNameError) {

  //             Swal.fire({
  //               title: this.lang.Error??'Error',
  //               text: ExceldataLastNameErrorMessage
  //             }).then((result) => {
  //               if (result.isConfirmed) {
  //                 this.myFileInput.nativeElement.value = '';
  //               }
  //             })
  //             jsonData = []
  //           }
  //         } else {
  //           //tampered excel error
  //         }

  //         this.logger.log(jsonData);

  //         // jsonData.forEach((element: any) => {
  //         //   element["isBulk"]=true
  //         // })

  //         let uploadEmployeeData = jsonData;

  // this.multiSelectProviancenames.sort(function (a, b) {
  //         return (a.id - b.id);
  //       })

  //       let province = ""
  //       let provincearray = []

  //       this.multiSelectProviancenames.forEach(element => {
  //         provincearray.push(element.shortName)
  //       });


  //       if (this.multiSelectProviancenames.length == 1) {
  //         // for(let i=0;i<this.multiSelectProviancenames.length;i++){
  //         province = this.multiSelectProviancenames[0].shortName
  //         // }
  //       }
  //       else if (this.multiSelectProviancenames.length > 1) {
  //         if (provincearray.includes(this.province)) {
  //           province = this.province

  //         }
  //         else {
  //           if (provincearray.includes("ON")) {
  //             province = "ON"
  //           }
  //           else {
  //             province = this.multiSelectProviancenames[0].shortName
  //           }
  //         }

  //       }
  //         this.logger.log(this.uploadEmployeeExcelData)

  //         uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
  //           obj['employeeId'] = obj['Employee ID'];
  //           obj['firstName'] = obj['First Name'];
  //           obj['lastName'] = obj['Last Name'];
  //           obj['email'] = obj['Email'];
  //           obj['jobTitle'] = obj['Job Title'];
  //           obj['dateOfBirth'] = obj['Date of Birth'];
  //           obj['dateOfHire'] = obj['Date of Hire'];
  //           obj['gender'] = obj['Gender'];
  //           // obj['residentIn'] = obj['Resident in'];
  //           // obj['country'] = obj['Country'];
  //           obj['country'] = 'Canada'
  //           obj['province'] = obj['Province of Employment'];
  //           obj['maritalStatus'] = obj['Marital Status'];
  //           obj['phoneNum'] = obj['Phone'];
  //           obj['annualIncome'] = obj['Annual Income'];
  //           // obj['annualIncome'] = obj['Annaul Income'];
  //           // obj['provienceName'] = obj['Provience Name'];
  //           obj['classificationTier'] = obj['Classification Tier'];
  //           obj['isBulk'] = true;
  //           obj['uId'] = 0;


  //           if (typeof obj.employeeId == 'number') {
  //             obj.employeeId = obj.employeeId.toString();
  //           }
  //           if (typeof obj.phoneNum == 'number') {
  //             obj.phoneNum = obj.phoneNum.toString();
  //           }
  //           if (obj.phoneNum == '') {
  //             obj.phoneNum = '';
  //           }
  //           if (obj.annualIncome == '') {
  //             obj.annualIncome = 0;
  //           }
  //           if (obj.classificationTier == '' || obj.classificationTier == undefined || obj.classificationTier == "All") {
  //             obj.classificationTier = 0; //assign default tier id
  //           }

  //           // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
  //           delete obj['Employee ID'];
  //           delete obj['First Name'];
  //           delete obj['Last Name'];
  //           delete obj['Email'];
  //           delete obj['Job Title'];
  //           delete obj['Date of Birth'];
  //           delete obj['Date of Hire'];
  //           delete obj['Gender'];
  //           //delete obj['Resident in'];
  //           delete obj['Country'];
  //           delete obj['Province of Employment'];
  //           delete obj['Marital Status'];
  //           delete obj['Phone'];
  //           delete obj['Annual Income'];
  //           delete obj['Provience Name'];
  //           delete obj['Classification Tier'];
  //           delete obj['Provience Id'];
  //           // Assign new key
  //           return obj;

  //         });


  //         this.uploadEmployeeExcelData = uploadEmployeeData


  //         if (uploadEmployeeData.length > 0) {
  //           this.myFileInput.nativeElement.value = '';
  //         }


  //         // }
  //       };
  //     }
  //     else {
  //       error = true;

  //       message = 'Invalid file type. Only xlsx files are allowed.';
  //       // alert(message);
  //       Swal.fire({ title: 'Info', text: message });
  //     }


  //     // reader.readAsBinaryString(file);
  //   }

  onFileChangeExcelBulk(ev: any) {

    const file = ev.target.files[0];
    var fileExtension = '.' + ev.target.files[0].name.split('.').pop();


    var allowedMimes = [
      '.xlsx'
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(fileExtension)) {
      let workBook: any = null;
      let jsonData = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file)
      reader.onload = async (event) => {
        const data = reader.result;
        const wb = await this.excelService.readDataFromExcel(data);
        const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
        this.logger.log(employeeSheet);
        // read first row as data keys
        if (employeeSheet) {
          let firstRow = employeeSheet.getRow(1);
          this.logger.log(firstRow)
          if (!firstRow.cellCount) return;
          let keys = firstRow.values;
          this.logger.log(keys)
          let ExceldataError = false
          let ExceldataErrorMessage = ''
          let ExceldataemailError = false
          let ExceldataEmailErrorMessage = ''
          let ExceldataFirstNameError = false
          let ExceldataFirstNameErrorMessage = ''
          let ExceldataLastNameError = false
          let ExceldataLastNameErrorMessage = ''
          employeeSheet.eachRow((row, rowNumber) => {
            if (rowNumber == 1) return;
            let values = row.values;
            let obj = {};
            //@ts-ignore


            //@ts-ignore
            for (let i = 1; i < keys.length; i++) {
              if (ExceldataError) {
                break;
              }
              if (keys[i]) {
                let value = values[i]
                // if(value==""){
                //   this.myFileInput.nativeElement.value = '';

                // }
                switch (keys[i]) {
                  case "First Name":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      // if (value.length >= 3) {
                      if (value.length >= this.fnlnMinlengthForSheetNdinputField) {
                      }
                      else {
                        ExceldataFirstNameError = true
                        ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {

                      this.logger.log(value)
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
                      break;
                    }
                    break;
                  case "Last Name":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      // if (value.length >= 3) {

                      if (value.length >= this.fnlnMinlengthForSheetNdinputField) {

                      }
                      else {
                        ExceldataLastNameError = true
                        ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
                      break;
                    }
                    break;

                  case "Email":
                    if (value && value != '') {
                      // value=value.text
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toLowerCase() + value.slice(1)
                      }
                      // var filter = this.commonPatternsService.emailTestPattern;
                      // if (!filter.test(value)) {
                      //     // alert('Please /provide a valid email address');

                      //     ExceldataemailError =true
                      // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
                      // break;
                      // }

                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Email_can_t_be_empty
                      break;
                    }


                    break;
                  case "Date of Hire":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat)
                    }
                    break;
                  case "Date of Birth":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat);
                      let today = moment(new Date());
                      let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

                      if (moment(value).isAfter(maxDAte)) {
                        ExceldataError = true;
                        ExceldataErrorMessage = "Age must be greater than or equal to 16";
                      }
                    }
                    break;

                  case "Country":
                    // if (value && value != '') {


                    // }
                    // else {
                    //   ExceldataError = true
                    //   ExceldataErrorMessage = "Country can't be empty"
                    //   break;
                    // }


                    break;
                  case "Province of Employment":

                    // if(value && value !=''){


                    //   }
                    //   else{
                    //     ExceldataError =true
                    //     ExceldataErrorMessage = "Province can't be empty"
                    //     break;
                    //   }
                    break;
                  case "Classification Tier":
                    // obj["classificationTier"] = this.gettierId(value)
                    break;
                  case "Job Title":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                    }
                    break;
                }

                obj[keys[i]] = value;


              }

            }

            jsonData.push(obj);
          });
          if (ExceldataError) {

            Swal.fire({
              title: this.lang.Error
              , text: ExceldataErrorMessage
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataemailError) {

            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: ExceldataEmailErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }

            });
            jsonData = []
          }
          if (ExceldataFirstNameError) {

            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: ExceldataFirstNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataLastNameError) {

            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: ExceldataLastNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            })
            jsonData = []
          }
        } else {
          //tampered excel error
        }

        this.logger.log(jsonData);

        // jsonData.forEach((element: any) => {
        //   element["isBulk"]=true
        // })

        let uploadEmployeeData = jsonData;



        // this.showEmployeeValue = array.length+uploadEmployeeData.length
        // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

        //   Swal.fire({ title: 'Info', text: "Head count and upload Employee/Entity List not match." });
        //   this.myFileInput.nativeElement.value = '';

        // }
        // else {



        this.multiSelectProviancenames.sort(function (a, b) {
          return (a.id - b.id);
        })

        let province = ""
        let provincearray = []

        this.multiSelectProviancenames.forEach(element => {
          provincearray.push(element.shortName)
        });


        if (this.multiSelectProviancenames.length == 1) {
          // for(let i=0;i<this.multiSelectProviancenames.length;i++){
          province = this.multiSelectProviancenames[0].shortName
          // }
        }
        else if (this.multiSelectProviancenames.length > 1) {
          if (provincearray.includes(this.province)) {
            province = this.province

          }
          else {
            if (provincearray.includes("ON")) {
              province = "ON"
            }
            else {
              province = this.multiSelectProviancenames[0].shortName
            }
          }

        }

        uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
          obj['employeeId'] = obj['Employee ID'];
          obj['firstName'] = obj['First Name'];
          obj['lastName'] = obj['Last Name'];
          obj['email'] = obj['Email'];
          obj['jobTitle'] = obj['Job Title'];
          obj['dateOfBirth'] = obj['Date of Birth'];
          obj['dateOfHire'] = obj['Date of Hire'];
          obj['gender'] = obj['Gender'];
          // obj['residentIn'] = obj['Resident in'];
          // obj['country'] = obj['Country'];
          obj['country'] = 'Canada'
          // obj['province'] = obj['Province of Employment'];
          obj['province'] = province
          obj['maritalStatus'] = obj['Marital Status'];
          obj['phoneNum'] = obj['Phone'];
          obj['annualIncome'] = obj['Annual Income'];
          // obj['annualIncome'] = obj['Annaul Income'];
          // obj['provienceName'] = obj['Provience Name'];
          obj['classificationTier'] = obj['Classification Tier'];
          obj['isBulk'] = true;


          if (typeof obj.employeeId == 'number') {
            obj.employeeId = obj.employeeId.toString();
          }
          if (typeof obj.phoneNum == 'number') {
            obj.phoneNum = obj.phoneNum.toString();
          }
          if (obj.phoneNum == '') {
            obj.phoneNum = '';
          }
          if (obj.annualIncome == '') {
            obj.annualIncome = 0;
          }
          if (obj.classificationTier == '' || obj.classificationTier == undefined || obj.classificationTier == "All") {
            obj.classificationTier = 0; //assign default tier id
          }

          // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
          delete obj['Employee ID'];
          delete obj['First Name'];
          delete obj['Last Name'];
          delete obj['Email'];
          delete obj['Job Title'];
          delete obj['Date of Birth'];
          delete obj['Date of Hire'];
          delete obj['Gender'];
          //delete obj['Resident in'];
          delete obj['Country'];
          delete obj['Province of Employment'];
          delete obj['Marital Status'];
          delete obj['Phone'];
          delete obj['Annual Income'];
          delete obj['Provience Name'];
          delete obj['Classification Tier'];
          delete obj['Provience Id'];
          // Assign new key
          return obj;

        });
        this.uploadEmployeeExcelData = uploadEmployeeData
        this.fileName = file.name
        // assign province-id
        //asign tier-id

        this.logger.log(this.employeeList);

        let array = []
        let array1 = []
        if (this.employeeList.length > 0) {
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true) {
              array.push(this.employeeList[i]);
            } else {
              array1.push(this.employeeList[i]);
            }
          }

          if (array.length > 0) {
            Swal.fire({
              title: 'Info',
              html: '<div style="text-align: left;">' + this.lang.Do_you_want_to_replace_or_append_the_employee_list + ' <br> <div style="font-size: 10px;">' + this.lang.Replace_Existing_replaced_with_new_file + '<br>' + this.lang.Append_File_will_be_appended_to_the_existing_list + '</div></div>',
              showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: '#10104d',
              cancelButtonColor: '#10104d',
              denyButtonColor: '#10104d',
              confirmButtonText: this.lang.Append,
              denyButtonText: this.lang.Replace,
              customClass: {
                confirmButton: 'merge-button',
                denyButton: 'deny-button-custom-class'
              },
            }).then((result) => {
              if (result.isConfirmed) {
                this.viweUploadButtons = false

                this.logger.log(this.employeeList) //old

                this.logger.log(uploadEmployeeData) //new
                let checkExistingMail = true;
                //check if mail exists
                for (let i = 0; i < this.employeeList.length; i++) {
                  if (uploadEmployeeData.find(item => item.email === this.employeeList[i].email)) {
                    checkExistingMail = false
                    Swal.fire({
                      title: this.lang.Error ?? 'Error',
                      html: `<div>${this.employeeList[i].email} ` + this.lang.mail_already_exists_in_existing_file + `</div><div>` + this.lang.Please_modify_re_upload + `</div>`,
                      confirmButtonText: "Ok"
                    }).then((result) => {
                      if (result.isConfirmed) {
                        Swal.close();
                      }
                    });
                  }
                }

                if (checkExistingMail) {
                  let temparray = []
                  let uploadEmployeeDataIndex = []
                  let existingRemoveEmployeeDataIndex = []
                  temparray = this.employeeList
                  let existingEmails = this.employeeList.map(a => a.email);


                  for (let j = 0; j < uploadEmployeeData.length; j++) {
                    if (existingEmails.includes(uploadEmployeeData[j].email)) {
                      this.logger.log(existingEmails.indexOf(uploadEmployeeData[j].email))
                      this.logger.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
                      if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {
                        existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))
                      }
                      else {
                        temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
                      }
                    }
                    else {
                      temparray.push(uploadEmployeeData[j]);
                    }
                  }
                  this.logger.log(temparray)
                  let EmailError = []
                  if (existingRemoveEmployeeDataIndex.length > 0) {
                    for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
                      EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
                    }
                  }

                  this.logger.log(EmailError)
                  this.logger.log(temparray)

                  this.logger.log(this.employeeList)

                  this.employeeList = temparray
                  this.logger.log(this.employeeList)

                  let mergeArray = []
                  for (let i = 0; i < this.employeeList.length; i++) {
                    if (this.employeeList[i].isBulk == true) {
                      mergeArray.push(this.employeeList[i]);
                    }
                  }

                  this.showEmployeeValue = mergeArray.length

                  for (let i = 0; i < this.employeeList.length; i++) {
                    if (this.employeeList[i] && this.employeeList[i]['uId']) {

                    }
                    else {
                      this.employeeList[i]['uId'] = 0
                    }
                    if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

                    }
                    else {
                      this.employeeList[i]['phoneNum'] = ""
                    }
                  }

                  this.lengthofemployee = this.employeeList.length;
                  this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
                  if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                  }
                  else {
                    // this.maxEmployeeCount = this.employeeList.length;
                    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                    this.maxEmployeeCount = formData.expectednoofEmployees;
                  }


                  // this.addedEmployeelist = this.employeeList
                  // this.addedEmployeelist.forEach((element: any) => {
                  //   element["isBulk"] = true
                  // })
                  // this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
                  setTimeout(() => {
                    if (EmailError.length > 0) {
                      this.toastrService.warning(EmailError.toString() + " " + "Employees Not Added");

                    }

                  }, 1000);
                }
              }
              else if (result.isDenied) {
                this.viweUploadButtons = false
                this.deletedId = []
                for (let i = 0; i < uploadEmployeeData.length; i++) {
                  array1.push(uploadEmployeeData[i]);
                }

                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk == true) {
                    if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
                      this.deletedId.push(this.employeeList[i].uId);
                    }
                  }
                }
                // setTimeout(() => {
                //   this.deleteEmployee(array1);
                // }, 2000);
                this.employeeList = array1
                let mergeArray = []
                for (let i = 0; i < array1.length; i++) {
                  if (array1[i].isBulk == true) {
                    mergeArray.push(array1[i]);
                  }
                }
                this.showEmployeeValue = mergeArray.length
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);

              }
            });

          } else {
            for (let i = 0; i < uploadEmployeeData.length; i++) {
              this.employeeList.push(uploadEmployeeData[i]);
            }

            let mergeArray = []
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true) {
                mergeArray.push(this.employeeList[i]);
              }
            }

            this.showEmployeeValue = mergeArray.length

            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i] && this.employeeList[i]['uId']) {

              }
              else {
                this.employeeList[i]['uId'] = 0
              }
              if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

              }
              else {
                this.employeeList[i]['phoneNum'] = ""
              }
            }

            this.lengthofemployee = this.employeeList.length;

            if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

            }
            else {
              // this.maxEmployeeCount = this.employeeList.length;
              let formData = JSON.parse(sessionStorage.getItem('formData') || '');

              this.maxEmployeeCount = formData.expectednoofEmployees;
            }
            // this.addedEmployeelist = this.employeeList
            // this.addedEmployeelist.forEach((element: any) => {
            //   element["isBulk"] = true
            // })
            this.logger.log(this.employeeList);
            this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);


          }

        }
        else {
          this.employeeList = uploadEmployeeData;
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i] && this.employeeList[i]['uId']) {

            }
            else {
              this.employeeList[i]['uId'] = 0
            }
            if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

            }
            else {
              this.employeeList[i]['phoneNum'] = ""
            }
          }

          this.lengthofemployee = this.employeeList.length;

          this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);


          document.getElementById('showTableContent').innerHTML = `<div style= "display: flex;  gap: 10px; cursor: pointer"><div>${file.name}</div><div id="viewDataTable"><i class="bi bi-eye-fill"></i></div></div>`

          let tableHTML = '<table style = "width: 100%; border-collapse: collapse;font-size: 12px;"><tr style="background-color: #90A6C8; color: white;"><th style="border: 1px solid white;">Employee Id</th><th style="border: 1px solid white;">First Name</th><th style="border: 1px solid white;">Last Name</th><th style="border: 1px solid white;">Email</th></tr>';

          uploadEmployeeData.forEach(item => {
            tableHTML += `<tr><td style="border: 1px solid #ddd;">${item.employeeId}</td><td style="border: 1px solid #ddd;">${item.firstName}</td><td style="border: 1px solid #ddd;">${item.lastName}</td><td style="border: 1px solid #ddd;">${item.email}</td></tr>`;
          });

          tableHTML += '</table>';

          document.getElementById('viewDataTable').addEventListener('click', () => {
            Swal.fire({
              title: 'Table',
              html: tableHTML,
            });
          });

          // if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

          // }
          // else {
          //   // this.maxEmployeeCount = this.employeeList.length;
          //   let formData = JSON.parse(sessionStorage.getItem('formData') || '');

          //   this.maxEmployeeCount = formData.expectednoofEmployees;
          // }
          // this.addedEmployeelist = this.employeeList
          // this.addedEmployeelist.forEach((element: any) => {
          //   element["isBulk"] = true
          // })
          this.logger.log(this.employeeList);

        }

        //original-employee-list

        //already-emp-cust-id?


        if (this.employeeList.length > 0) {
          this.myFileInput.nativeElement.value = '';
        }


        // }
      };
    }
    else {
      error = true;

      message = 'Invalid file type. Only xlsx files are allowed.';
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
    }
    // }

    // reader.readAsBinaryString(file);
  }


  showUploadedData() {
    console.log('Parsed Data:', this.uploadEmployeeExcelData);
    let tableHTML = '<table style = "width: 100%; border-collapse: collapse;font-size: 12px;"><tr style="background-color: #90A6C8; color: white;"><th style="border: 1px solid white;">Employee Id</th><th style="border: 1px solid white;">First Name</th><th style="border: 1px solid white;">Last Name</th><th style="border: 1px solid white;">Email</th></tr>';

    this.uploadEmployeeExcelData.forEach(item => {
      tableHTML += `<tr><td style="border: 1px solid #ddd;">${item.employeeId}</td><td style="border: 1px solid #ddd;">${item.firstName}</td><td style="border: 1px solid #ddd;">${item.lastName}</td><td style="border: 1px solid #ddd;">${item.email}</td></tr>`;
    });

    tableHTML += '</table>';

    Swal.fire({
      title: 'Table',
      html: tableHTML,
    });
  }


  accordionClick(data) {
    this.logger.log(data)
  }


  stringCount(i) {
    let count = { 1: 'One', 2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five', 6: 'Six', 7: 'Seven', 8: 'Eight', 9: 'Nine', 10: 'Ten' }
    return count[i + 1]
  }

  deleteEmployee(data) {

    this.logger.log(data)

    let Obj = {
      employees: data || [],
      deletedIds: this.deletedId || [],
    };

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/cp/admin/v2/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminCorporates',{id:Number(this.corpId)}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })

            this.employeeList = response.data
          } else {
            Swal.fire({
              title: 'Error#' + response.errorCode,
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }


  headCountUpdate(event: any) {
    this.showEmployeeValue = event.target.value;

    if (this.headcountcheck == this.showEmployeeValue) {
      this.showupdatebutton = false;
    } else {
      this.showupdatebutton = true;
    }
  }


  editCorporate() {
    this.router.navigate([`/manageCorporates/edit-corporate/${this.corpId}`])
  }

  headCountUpdatewellness(event: any) {
    this.showEmployeeValue = event.target.value;
    if (this.headcountcheck == this.showEmployeeValue || this.showEmployeeValue < 0 || !this.showEmployeeValue) {
      this.showupdatebuttonwellness = false;
    } else {
      this.showupdatebuttonwellness = true;
    }
  }
  updatebulkInfo(bpplans: any) {
    this.logger.log("updatebulkInfo")
    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint =
      '/api/cp/admin/v2/corporate/' + corporateId + '/bulkPlanWithEmployees';

    let obj = {
      name: bpplans.planLevel,
      customerplanId: bpplans.id,
      quantity: +this.showEmployeeValue,
      subscriptionId: bpplans.subscriptionId + "",
      taxSubscriptionId: bpplans.taxSubscriptionId + "",
      deletedIds: [],
      employees: [],
    };
    this.http
      .put(environment.apiUrl + endPoint, obj, {
        headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            Swal.fire({ title: 'Info', text: response.message }).then(res => {
              if (res.isConfirmed) {
                window.location.reload()
              }
            })

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error });
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  updatebulkInfoWellness(bpplans: any) {

    this.logger.log("bpplans: " + bpplans)
    if (this.headcountcheck > this.showEmployeeValue) {
      this.selectedRow = []
      $('#deltebulkemployee-modal').show();
      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i].isBulk == true) {
          this.deleteBulkemployeelist.push(this.employeeList[i])
        }
      }
      this.deletebulkemployeecheck = bpplans
    }
    else {
      this.logger.log(bpplans)
      $('#deltebulkemployeeexcel-modal').show();
      this.deletebulkemployeecheck = bpplans
      this.logger.log("this.deletebulkemployeecheck: " + this.deletebulkemployeecheck)

      // addexcel
    }

  }
  toggleCheckbox(event: any, index: number, admin: any) {
    if (event.target.checked) {
      // Add the index to selectedRow
      this.selectedRow.push(admin.uId);
    } else {
      const indexToRemove = this.selectedRow.indexOf(admin.uId);
      if (indexToRemove !== -1) {
        this.selectedRow.splice(indexToRemove, 1);
      }
    }

    this.logger.log(this.selectedRow)
  }
  bulkPlansAPI() {
    var accessToken = sessionStorage.getItem('accessToken');
    var endPoint = '/api/cp/admin/corporate/' + this.corpId + '/bulkPlanSubscrption';
    this.http
      .post(environment.apiUrl + endPoint, {}, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
          'corpId': this.corpId,
        },
        // headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe((response: any) => {
        if (response.status == 200) {
        }
        else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
        }
      })
  }


  confirmSubmitDeleteEmployee() {
    $('#confirm-modal').show();
  }


  closeConfirmSubmitDeleteEmployee() {
    $('#confirm-modal').hide();
  }


  submitdeleteemployee() {
    if (this.headcountcheck - this.showEmployeeValue == this.selectedRow.length) {
      var accessToken = sessionStorage.getItem('accessToken');
      var corporateId = sessionStorage.getItem('corporateId');
      var endPoint =
        '/api/cp/admin/v2/corporate/' + corporateId + '/bulkPlanWithEmployees';
      let obj = {
        name: this.deletebulkemployeecheck.planLevel,
        customerplanId: this.deletebulkemployeecheck.id,
        quantity: +this.showEmployeeValue,
        subscriptionId: this.deletebulkemployeecheck.subscriptionId + "",
        taxSubscriptionId: this.deletebulkemployeecheck.taxSubscriptionId + "",
        deletedIds: this.selectedRow,
        employees: []
      };
      this.http
        .put(environment.apiUrl + endPoint, obj, {
          headers: this.commonApiAlgo.apiHeaders(),
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              this.logger.log("deleted success")
              $('#deltebulkemployee-modal').hide();
              $('#confirm-modal').hide();
              // window.location.reload();
              this.deleteBulkemployeelist = [];
              this.getDetails();
              this.logger.log("deleteBulkemployeelist: " + JSON.stringify(this.deleteBulkemployeelist))
              Swal.fire({ title: 'Info', text: this.lang.Employee_Count_updated_successfully, }).then(res => {
                if (res.isConfirmed) {
                  window.location.reload()
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message }).then(res => {
                if (res.isConfirmed) {
                  window.location.reload()
                }
              })
            }
          },
          (error) => {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error });
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );

    } else {
      Swal.fire({ title: 'Info', text: this.lang.Please_selected_employees_must_be + ` ${this.headcountcheck - this.showEmployeeValue}` });
    }
  }
  submituploademployeeData() {
    // if(this.showEmployeeValue==this.uploadEmployeeExcelData.length){
    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    for (let i = 0; i < this.uploadEmployeeExcelData.length; i++) {
      if (this.uploadEmployeeExcelData[i] && this.uploadEmployeeExcelData[i]['uId']) {

      }
      else {
        this.uploadEmployeeExcelData[i]['uId'] = 0
      }
    }

    var endPoint =
      '/api/cp/admin/v2/corporate/' + corporateId + '/bulkPlanWithEmployees';

    let obj = {
      name: this.deletebulkemployeecheck.planLevel,

      customerplanId: this.deletebulkemployeecheck.id,

      quantity: +this.showEmployeeValue,

      subscriptionId: this.deletebulkemployeecheck.subscriptionId + "",

      taxSubscriptionId: this.deletebulkemployeecheck.taxSubscriptionId + "",

      deletedIds: this.deletedId,

      employees: this.uploadEmployeeExcelData,
    };
    this.http
      .put(environment.apiUrl + endPoint, obj, {
        headers: this.commonApiAlgo.apiHeaders(),
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            $('#deltebulkemployee-modal').hide();
            $('#deltebulkemployeeexcel-modal').hide();
            Swal.fire({ title: 'Info', text: this.lang.Employee_count_updated_successfully_to + ` ${obj.quantity}.` }).then(res => {
              if (res.isConfirmed) {
                window.location.reload()
              }
            });

          } else {
            $('#deltebulkemployeeexcel-modal').hide();
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message }).then(res => {
              if (res.isConfirmed) {
                window.location.reload()
              }
            })
          }
        },
        (error) => {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error });
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
    // }
    //     else{
    //       this.logger.log(this.showEmployeeValue)
    //       this.logger.log(this.uploadEmployeeExcelData.length)
    //       Swal.fire({ title: 'Info', text: 'Please check head count and Employee/Entity list' });
    // this.uploadEmployeeExcelData =[]
    //     }





  }

  executeBlocks() {
    return new Promise((resolve, reject) => {
      // First block of code
      this.logger.log("Executing block 1");

      this.logger.log(this.bulkplans)

      if (this.bulkplans.length > 0) {
        for (let i = 0; i < this.bulkplans.length; i++) {

          setTimeout(() => {
            const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
            if (element != null)
              element.click()
            setTimeout(() => {
              this.showEmployeeValue = this.bulkplans[i].quantity
            }, 10);

            if (this.bulkplans[i].subscriptionId && this.bulkplans[i].status != "Draft") {
              $("#plancheckboxbulk19").prop("disabled", true);
              $("#plancheckboxbulk20").prop("disabled", true);
              $("#plancheckboxbulk21").prop("disabled", true);
              $("#plancheckboxbulk33").prop("disabled", true);

            }

            if (i === this.bulkplans.length - 1) {
              for (let i = 0; i < this.paidByCompany?.length; i++) {
                setTimeout(() => {
                  const element: any = $("#plancheck" + this.paidByCompany[i]?.planLevelId);
                  if (element != null)
                    element.click()
                  this.logger.log(`Block 1 - Task ${i + 1} completed`);
                  this.logger.log(i)
                  this.logger.log(this.paidByCompany?.length - 1)
                  if (i === this.paidByCompany?.length - 1) {
                    // Second block of code

                    this.logger.log("Executing block 2");


                    setTimeout(() => {
                      if (this.coveredByCompany?.length > 0) {
                        this.logger.log("cehckheree")
                        let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                        if (el1 != null) el1.click();
                        this.upgradeplansselection == true;

                        for (let j = 0; j < this.coveredByCompany?.length; j++) {
                          setTimeout(() => {
                            const element: any = $("#plancheck2" + this.coveredByCompany[j]?.planLevelId);
                            if (element != null) element.click();

                            this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(this.coveredByCompany[j]?.coverage)

                            if (
                              this.plancheck2Coverage
                            ) {
                              if (this.plancheck2Coverage.single) {
                                $("#executiveplansblock2single" + this.coveredByCompany[j]?.subGroupId).prop("checked", true);

                              } if (this.plancheck2Coverage.couple) {
                                $("#executiveplansblock2couple" + this.coveredByCompany[j]?.subGroupId).prop("checked", true);

                              } if (this.plancheck2Coverage.family) {
                                $("#executiveplansblock2family" + this.coveredByCompany[j]?.subGroupId).prop("checked", true);

                              }
                            }
                            this.logger.log(`Block 2 - Task ${j + 1} completed`);
                            if (j === this.coveredByCompany?.length - 1) {
                              // Third block of code
                              this.logger.log("Executing block 3");

                              setTimeout(() => {
                                if (this.paidByEmployee?.length > 0) {
                                  let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                                  if (el1 != null) el1.click();
                                  this.employeeplanpurchase == true
                                  for (let k = 0; k < this.paidByEmployee?.length; k++) {
                                    setTimeout(() => {
                                      const element: any = $("#plancheck3" + this.paidByEmployee[k]?.planLevelId);
                                      element.click()
                                      this.logger.log(`Block 3 - Task ${k + 1} completed`);
                                      if (k === this.paidByEmployee?.length - 1) {
                                        resolve("All blocks executed successfully");
                                      }
                                    }, 1500);
                                  }
                                }
                              }, 1000);

                            }
                          }, 1000);
                        }
                      }
                      if (this.coveredByCompany?.length == 0 && this.paidByEmployee?.length > 0) {
                        let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                        if (el1 != null) el1.click();
                        this.employeeplanpurchase == true
                        for (let k = 0; k < this.paidByEmployee?.length; k++) {
                          setTimeout(() => {
                            const element: any = $("#plancheck3" + this.paidByEmployee[k]?.planLevelId);
                            element.click()
                            this.logger.log(`Block 3 - Task ${k + 1} completed`);
                            if (k === this.paidByEmployee?.length - 1) {
                              resolve("All blocks executed successfully");
                            }
                          }, 1500);
                        }
                      }
                    }, 2000);





                  }
                }, 1000);
              }
            }
          }, 1000);
        }
      }
      else {
        for (let i = 0; i < this.paidByCompany?.length; i++) {
          setTimeout(() => {
            const element: any = $("#plancheck" + this.paidByCompany[i]?.planLevelId);
            if (element != null)
              element.click()
            this.logger.log(`Block 1 - Task ${i + 1} completed`);
            this.logger.log(i)
            this.logger.log(this.paidByCompany?.length - 1)
            if (i === this.paidByCompany?.length - 1) {
              // Second block of code

              this.logger.log("Executing block 2");


              setTimeout(() => {
                if (this.coveredByCompany?.length > 0) {
                  this.logger.log("cehckheree")
                  let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                  if (el1 != null) el1.click();
                  this.upgradeplansselection == true;

                  for (let j = 0; j < this.coveredByCompany?.length; j++) {
                    setTimeout(() => {
                      const element: any = $("#plancheck2" + this.coveredByCompany[j]?.planLevelId);
                      if (element != null) element.click();

                      this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(this.coveredByCompany[j]?.coverage)

                      if (
                        this.plancheck2Coverage
                      ) {
                        if (this.plancheck2Coverage.single) {
                          $("#executiveplansblock2single" + this.coveredByCompany[j]?.subGroupId).prop("checked", true);

                        } if (this.plancheck2Coverage.couple) {
                          $("#executiveplansblock2couple" + this.coveredByCompany[j]?.subGroupId).prop("checked", true);

                        } if (this.plancheck2Coverage.family) {
                          $("#executiveplansblock2family" + this.coveredByCompany[j]?.subGroupId).prop("checked", true);

                        }
                      }
                      this.logger.log(`Block 2 - Task ${j + 1} completed`);
                      if (j === this.coveredByCompany?.length - 1) {
                        // Third block of code
                        this.logger.log("Executing block 3");

                        setTimeout(() => {
                          if (this.paidByEmployee.length > 0) {
                            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                            if (el1 != null) el1.click();
                            this.employeeplanpurchase == true
                            for (let k = 0; k < this.paidByEmployee.length; k++) {
                              setTimeout(() => {
                                const element: any = $("#plancheck3" + this.paidByEmployee[k].planLevelId);
                                element.click()
                                this.logger.log(`Block 3 - Task ${k + 1} completed`);
                                if (k === this.paidByEmployee.length - 1) {
                                  resolve("All blocks executed successfully");
                                }
                              }, 1500);
                            }
                          }
                        }, 1000);

                      }
                    }, 1000);
                  }
                }
                if (this.coveredByCompany?.length == 0 && this.paidByEmployee?.length > 0) {
                  let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                  if (el1 != null) el1.click();
                  this.employeeplanpurchase == true
                  for (let k = 0; k < this.paidByEmployee?.length; k++) {
                    setTimeout(() => {
                      const element: any = $("#plancheck3" + this.paidByEmployee[k]?.planLevelId);
                      element.click()
                      this.logger.log(`Block 3 - Task ${k + 1} completed`);
                      if (k === this.paidByEmployee?.length - 1) {
                        resolve("All blocks executed successfully");
                      }
                    }, 1500);
                  }
                }
              }, 2000);





            }
          }, 1000);
        }
      }

    });
  }

  public getExecutiveCoveragesFromCode(code: string) {

    let coverage;

    if (code) {
      coverage = { single: false, couple: false, family: false }
      if (code[0] == '1') {
        coverage.family = true;
      }
      if (code[1] == '1') {
        coverage.couple = true;
      }
      if (code[2] == '1') {
        coverage.single = true;
      }
    } else {
      coverage = null
    }

    return coverage;

  }

  scrollToFirstInvalidControl1() {
    const firstInvalidControl: HTMLElement =
      this.elementRef.nativeElement.querySelector(
        'form .ng-untouched'
      );

    // this.logger.log(firstInvalidControl)
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }

  getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  async executeBlocks2() {
    try {
      // First block of code
      this.logger.log("Executing block 1");
      await this.block1();

      // Second block of code
      this.logger.log("Executing block 2");
      await this.block2();

      // Third block of code
      this.logger.log("Executing block 3");
      await this.block3();

      this.logger.log("All blocks executed successfully");
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  async block1() {
    return new Promise<void>((resolve, reject) => {
      // Simulating some asynchronous operation
      setTimeout(() => {
        if (this.paidByCompany.length > 0) {
          for (let i = 0; i < this.paidByCompany.length; i++) {
            const element: any = $("#plancheck" + this.paidByCompany[i].planLevelId);
            if (element != null)
              element.click()
          }

        }


        resolve();
      }, 1000);
    });
  }

  async block2() {
    return new Promise<void>((resolve, reject) => {
      // Simulating some asynchronous operation
      setTimeout(() => {
        if (this.coveredByCompany.length > 0) {
          let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
          if (el1 != null) el1.click();
          this.upgradeplansselection == true;

          setTimeout(() => {
            for (let i = 0; i < this.coveredByCompany.length; i++) {
              const element: any = $("#plancheck2" + this.coveredByCompany[i].planLevelId);
              if (element != null) element.click();
            }
          }, 1500);
        }
        resolve();
      }, 1000);
    });
  }

  async block3() {
    return new Promise<void>((resolve, reject) => {
      // Simulating some asynchronous operation
      setTimeout(() => {

        if (this.paidByEmployee.length > 0) {
          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
          if (el1 != null) el1.click();
          this.employeeplanpurchase == true
          // setTimeout(() => {
          for (let i = 0; i < this.paidByEmployee.length; i++) {
            const element: any = $("#plancheck3" + this.paidByEmployee[i].planLevelId);
            element.click()


          }
          // }, 1000);
        }
        resolve();
      }, 1000);
    });
  }
  updateAllStatus() {
    throw new Error('Method not implemented.');
  }
  assignAllplanLvelwithdisallowed(plansBlock1: any) {
    throw new Error('Method not implemented.');
  }
  assignAllplanLvelwithdisallowedTiers(plansBlock1Tiers: any) {
    throw new Error('Method not implemented.');
  }


  closedeleteemployee() {
    this.viweUploadButtons = true
    this.deleteBulkemployeelist = [];
    if (this.uploadEmployeeExcelData && this.uploadEmployeeExcelData.length > 0) {
      const emailsToFilter = this.uploadEmployeeExcelData.map(item => item.email);
      const filteredData = this.employeeList.filter(employee => !emailsToFilter.some(email => email === employee.email));
      this.employeeList = filteredData
    }
    $('#deltebulkemployee-modal').hide();
    $('#deltebulkemployeeexcel-modal').hide();
  }



  //Get TierID
  gettierId(value) {

  }


  alphaNumaricssWithHipen(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 45
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 32 ||
        charCode === 45
      )
        return true;
      else return false;
    }
  }


  async mergePDFs(urls: string[]) {
    // Create a new PDF document to merge into
    const mergedPdf = await PDFDocument.create();

    // Iterate through each URL and add its pages to the merged PDF
    for (let i=0; i<urls?.length; i++) {
      let url: any = urls[i];
      // Fetch PDF file from URL
      const pdfBytes = await fetch(url?.link ?? url).then(res => res.arrayBuffer());

      // Load PDF document
      const pdfDoc = await PDFDocument.load(pdfBytes);

      // Add pages from the PDF to the merged document
      const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
      copiedPages.forEach(page => mergedPdf.addPage(page));
    }

    // Save the merged PDF to a buffer
    // const mergedPdfBytes = await mergedPdf.save();

    this.memberhealthCardurl = await mergedPdf.save();
    // Display the merged PDF
    // Assuming you have a function to display the PDF in your modal popup
    // displayPdfInModal(mergedPdfBytes);
  }

  addEmail() {
    if (this.emailForm.valid) {
      const newEmail = this.emailForm.value.newEmail;

      const emails = this.inviteEmails.
        map(email => email.label).
        map(email => {
          const match = email.match(/\{([^}]+)\}/); // returns which is present in curly brackets
          return match ? match[1] : email;
        });

      // Check if the email already exists in the inviteEmails array
      const emailExists = emails.some(email => email.replace(/[{}]/g, '').trim() == newEmail);

      if (!emailExists) {
        this.inviteEmails.push({ label: `${newEmail}`, checked: true });
        this.emailForm.get('newEmail').setValue('');
      } else {
        Swal.fire({ title: 'Info', text: 'Email already present in the list above' });
      }
    } else {
      console.log('Form is invalid');
    }

    console.log(this.inviteEmails);
  }


  getSelectedEmails() {
    // return this.inviteEmails.filter(email => email.checked).map(email => email.label);
    return this.inviteEmails.
      filter(email => email.checked).
      map(email => email.label).
      map(email => {
        const match = email.match(/\{([^}]+)\}/); // returns which is present in curly brackets
        return match ? match[1] : email;
      });
  }

  getInviteEmails() {
    this.inviteEmails = []
    const accessToken = sessionStorage.getItem('accessToken')
    // const endPoint = environment.apiUrl+'/api/ap/corporate/'+this.fusebillCustomerId+'/contacts/list'
    const endPoint = environment.apiUrl + `/api/ap/admin/corporate/${this.corpId}/groupAdmins`
    this.http.get(endPoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
      }
    }).subscribe((response: any) => {
      console.log({ response })
      const checkboxes = response.data
      const checkboxesForMail = checkboxes.map((c: any, i: number) => {
        const obj = {
          label: `${c.roleNameDisplay == "Others" ? c.roleName.charAt(0).toUpperCase() + c.roleName.slice(1).toLowerCase() : c.roleNameDisplay.charAt(0).toUpperCase() + c.roleNameDisplay.slice(1).toLowerCase()} - ${c.firstName} ${c.lastName} {${c.email}}`,
          checked: false,
          id: c.groupAdminId
        }
        return obj
      }
      )
      this.inviteEmails = checkboxesForMail
    })
  }

  getConfigurationEmails(){
    let type='draft'
    this.configurationEmails = []
    const accessToken = sessionStorage.getItem('accessToken')
    // const endPoint = environment.apiUrl+'/api/ap/corporate/'+this.fusebillCustomerId+'/contacts/list'
    const endPoint = environment.apiUrl + `/api/ap/member/${this.customerid}/email-configurations/invoices`
    this.http.get(endPoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
      }
    }).subscribe((response: any) => {
      console.log({ response })
      const checkboxes = response.data
      const checkboxesForMail = checkboxes.map((c: any, i: number) => {
        const obj = {
          label: `${c.roleNameDisplay == "Others" ? c.roleName.charAt(0).toUpperCase() + c.roleName.slice(1).toLowerCase() : c.roleNameDisplay.charAt(0).toUpperCase() + c.roleNameDisplay.slice(1).toLowerCase()} - ${c.firstName} ${c.lastName} {${c.email}}`,
          checked: false,
          id: c.groupAdminId
        }
        return obj
      }
      )
      this.configurationEmails = checkboxesForMail
    })
  }

  

  paymentUpdationInvitationMail() {
    const obj = {
      emails: this.getSelectedEmails(),
      // emails:this.primaryEmail,
      paymentMethod: this.paymentMethod == 'CREDIT_CARD' ? 'CC' : this.paymentMethod == 'ACH' ? 'PAD' : ''
    }
    console.log({ obj })
    $('#emailConfirmationModal').modal('hide');
    let accessToken = sessionStorage.getItem('accessToken');
    // let inviteMail = `/api/ap/admin/v2/corporate/${this.fusebillCustomerId}/updatePaymentInfoMail`;
    let inviteMail = `/api/ap/admin/v2/corporate/${this.customerId}/updatePaymentInfoMail`;
    this.http.post(environment.apiUrl + inviteMail, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response['status'] == 200 || response['statusCode'] == 200) {
        Swal.fire({
          title: this.lang?.Info,
          text: this.lang?.Invitation_successfully_sent_to + " " + this.getSelectedEmails().join(', ')
        }).then((result) => { })
        this.emailForm.get('newEmail').setValue('');
        this.inviteEmails = []
      } else {
        Swal.fire({ title: this.lang?.Error, text: response.message })
      }
    }), (error) => {
      Swal.fire({ title: this.lang?.Error, text: error.error.error.message });
    }
  }

  updateExpiryStatus(cardExpiry) {
    // current date
    const currentDate = new Date();

    // split expiry month and year
    const expiryParts = cardExpiry.split('/');
    const expiryMonth = parseInt(expiryParts[0], 10);
    const expiryYear = parseInt('20' + expiryParts[1], 10);

    // get formated expiry date
    const expiryDate = new Date(expiryYear, expiryMonth - 1);

    // get the difference between current date and expiry date
    const monthDiff = (expiryDate.getFullYear() - currentDate.getFullYear()) * 12 + expiryDate.getMonth() - currentDate.getMonth();

    if (monthDiff <= 0) {
      // expired
      this.ccExpiryTitle = 'Expired'
      this.ccExpiryColor = 'red'
    } else if (monthDiff === 1) {
      // expires in 1 month
      this.ccExpiryTitle = 'Expires next month'
      this.ccExpiryColor = 'darkorange'
    } else if (monthDiff === 2) {
      // expires in 2 months
      this.ccExpiryTitle = 'Expires in couple of months'
      this.ccExpiryColor = 'orange'
    } else if (monthDiff === 3) {
      // expires in 3 months
      this.ccExpiryTitle = 'Expires in 3 months'
      this.ccExpiryColor = '#FFD700'
    } else if (monthDiff > 3) {
      // expires in more than 3 months
      this.ccExpiryTitle = ''
      this.ccExpiryColor = 'green'
    }
  }

  formatPrice(price: any): string {
    // Ensure the price is a number
    const num = parseFloat(price);
    
    if (isNaN(num)) {
        return '$0.00'; // Return default value in case of invalid input
    }
    
    // Format the price using NumberFormat for currency
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  filterInvoices() {
    console.log('Selected filter:', this.filterInvoice);
    console.log('customerFinalInvoices1:', this.customerFinalInvoices);

    if (this.filterInvoice === 'All') {
      this.customerFinalInvoices = this.allCustomerFinalInvoices
    } else {
      const selectedYear = this.filterInvoice;
      this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
        const dueDate = new Date(invoice.dueDate);
        return dueDate.getFullYear().toString() == selectedYear;
      });
    }

    console.log('Filtered invoices:', this.filteredInvoices);
  }

  onCustomClick(event: MouseEvent) {
    event.stopPropagation();
    this.filterInvoice = 'Custom';
  }

  CustomInvoiceFilter() {
    console.log('this.filterDateSelection', this.filterDateSelection);
    if (this.filterDateSelection) {
      this.updateCustomRange();
      // if (this.dropdown) {
      //   this.dropdown.hide();
      // }
    } else {
      console.log('No date selected');
    }
  }
  updateCustomRange() {
    const [startDate, endDate] = this.filterDateSelection.map(date => new Date(date));

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    if (isNaN(startDate) || isNaN(endDate)) {
      console.log('Invalid start or end date');
      return;
    }

    console.log('Custom date range:', startDate, 'to', endDate);

    // Filter invoices within the date range
    this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    $('#dropdownMenuButton').click()
  }

  getCoverage(coverage: any): string {
    if (coverage == '001') {
      return 'Single'
    } else if (coverage == '010') {
      return 'Couple'
    } else if (coverage == '100') {
      return 'Family'
    } else if (coverage == '111') {
      return 'All - Single, Couple, Family'
    } else {
      return ''
    }

  }

  reAuthorize() {
    const paymentDetails = this.corpDetails?.latestPaymentDetails;
    const payload = {
      customerProfileId: paymentDetails?.customerProfileId,
      paymentProfileId: paymentDetails?.paymentProfileId,
      amount: paymentDetails?.amount
    }
    console.log(payload);
    fetch(`${environment.authorizeApiUrl}/api/authorize-net/authorize`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
    })
    .then(async (res) => {
      if (!res.ok) {
        const reason = await res.text();
        console.error('Payment authorization failed:', reason);

        // Call backend to update status as failed
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Failed',
        }).subscribe();

        return;
      }

      const json = await res.json();

      // Update status as Authorized
      this.authorizeNetService.updatePaymentStatus({
        id: paymentDetails?.id,
        status: 'Authorized',
        authTransId: json.transactionId,
      }).subscribe();

      console.log('Payment authorized:', json);
    })
    .catch((err) => {
      console.error('Error during authorization:', err);

      this.authorizeNetService.updatePaymentStatus({
        id: paymentDetails?.id,
        status: 'Failed',
      }).subscribe();
    });

  }


  retryPayment() {
    const paymentDetails = this.corpDetails?.latestPaymentDetails;
    const today = new Date();
    const payload = {
      customerProfileId: paymentDetails?.customerProfileId,
      paymentProfileId: paymentDetails?.paymentProfileId,
      amount: paymentDetails?.amount
    }
    console.log(payload);
    fetch(`${environment.authorizeApiUrl}/api/authorize-net/charge-now`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
    })
    .then(async (res) => {
      if (!res.ok) {
        const reason = await res.text();
        console.error('Payment failed:', reason);

        // Call backend to update status as failed
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Failed',
          retryCount: (paymentDetails.retryCount ?? 0) + 1,
          lastRetryAttempt: today.toISOString(),
        }).subscribe();

        return;
      }

      const json = await res.json();

      // Update status as Authorized
      this.authorizeNetService.updatePaymentStatus({
        id: paymentDetails?.id,
        status: 'Captured',
        captureTransId: json.transactionId,
      }).subscribe();

      console.log('Payment Captured:', json);
    })
    .catch((err) => {
      console.error('Error during authorization:', err);

      this.authorizeNetService.updatePaymentStatus({
        id: paymentDetails?.id,
        status: 'Failed',
        retryCount: (paymentDetails.retryCount ?? 0) + 1,
        lastRetryAttempt: today.toISOString(),
      }).subscribe();
    });

  }

  get igbmsId(): string {
    return 'IGBMS_' + this.customerId + (
      this.paymentPlatform === 'Staxbill' 
      ? '-SB_' + (this.fusebillCustomerId??0) 
      : this.authorizenetCustomerId ? '-AN_' + (this.authorizenetCustomerId ?? 0) : '');
  }

  checkUserIsAnyWhere(email:any) {
  var accessToken = sessionStorage.getItem('accessToken');
      var endPoint = `/api/ap/admin/usage/email/${email}`;
      this.http
        .get(environment.apiUrl + endPoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'corpId': this.corpId,
          },
        })
        .subscribe((response: any) => {
          if (response.status == 200) {
            let contactData = response.contactData;
            if(contactData && contactData.length > 0){
              let existingBroker = contactData.find((item:any) => item.brokerId == this.corpId);
              if (existingBroker) {
                // Save existing broker details for later use
                this.existingBrokerDetails = existingBroker;
                  let primaryEmail:any = false;
                    let secondaryEmail:any = false;
                    if(email == existingBroker.primaryEmail){
                      primaryEmail = true;
                    }
                    if(email == existingBroker.secondaryEmail){
                      secondaryEmail = true;
                    }

                Swal.fire({
                  title: 'Info',
                  html: `Same email address already exists for this corporate (<strong>${existingBroker.broker}</strong>) as ${primaryEmail ? 'Primary Email' : 'Secondary Email'}. Do you want to update it?`,
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Call your API here

                    var endPoint2 = `/api/ap/admin/update-usage/email/${this.editadminemail}/${existingBroker.contactId}/${primaryEmail}/${secondaryEmail}`;
                    this.http
                      .get(environment.apiUrl + endPoint2, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'corpId': this.corpId,
                        },
                      })
                      .subscribe((response: any) => {
                        if (response.status == 200) {
                            Swal.fire({ title: 'Info', text: 'Contact Information updated successfully' }).then(res => {
                            if (res.isConfirmed) {
                              this.clickCount = 1
                              this.getcoverflow();
                              $("#basicModaledit").modal("hide");
                              console.log(this.emailUsingAnywhere)
                              this.getGroupContactList();
                            }
                          })
                        }
                      })
                  }
                  // No need to do anything if 'No' is clicked; modal will just close
                });
              }

            }
            return response;
          }
        })
  }
}


export function creditcardvalidation(control: AbstractControl) {
  var creditcardRegexp = /^[0-9 ]{19,19}$/;
  if (control.value && !creditcardRegexp.test(control.value)) {
    return { invalidcreditcarddetails: true };
  }
  return null;
}

export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}
